import { Component, OnInit, ViewChild } from '@angular/core';
import { Usuario } from '../../usuario';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { Cxctmptrnresumen } from '../../ven/veninterfaces/cxctmptrnresumen';
import { Cxctrnresumen } from '../../ven/veninterfaces/cxctrnresumen';
import { Comencdevfac } from '../../com/cominterfaces/comencdevfac';
import { Cxctrndebitobancario } from '../cxcinterfaces/cxctrndebitobancario';
import { Cxctrnretencion } from '../cxcinterfaces/cxctrnretencion';
import { Cxctrnotrosg } from '../cxcinterfaces/cxctrnotrosg';
import { Cxctrnformapago } from '../cxcinterfaces/cxctrnformapago';
import { Cxctrnanexos } from '../cxcinterfaces/cxctrnanexos';
import { Cxctrnvarios } from '../cxcinterfaces/cxctrnvarios';
import { Cxctrncobro } from '../cxcinterfaces/cxctrncobro';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { AggridBanComponent } from '../../ban/aggrid-ban/aggrid-ban.component';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { Cxctrnanticipos } from '../cxcinterfaces/cxctrnanticipos';
import { CxcTrncobro } from 'src/app/interfaces/cxctrncobro';
import { CxctrnabonoService } from '../cxcservicios/cxctrnabono.service'
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { SegMaeCompania } from '../../ven/veninterfaces/segmaecompania';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { DatePipe } from '@angular/common';
import { VenmaeclienteService } from '../../ven/venservicios/venmaecliente.service';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { UtilitariosService } from '../../advantage/advantageservices/utilitarios.service';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { isNullOrUndefined } from 'util';
@Component({
  selector: 'app-cxctrnabono',
  templateUrl: './cxctrnabono.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class CxctrnabonoComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  hmpConfiguracion: any[];
  indicador: any;
  numeroFactura: string;
  // barra
  btnGuardar: boolean;
  btnRegresar: boolean;
  btnBorrar: boolean;
  botonAnular: boolean;
  botonXML: boolean;
  botonReenviarCorreo: boolean;
  botonAsiento: boolean;
  botonPago: boolean;
  botonBuscar: boolean;
  botonVerAsiento: boolean;
  botonAnterior: boolean;
  botonPrimero: boolean;
  botonUltimo: boolean;
  botonSiguiente: boolean;
  barraBotones2: boolean;
  btnNuevo: boolean;
  // interfaces
  trnresumenSeleccionado: Cxctrnresumen;
  facturaPend: Cxctrnresumen;
  detalleRetencionSeleccionado: Cxctrnretencion;
  detalleVariosSeleccionado: Cxctrnvarios;
  detalleVariosSeleccionadoAux: Cxctrnvarios;
  detalleOtrasFSeleccionada: Cxctrnotrosg;
  detalleFormaPago: Cxctrnformapago;
  detalleFormaPagoDev: Cxctrnformapago;
  detalleRetencionSeleccionadoAux: Cxctrnretencion;
  detalleOtrasFSeleccionadaAux: Cxctrnotrosg;
  detalleFormaPagoAux: Cxctrnformapago;
  detalleFormaPagoDevAux: Cxctrnformapago;
  cxctmptrnresumen: Cxctmptrnresumen[];
  cxctrnresumen: Cxctrnresumen[];
  encabezadosCartera: Comencdevfac[];
  anexoSeleccionado: Cxctrnanexos;
  permisosCartera: SegMaePermiso;
  editpagofr = true;
  editConcil = true;
  displayDialogfrmcorreos: boolean;//CDPJ
  // aggrid
  rowSelection = 'multiple';
  public frameworkComponents;
  rowStyle;
  rowStyleEC;
  rowStyleSaldo;
  rowStyleECAnc;
  rowStyleFp;
  rowStyleFpdev;
  defaultColumnDefCarteraDoc;
  defaultColumnDefAbonoRet;
  defaultColumnDefAbonoOtrosG;
  defaultColumnDefAbonoFormaPago;
  defaultColumnDefCarteraFormaPagoDev;
  defaultColumnDefCarteraVarios;
  defaultColumnDefCarteraDebito;
  defaultColumnDefCarteraAnticipo;
  defaultColDefCxctmptrnresumen;
  defaultColDefCxctrnresumen;
  defaultColumnDefFacCanceladas;
  comboOpciones: any[];
  largo: string;
  largoRef: string;

  ecanticipo: any[];
  lblDocCierre = false;

  bolNuevo = false;
  listaDoc: CxcTrncobro[] = [];
  datosfe: SegMaeCompania = {};

  btneditConcil = true;
  // busqueda
  opcionbusqueda: string;
  types: SelectItem[];
  arregloCons: any[];
  arregloBus: any[];
  busquedacampos: string[];
  tabla: string;
  where: string;
  consulta: string;
  busquedaCompuesta: boolean;
  bolestcta: boolean;
  bolsaldo: boolean;
  opcion: string;
  // dialogs
  displayDialogDetFac: boolean;
  displayDialogPedidos: boolean;
  displayDialogAsiento: boolean;
  displayAsiContable: boolean;
  displayDialogSeriales: boolean;
  displayDialogDescuento: boolean;
  displayDialogBusquedaFast: boolean;
  displayDialogBus: boolean;
  displayDialogPago: boolean;
  dialogFacCanceladas: boolean;
  displayAcciones: boolean;
  displayLog: boolean;
  displayDialogReportes: boolean;
  claveDialog: boolean;
  spin = false;
  auxiliar: number;
  auxContEC: number;
  debeTotal: number;
  haberTotal: number;
  indiceTablas: number;
  totalimporte: number;
  totalpagado: number;
  totalsaldo: number;
  totalApagar: number;
  valorDscValor: number;
  valorDscPorcentaje: number;
  numdecsist: number;
  dscClienteActual: number;
  numeroActual: number;
  indice: number;
  i: number;
  activeIndex: number;
  indiceCliente: number;
  indiceDocRef: number;
  listaSaldos: any;
  itemTipoDoc: any;
  listaClientes: any[];
  listaReferencias: any[];
  numeracionActual: any;
  fechaEmision: any;
  fechaInicio: any;
  fechaFin: any;
  horaSistema: any;
  horaInicio: any;
  horaFin: any;
  listaprecios: any[];
  tabDocumentos: boolean;
  booleanAnulado: boolean;
  tabVarios: boolean;
  tabRetenciones: boolean;
  tabOtrosGastos: boolean;
  booleanNumero: boolean;
  tabFormaPago: boolean;
  tabFormaPagoDev: boolean;
  tabEstadoCuentaAnt: boolean;
  tabDebitoBancario: boolean;
  valorInvalidoV: boolean;
  saldoInicial: boolean;
  bolsaldoIni: boolean;
  valorInvalidoP: boolean;
  numeracionDialog: boolean;
  editarCeldas: boolean;
  booleanValor: boolean;
  booleanDatosPantalla: boolean;
  booleanPorcentaje: boolean;
  booleanRegimen: boolean;
  booleanParaiso: boolean;
  booleanRegimenP: boolean;
  booleanRefrendo: boolean;
  booleanImpuestoRenta: boolean;
  booleanBodega: boolean;
  btnNuevoGrid: boolean;
  btnGuardarGrid: boolean;
  btnBorrarGrid: boolean;
  btnCancelarGrid: boolean;
  btnVerificarExis: boolean;

  devboolean: boolean;
  impboolean: boolean;
  expboolean: boolean;
  otrosboolean: boolean;
  transboolean: boolean;
  cotizacionBoolean: boolean;
  porcIvaBoolean: boolean;
  retencionElect: boolean;
  bolnc: boolean;
  choosedColor: string;
  claveExportNuevo: string;
  tipodetalleactivo: string;
  botonFacNR: string;
  impresoString: string;
  grupo1: string;
  numSerie: string;
  nombrePaisSeleccionado: string;
  codigoPaisRegimen: string;
  codigoPaisParaiso: string;
  dscSeleccionado: string;
  asiento: string;

  claveAuth: string;
  saldoCliente: string;
  nombreProveedor: string;
  logResultado: string;
  accionClave: string;
  cobroCodigo: string;

  numDocRef: string;
  imagenProducto: string;
  estadoRef: string;
  largoestcta: string;
  choosedColorG: string;
  choosedColorSB: string;
  nombrebodega: string;
  codClienteFac: string;
  nombreClienteFac: string;
  nroFacCancelada: string;
  lblAplicaRegMicroempresas: string;
  tipodetalle = '';
  boltrnaextipcom: boolean;
  auxreporte: number = 0;
  strNombreForma: string;

  RESINFCC:number
  boolRESINFCC:boolean;
  arraybodporuser: any = []
  arrayvalbodper: any = []

  constructor(
    public cxctrnabonoService: CxctrnabonoService,
    private confIniciales: ConfInicialesService,
    private init: NuevoComponentService,
    private busquedaSer: InvbusquedaService,
    private datePipe: DatePipe,
    private message: MessageService,
    private cliService: VenmaeclienteService,
    public usuario: Usuario,
    private permisosService: PermisosService,
    private utilitariosService: UtilitariosService,
    private confirmationService: ConfirmationService,
    private auditoriagral: AuditoriagralService
  ) {
    this.agTable();

  }
  columnDefsCxctmptrnresumen = [
    {
      headerName: 'Fecha', field: 'TRNCOBRO_FECHATRN', width: 200
    },
    {
      headerName: 'Tipo', field: 'TRNCOBRO_TIPODOC', width: 100,
    },
    {
      headerName: 'Número', field: 'TRNCOBRO_NROCOMPROBANTE', width: 200
    },
    {
      headerName: 'Concepto', field: 'TRNCOBRO_CONCEPTO', width: 200
    },
    {
      headerName: 'Debe', field: 'DEBE', cellStyle: { textAlign: 'right' },
    },
    {
      headerName: 'Haber', field: 'HABER', cellStyle: { textAlign: 'right' },
    },
    {
      headerName: 'Saldo', field: 'SALDO', cellStyle: { textAlign: 'right' },
    },
  ];
  columnDefsCxctrnresumen = [
    {
      headerName: 'Fecha', field: 'TRNCOBRO_FECHATRN', width: 200
    },
    {
      headerName: 'Tipo', field: 'TRNCOBRO_TIPODOC'
    },
    {
      headerName: 'Número', field: 'TRNCOBRO_NROCOMPROBANTE', width: 200
    },
    {
      headerName: 'Fecha', field: 'TRNCOBRO_FECHAVENCE', width: 200
    },
    {
      headerName: 'Concepto', field: 'TRNCOBRO_CONCEPTO', width: 200
    },
    {
      headerName: 'Importe', field: 'TRNCOBRO_IMPORTE', cellStyle: { textAlign: 'right' },
    },
    {
      headerName: 'Pagado', field: 'PAGADO', cellStyle: { textAlign: 'right' },
    },
    {
      headerName: 'Saldo', field: 'SALDO', cellStyle: { textAlign: 'right' },
    },
  ];
  columDefCarteraDoc = [
    {
      headerName: 'S/N',
      field: 'SELECCIONADO',
      cellRendererFramework: AggridBanComponent,
      editable: (params) => {
        return false;
      },
      width: 50,
      onCellClicked: (params) => {
        this.docSeleccionado(params);
      }
    },
    {
      headerName: 'Nro. Documento', field: 'TRNCOBRO_NRODOC', cellEditor: 'cellPrueba', width: 180, editable: (params) => {
        const boolEdit = this.isEditFP(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 50,
          opcionbuscar: true
        }
      }
    },
    {
      headerName: 'Fecha', field: 'TRNCOBRO_FECHATRN', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        const boolEdit = this.isEditFP(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: true,
          tamanocelda: 32
        }
      }
    },
    {
      headerName: 'Fecha Vec.', field: 'TRNCOBRO_FECHAVENCE', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        const boolEdit = this.isEditFP(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: true,
          tamanocelda: 32,
        }
      }
    },
    {
      headerName: 'Concepto', field: 'TRNCOBRO_CONCEPTO', cellEditor: 'cellPrueba', width: 200, editable: (params) => {
        const boolEdit = this.isEditFP(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 200,
        }
      }
    },
    {
      headerName: 'Saldo', field: 'TRNCOBRO_SALDOINI', cellEditor: 'agSelectCellEditor', width: 100, cellStyle: { textAlign: 'right' }, editable: (params) => {
        const boolEdit = this.isEditFP(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Importe', field: 'TRNCOBRO_IMPORTE', cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'right' },
      editable: (params) => {
        const boolEdit = this.isEdit(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 0,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Vendedor', field: 'VEN_CODIGO', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        const boolEdit = this.isEditFP(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 5,
          tienecalculos: true,
          int: true
        }
      }
    }];
  columDefCarteraRetencion = [
    {
      headerName: 'Código', field: 'RETENCION_CODIGO', cellEditor: 'cellPrueba', width: 80, editable: (params) => {
        const boolEdit = this.isEdit(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 25,
          opcionbuscar: true
        }
      }
    },
    {
      headerName: 'Descripción', field: 'TRNRETENCION_DESCRIPCION', cellEditor: 'cellPrueba', width: 250, editable: (params) => {
        const boolEdit = this.isEdit(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 200
        }
      }
    },
    {
      headerName: 'Número', field: 'TRNRETENCION_NRO', cellEditor: 'cellPrueba', width: 150, editable: (params) => {
        const boolEdit = this.isEdit(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 15,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Base', field: 'TRNRETENCION_BASE', cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'right' }, editable: (params) => {
        const boolEdit = this.isEdit(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: '%', field: 'TRNRETENCION_PORCENTAJE', cellEditor: 'agSelectCellEditor', width: 80, cellStyle: { textAlign: 'right' }, editable: (params) => {
        const boolEdit = this.isEdit(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'T.Retenido', field: 'TRNRETENCION_TOTALRETENIDO', cellEditor: 'cellPrueba', width: 120, cellStyle: { textAlign: 'right' }, editable: (params) => {
        const boolEdit = this.isEdit(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    }];
  columDefCarteraOtrosG = [
    {
      headerName: 'Código', field: 'COMISION_CODIGO', cellEditor: 'cellPrueba', width: 80, editable: (params) => {
        const boolEdit = this.isEdit(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 25,
          opcionbuscar: true
        }
      }
    },
    {
      headerName: 'Descripción', field: 'TRNCOMISION_DESCRIPCION', cellEditor: 'cellPrueba', width: 250, editable: (params) => {
        const boolEdit = this.isEdit(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 200
        }
      }
    },
    {
      headerName: 'Número', field: 'TRNCOMISION_NRO', cellEditor: 'cellPrueba', width: 150, editable: (params) => {
        const boolEdit = this.isEdit(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 35,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Importe', field: 'TRNCOMISION_TOTALRETENIDO', cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'right' }, editable: (params) => {
        const boolEdit = this.isEdit(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 0,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true
        }
      }
    }];
  columDefCarteraFormaPago = [
    {
      headerName: 'Tipo', field: 'TRNPAGO_TIPO', cellEditor: 'cellPrueba', width: 80, editable: (params) => {
        const boolEdit = this.isEditFRmpago(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 4,
          opcionbuscar: true
        }
      }
    },
    {
      headerName: 'Código', field: 'CAJ_CODIGO', cellEditor: 'cellPrueba', width: 80, editable: (params) => {
        const boolEdit = this.idEditcajcodigoFormapago(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 35,
          opcionbuscar: true
        }
      }
    },
    {
      headerName: 'Número', field: 'TRNPAGO_NUMERO', cellEditor: 'cellPrueba', width: 80, editable: (params) => {
        const boolEdit = this.isEditFRmpago(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 45,
          opcionbuscar: true
        }
      }
    },
    {
      headerName: 'Fecha', field: 'TRNPAGO_FECHA', cellEditor: 'cellPrueba', width: 150, editable: (params) => {
        const boolEdit = this.isEditFRmpago(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: true,
          tamanocelda: 32,
          tienecalculos: true
        }
      }
    },
    {
      headerName: 'Ban', field: 'BANCLI_CODIGO', cellEditor: 'cellPrueba', width: 80, editable: (params) => {
        const boolEdit = this.isEditFRmpago(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 35,
          tienecalculos: true,
          int: true,
          opcionbuscar: true
        }
      }
    },
    {
      headerName: 'Nombre', field: 'BANCLI_NOMBRE', cellEditor: 'cellPrueba', width: 200, editable: (params) => {
        const boolEdit = this.isEditFRmpago(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 100,
          tienecalculos: true
        }
      }
    },
    {
      headerName: 'Número Cuenta', field: 'TRNPAGO_NROCTA', cellEditor: 'cellPrueba', width: 100,
      editable: p => {
        return (p.data.TRNPAGO_TIPO === 'TA' || p.data.TRNPAGO_TIPO === 'CH') && p.data.TRNPAGO_ORIGEN ==='CXC';
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 25,
          tienecalculos: true
        }
      }
    },
    {
      headerName: 'Concepto', field: 'TRNPAGO_CONCEPTO', cellEditor: 'cellPrueba', width: 150, editable: (params) => {
        const boolEdit = this.isEditFRmpago(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 1000,
          tienecalculos: true
        }
      }
    },
    {
      headerName: 'Importe', field: 'TRNPAGO_IMPORTE', cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'right' }, editable: (params) => {
        const boolEdit = this.isEdit(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true
        }
      }
    },
    {
      headerName: 'C.Sri', field: 'TRNPAGO_CODSRI', cellEditor: 'cellPrueba', width: 80, editable: (params) => {
        const boolEdit = this.isEdit(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 2,
          tienecalculos: true
        }
      }
    },
    {
      headerName: 'Disp.', field: 'TRNPAGO_TIPDIS', cellEditor: 'cellPrueba', width: 80, editable: (params) => {
        const boolEdit = this.isEdit(params.data);
        return boolEdit;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 0,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 4,
          tienecalculos: true
        }
      }
    }];
    columDefFacCanceladas = [
      {
        headerName: 'Nro. Documento', field: 'TRNDOCUMENTO_NRODOC', width: 150, editable: false
      },
      {
        headerName: 'Nro. Comprobante', field: 'TRNCOBRO_NROCOMPROBANTE', editable: false
      },
      {
        headerName: 'Fecha', field: 'TRNCOBRO_FECHATRN', editable: false
      },
      {
        headerName: 'Importe Cancelado', field: 'TRNDOCUMENTO_IMPORTE', editable: false, cellStyle: { textAlign: 'right' },
      },
      {
        headerName: 'Cod. Cliente', field: 'CLI_CODIGO', editable: false
      }];
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.data.APLORG_CODIGO === 'SISTEMA' &&
        params.data.TRNCOBRO_CONCEPTO.includes('CUOTA')) {
        return { background: 'rgb(255, 255, 170)' };
      }

      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }

      if ((params.data.TRNCOBRO_FECHATRN === '' || params.data.TRNCOBRO_FECHATRN === null) &&
        (this.activeIndex === 1 || this.activeIndex === 2)) {
        return { background: '#AAFF00' };
      }
      /*if (params.data.TRNCOBRO_NRODOC === '' && this.activeIndex === 1) {
        return {background: '#AAFF00'};
      }*/
      /*if (params.data.APLORG_CODIGO === 'SISTEMA') {
        return {background: '#AAFF00'};
      }*/

    };

    this.rowStyleEC = (params) => {
      if (params.data.TRNCOBRO_TIPO !== 'A') {
        if (params.data.TRNCOBRO_FECHATRN === '') {
          return { background: 'rgb( 255, 255, 170)' };
        } else {
          return { background: 'rgb( 196, 225, 255)' };
        }
      }
    };

    this.rowStyleSaldo = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
      if (params.data.TRNCOBRO_FECHATRN === '') {
        return { background: 'rgb( 255, 255, 170)' };
      }
    };

    this.rowStyleECAnc = (params) => {
      if (params.data.TRNPAGO_FECHA === '') {
        return { background: 'rgb( 255, 255, 170)' };
      } else {
        return { background: 'rgb( 196, 225, 255)' };
      }
    };

    this.rowStyleFp = (params) => {
      if (params.data.APLORG_CODIGO === 'SISTEMA' &&
        params.data.TRNCOBRO_CONCEPTO.includes('CUOTA')) {
        return { background: 'rgb(255, 255, 170)' };
      }
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
      if ((params.data.TRNCOBRO_FECHATRN === '' || params.data.TRNCOBRO_FECHATRN === null) &&
        (this.activeIndex === 1 || this.activeIndex === 2)) {
        return { background: '#AAFF00' };
      }
      if (params.data.COLORDOCDEP === true) {
        return { background: 'rgb(255, 207, 185)' };
      }
      if (params.data.COLORDOCCONC === true) {
        return { background: 'rgb(135, 234, 130)' };
      }
    };

    this.rowStyleFpdev = (params) => {
      if (params.data.APLORG_CODIGO === 'SISTEMA' &&
        params.data.TRNCOBRO_CONCEPTO.includes('CUOTA')) {
        return { background: 'rgb(255, 255, 170)' };
      }
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
      if ((params.data.TRNCOBRO_FECHATRN === '' || params.data.TRNCOBRO_FECHATRN === null) &&
        (this.activeIndex === 1 || this.activeIndex === 2)) {
        return { background: '#AAFF00' };
      }
      if (params.data.COLORDOCDEP === true) {
        return { background: 'rgb(255, 207, 185)' };
      }
      if (params.data.COLORDOCCONC === true) {
        return { background: 'rgb(135, 234, 130)' };
      }
    };

    this.defaultColumnDefCarteraDoc = {
      editable: true,
      width: 100,
      objeto: 'cxctrnabonodocumentos'
    };
    this.defaultColumnDefAbonoRet = {
      editable: true,
      width: 100,
      objeto: 'cxctrnabonoretenciones'
    };
    this.defaultColumnDefAbonoOtrosG = {
      editable: true,
      width: 100,
      objeto: 'cxctrnabonootrosgastos'
    };
    this.defaultColumnDefAbonoFormaPago = {
      editable: true,
      width: 100,
      objeto: 'cxctrnabonoformapago'
    };
    this.defaultColumnDefCarteraFormaPagoDev = {
      editable: true,
      width: 100,
      objeto: 'cxcformapagodev'
    };
    this.defaultColumnDefCarteraVarios = {
      editable: true,
      width: 100,
      objeto: 'cxcvarios'
    };
    this.defaultColumnDefCarteraDebito = {
      editable: true,
      width: 100,
      objeto: 'cxcdepositoban'
    };
    this.defaultColumnDefCarteraAnticipo = {
      editable: true,
      width: 100,
      objeto: 'cxcanticipo'
    };
    this.defaultColDefCxctmptrnresumen = {
      editable: false,
      width: 100,
      objeto: 'cxctmptrnresumen'
    };

    this.defaultColDefCxctrnresumen = {
      editable: false,
      width: 100,
      objeto: 'cxctrnresumen'
    };
    this.defaultColumnDefFacCanceladas = {
      editable: true,
      width: 100,
      objeto: 'cxcfacCanceladas'
    };
  }
  ngOnInit() {
    this.indiceTablas = 0;
    this.usuario.loadStorage();
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador] = {};
    this.detalleRetencionSeleccionado = {};
    this.detalleVariosSeleccionado = {};
    this.detalleRetencionSeleccionadoAux = {};
    this.detalleOtrasFSeleccionada = {}
    this.detalleOtrasFSeleccionadaAux = {};
    this.cxctrnabonoService.cxctrnresumenarray[this.indicador] = [];
    this.cxctrnabonoService.cxctrnretencionarray[this.indicador] = [];
    this.cxctrnabonoService.cxctrnvariosarray[this.indicador] = [];
    this.cxctrnabonoService.cxctrnformapagoarray[this.indicador] = [];
    this.cxctrnabonoService.cxctrnotrosgarray[this.indicador] = [];
    this.cxctrnabonoService.cxcdebitobancarioarray[this.indicador] = [];
    this.cxctrnabonoService.cxctrnanticiposarray[this.indicador] = [];
    this.cxctrnabonoService.cxctrnformapagodevarray[this.indicador] = [];
    this.tipodetalleactivo = 'all';
    this.booleanNumero = true;
    this.tabDocumentos = true;
    this.tabFormaPago = true;
    this.booleanAnulado = false;
    this.tabOtrosGastos = true;
    this.tabRetenciones = true;
    this.busquedaCompuesta = false;
    this.activeIndex = 0;
    this.largo = '630';
    this.largoestcta = '420';
    this.permisosService.getListaPermisos('CXC', '8', '1041').subscribe((permiso) => {
      this.permisosCartera = permiso[0];
    });
    this.auditoriagral.obtenerConfiguracion1().subscribe(async (conf) => {
      this.hmpConfiguracion = conf;
      this.cxctrnabonoService.hmpConfiguracion=this.hmpConfiguracion
      this.RESINFCC = this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'RESINFCC').CFG_VALOR1;
      if (this.RESINFCC === 1) {
        const RESINFCC = await this.utilitariosService.getbodporuser(this.cxctrnabonoService.usuario.identificacion);
        const valboduser = await this.utilitariosService.getvalbodporuser(this.cxctrnabonoService.usuario.identificacion);
        if (RESINFCC !== false && isNullOrUndefined(RESINFCC) === false) {
          this.arraybodporuser = RESINFCC
        } else {
          this.arraybodporuser = [{ 'BOD_CODIGO': '' }]
        }
        if (valboduser !== false && isNullOrUndefined(valboduser) === false) {

          this.arrayvalbodper = valboduser
        } else {
          this.arrayvalbodper = []
        }
        this.boolRESINFCC=true;
      }else{
        this.boolRESINFCC=false;
      }
    });
    this.choosedColorG = '#804000';
    this.choosedColorSB = '#00FF00';
    this.choosedColor = '#AAFF00';
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
    this.botonAnular = false;
    this.botonXML = true;
    this.botonReenviarCorreo = true;
    this.botonAsiento = false;
    this.botonVerAsiento = false;
    this.botonBuscar = false;
    this.editarCeldas = false;
    this.cxctrnabonoService.getListaClientes().subscribe((resCli) => {
      this.listaClientes = resCli;
    });
    this.botonPago = false;
    this.cxctrnabonoService.leerConfiguracionDatosElectronicos().subscribe(data => {
      for (const rs of data) {
        this.datosfe = rs;
      }
    });
  }
  ngOnDestroy(): void {
    this.confIniciales.instanciasTrnabono--;
  }
  async manejarSenales(valor) {
    if (valor !== 'Nuevo' && valor !== 'Cancelar'
      && valor !== 'Primero' && valor !== 'Anterior' && valor !== 'Siguiente' && valor !== 'Ultimo'
      && valor !== 'Buscar' && valor !== 'Imprimir' && valor !== 'AsientoVer' && valor !== 'Salir'
      && valor !== 'facturasAbonadas') {
      let dia = new Date().getDate();
      let mes = new Date().getMonth();
      let anio = new Date().getFullYear();
      try {
        // Verifica el periodo contable
        dia = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN === undefined ? dia : this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN.getDate();
        mes = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN === undefined ? mes : this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN.getMonth();
        anio = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN === undefined ? anio : this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN.getFullYear();
      } catch {
        const tmpfecha = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN.substr(0, 10);
        console.log(tmpfecha);
        const splfec = tmpfecha.split('/');
        const fecha = new Date(splfec[2], splfec[1] - 1, splfec[0]);
        dia = fecha.getDate();
        mes = fecha.getMonth();
        anio = fecha.getFullYear();
      }

      if (await this.utilitariosService.verificarPeriodoContable(dia, mes, anio) === false) {
        this.message.add({
          key: 'cxctrnabono',
          severity: 'info',
          summary: 'Información',
          detail: 'Error, fecha debe de estar dentro del período contable'
        });
        return;
      }
    }
    this.displayAcciones = false;
    const RESINFCC = await this.utilitariosService.getbodporuser(this.cxctrnabonoService.usuario.identificacion);
    const elemento = document.getElementsByClassName('layout-config');
    for (let i = 1; i <= elemento.length; i++) {
      elemento[i - 1].className = 'layout-config';
    }
    if (RESINFCC !== false && isNullOrUndefined(RESINFCC) === false) {
      this.arraybodporuser=RESINFCC
    }else{
      this.arraybodporuser=[{'BOD_CODIGO':''}]
    }
    if (valor === 'Primero') {
      this.primero();
    } else if (valor === 'Siguiente') {
      this.siguiente();
    } else if (valor === 'Anterior') {
      this.anterior();
    } else if (valor === 'Ultimo') {
      this.ultimo();
    } else if (valor === 'Nuevo') {
      // if ((RESINFCC === false || isNullOrUndefined(RESINFCC)) && this.RESINFCC === 1 ) {
      //   this.message.add({
      //     key: 'cxctrnabono',
      //     severity: 'info',
      //     summary: 'Información',
      //     detail: 'El usuario '+this.cxctrnabonoService.usuario.identificacion+', no tiene parametrizada una bodega, '+
      //     'comuniquese con gerencia por favor.'
      //   });
      //   return;
      // }
      this.nuevo();
    } else if (valor === 'Borrar') {
      let cencodigo=this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CEN_CODIGO
      if (this.RESINFCC === 1 && Object.entries(this.arrayvalbodper).length === 0) {
        this.message.add({
          key: 'cxctrnabono',
          severity: 'warn',
          summary: 'Información',
          detail: 'No tiene permiso para eliminar ningún documento'
        });
       
        return;
      }
      if (this.RESINFCC === 1 && Object.entries(this.arrayvalbodper).length > 0) {
        const bodpermitidas = this.arrayvalbodper.USU_BODPER.split(';')
        const tieneacceso = bodpermitidas.includes(cencodigo);
        if (this.RESINFCC === 1 && !tieneacceso) {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'warn',
            summary: 'Información',
            detail: 'No puede eliminar documentos que no pertenezcan a su bodega parametrizada.'
          });         
          return;
        }
      }
      // if (this.RESINFCC === 1 && this.arraybodporuser['BOD_CODIGO'] !== cencodigo) {
      //   this.message.add({
      //     key: 'cxctrnabono',
      //     severity: 'warn',
      //     summary: 'Información',
      //     detail: 'No puede eliminar documentos que no pertenezcan a su bodega parametrizada.'
      //   });
      //   return;
      // }
      this.borrar();
    } else if (valor === 'Guardar') {
      // this.guardarNew();
      let cencodigo = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CEN_CODIGO
        if (this.RESINFCC === 1 && Object.entries(this.arrayvalbodper).length === 0) {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'warn',
            summary: 'Información',
            detail: 'No tiene permiso para editar ningún documento'
          });
         
          return;
        }
        if (this.RESINFCC === 1 && Object.entries(this.arrayvalbodper).length > 0) {
          const bodpermitidas = this.arrayvalbodper.USU_BODPER.split(';')
          const tieneacceso = bodpermitidas.includes(cencodigo);
          if (this.RESINFCC === 1 && !tieneacceso) {
            this.message.add({
              key: 'cxctrnabono',
              severity: 'warn',
              summary: 'Información',
              detail: 'No puede guardar documentos que no pertenezcan a sus bodegas parametrizadas.'
            });
            
            return;
          }
        }
      this.guardar();
    } else if (valor === 'Cancelar') {
      this.cancelarEdicionCartera();
    } else if (valor === 'Anular') {
      let cencodigo=this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CEN_CODIGO
      if (this.RESINFCC === 1 && Object.entries(this.arrayvalbodper).length === 0) {
        this.message.add({
          key: 'cxctrnabono',
          severity: 'warn',
          summary: 'Información',
          detail: 'No tiene permiso para anular ningún documento'
        });
       
        return;
      }
      if (this.RESINFCC === 1 && Object.entries(this.arrayvalbodper).length > 0) {
        const bodpermitidas = this.arrayvalbodper.USU_BODPER.split(';')
        const tieneacceso = bodpermitidas.includes(cencodigo);
        if (this.RESINFCC === 1 && !tieneacceso) {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'warn',
            summary: 'Información',
            detail: 'No puede anular documentos que no pertenezcan a su bodega parametrizada.'
          });

          return;
        }
      }
      // if (this.RESINFCC === 1 && this.arraybodporuser['BOD_CODIGO'] !== cencodigo) {
      //   this.message.add({
      //     key: 'cxctrnabono',
      //     severity: 'warn',
      //     summary: 'Información',
      //     detail: 'No puede anular documentos que no pertenezcan a su bodega parametrizada.'
      //   });
      //   return;
      // }
      this.abrirClave('clave');
    } else if (valor === 'Buscar') {
      this.buscarCartera();
    } else if (valor === 'Asiento') {
      this.generarasiento();
    } else if (valor === 'AsientoVer') {
      this.asientover();
    } //else if (valor === 'Firmar') {
    //   this.insertarEleTrnDoc();
    // } 
    else if (valor === 'EnviarCorreo') {
      //this.reenviarCorreo();
    } else if (valor === 'facturasAbonadas') {
      this.abrirFacturasAbonadas();
    }

    if (valor === 'Imprimir') {
      this.strNombreForma = this.init.tabs[this.init.tabindex].component;
      this.auxreporte++;
      this.displayDialogReportes = true;
    }
    //CDPJ
    if (valor === 'FormularioCorreos') {
      this.strNombreForma = this.init.tabs[this.init.tabindex].component;
      this.auxreporte++;
      this.displayDialogfrmcorreos = true
    }
    //CDPJ
    if (valor === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
  }
  consultarPosicionCliente(valor) {
    if (valor === 'P') {
      this.indiceCliente = 0;
    } else if (valor === 'S') {
      if (this.indiceCliente < this.listaClientes.length - 1) {
        this.indiceCliente++;
      } else {
        this.indiceCliente = this.listaClientes.length - 1;
        valor = 'U';
      }
    } else if (valor === 'A') {
      if (this.indiceCliente > 0) {
        this.indiceCliente--;
      } else {
        this.indiceCliente = 0;
        valor = 'P';
      }
    } else if (valor === 'U') {
      this.indiceCliente = this.listaClientes.length - 1;
    }
    this.consultarReferencias(valor);
  }
  consultarReferencias(valor) {
    this.cxctrnabonoService.getListaReferencias(this.listaClientes[this.indiceCliente].CLI_CODIGO).subscribe((resRef) => {
      this.listaReferencias = resRef;
      if (valor === 'P' || valor === 'S') {
        this.indiceDocRef = 0;
      } else if (valor === 'A' || valor === 'U') {
        this.indiceDocRef = this.listaReferencias.length - 1;
      }
      this.obtenerDatos(this.listaReferencias[this.indiceDocRef].TRNCOBRO_REFERENCIAEXTERNA);
    });
  }
  primero() {
    this.editpagofr = true;
    this.consultarPosicionCliente('P');
    if (this.botonUltimo === true) {
      this.botonUltimo = !this.botonUltimo;
    }
    if (this.botonSiguiente === true) {
      this.botonSiguiente = !this.botonSiguiente;
    }
    this.botonPrimero = true;
    this.botonAnterior = true;
  }
  siguiente() {
    this.editpagofr = true;
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE.length === 0) {
      this.consultarPosicionCliente('S');
      return;
    }
    if (this.indiceDocRef < this.listaReferencias.length - 1) {
      this.indiceDocRef++;
    } else {
      this.consultarPosicionCliente('S');
      return;
    }
    if (this.botonPrimero === true && this.botonAnterior === true) {
      this.botonPrimero = false;
      this.botonAnterior = false;
    }
    this.consultarReferencias('');
  }
  anterior() {
    this.editpagofr = true;
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE.length === 0) {
      this.consultarPosicionCliente('A');
      return;
    }
    if (this.indiceDocRef > 0) {
      this.indiceDocRef--;
    } else {
      this.consultarPosicionCliente('A');
      return;
    }
    if (this.botonUltimo === true && this.botonSiguiente === true) {
      this.botonUltimo = false;
      this.botonSiguiente = false;
    }
    this.consultarReferencias('');
  }
  ultimo() {
    this.editpagofr = true;
    this.consultarPosicionCliente('U');
    if (this.botonPrimero === true) {
      this.botonPrimero = !this.botonPrimero;
    }
    if (this.botonAnterior === true) {
      this.botonAnterior = !this.botonAnterior;
    }
    this.botonUltimo = true;
    this.botonSiguiente = true;
  }
  nuevo() {
    this.editConcil = true;
    this.lblDocCierre = false;
    //this.opcionesTipoDoc = [];
    // this.cxctrnabonoService.llenarTipoDoc().subscribe((tipodoc) => {
    //   tipodoc.map((doc) => {
    //     this.itemTipoDoc = { label: doc.NOMBRE, value: doc.CODIGO };
    //     this.opcionesTipoDoc.push(this.itemTipoDoc);
    //   });
    //   this.opcionesTipoDoc.push({ label: '', value: '' });
    // });

    if (this.permisosCartera.PERINSERCION === 1) {
      this.nuevaCartera('N');
    } else if (this.permisosCartera.PERINSERCION === 0) {
      this.message.add({
        key: 'cxctrnabono',
        severity: 'error',
        summary: 'Inserción de Abono',
        detail: 'El usuario no tiene permisos de inserción, acción denegada'
      });
    }
    document.getElementById("errasiento").style.display = 'none';
  }
  nuevaCartera(parametro) {
    this.bolNuevo = true;
    if (parametro === 'N') { // N para nuevo
      this.btnNuevo = true;
      document.getElementById('divPrincipal').style.pointerEvents = 'all';
      document.getElementById('divPrincipal').style.opacity = '1.0';
      /*this.columnDefsDVFDetalle.map((columna) => {
        columna.editable = true;
      });*/
      // this.aggrid.refreshColumnDefs2(this.columnDefsDVFDetalle);
      this.numeroFactura = '';
      this.editarCeldas = false;
      this.tipodetalleactivo = 'all';
      this.btnGuardar = false;
      this.btnBorrar = false;
      this.btnRegresar = false;
      this.botonUltimo = true;
      this.botonAnterior = true;
      this.botonSiguiente = true;
      this.botonPrimero = true;
      this.botonPago = true;
      this.botonAnular = true;
      this.botonBuscar = true;
      this.botonAsiento = true;
      this.botonVerAsiento = true;
      this.porcIvaBoolean = true;
      this.booleanDatosPantalla = false;
      this.tabVarios = false;
      this.booleanNumero = false;
      this.cxctrnabonoService.dblTotalRetarray[this.indicador] = 0;
      this.cxctrnabonoService.dblTotalDocarray[this.indicador] = 0;
      this.cxctrnabonoService.dblTotalFormaDevarray[this.indicador] = 0;
      this.cxctrnabonoService.dblTotalNDarray[this.indicador] = 0;
      this.cxctrnabonoService.dblTotalFormaPagoarray[this.indicador] = 0;
      this.cxctrnabonoService.dblTotalOtrosGarray[this.indicador] = 0;
      this.cxctrnabonoService.dblTotalNCarray[this.indicador] = 0;
      this.cxctrnabonoService.dblTotalCobrararray[this.indicador] = 0;
      //this.tabDebitoBancario = false;
      // this.tabFormaPagoDev = false;
      this.tabRetenciones = true;
      this.tabOtrosGastos = true;
      //this.tabEstadoCuentaAnt = false;
      this.tabFormaPago = true;
      this.impresoString = '';
      this.retencionElect = true;
      let cencod=''
      if (this.RESINFCC === 1 ) {
        cencod=this.arraybodporuser['BOD_CODIGO']
      }
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador] = {
        SALDO: '',
        TRNCOBRO_TIPODOC: 'AB',
        TOTALFORMAPAGO: 0,
        TOTALND: 0,
        TRNCOBRO_IMPORTE: 0,
        TOTALNC: 0,
        TOTALOTROSG: 0,
        TOTALRET: 0,
        TOTALACOBRAR: 0,
        TOTALDOC: 0,
        BAN_BANCO: '',
        BAN_CODIGO: '',
        TRNCOBRO_NROCOMPROBANTE: '',
        TRNCOBRO_SALDOINI: '',
        CON_CODIGO: '',
        TRNCOBRO_NRODOC: '',
        TOTALANTICIPO: '',
        TRNCOBRO_FECHAVENCE: '',
        CLI_NOMBRE: '',
        REALIZADO: '',
        ORIGEN: '',
        VEN_NOMBRE: '',
        APLORG_CODIGO: 'CXC',
        USU_IDENTIFICACION: this.usuario.identificacion,
        TRNCOBRO_CONCEPTO: '',
        BOD_CODIGO: '',
        TRNCOBRO_FECHATRN: new Date(),
        VEN_CODIGO: '',
        CLI_CODIGO: '',
        ASI_NRO: '',
        CABROLADMN_CODIGO: '',
        CABROLVEND_CODIGO: '',
        COM_CODIGO: '01',
        COM_CODIGO_CXP: '01',
        COM_TIPOAMBFACTELEC: '',
        EMP_CODIGO: '',
        EMP_CODIGOVEND: '',
        TRNCOBRO_ANULADO: '',
        TRNCOBRO_CAMBIO: '',
        TRNCOBRO_CUADRE: '',
        TRNCOBRO_EFECTIVO: '',
        TRNCOBRO_FLAG: '1',
        TRNCOBRO_IMPRESO: '',
        TRNCOBRO_LOCALIZACIONXMLRET: '',
        TRNCOBRO_NRODOC_CXP: '',
        TRNCOBRO_NRODOC_OLD: '',
        TRNCOBRO_PATHPDF_FE: '',
        TRNCOBRO_PATHXMLNOAUTO_FE: '',
        TRNCOBRO_PATHXMLRET: '',
        TRNCOBRO_REFERENCIAEXTERNA: '',
        TRNCOBROND_AUTORIZACION_FE: '',
        TRNCOBROND_CLAVEACCESO_FE: '',
        TRNCOBROND_ESTADO_FE: '',
        TRNCOBROND_FECHAAUT_FE: '',
        TRNCOBROND_NUMFACTELEC: '',
        CEN_CODIGO:cencod,
        ENCCUO_CODIGO:''
      };
      document.getElementById('cliente').focus();
      this.cxctrnabonoService.getOrigen(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].APLORG_CODIGO).subscribe((resApl) => {
        if (resApl.length !== 0) {
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ORIGEN =
            this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].APLORG_CODIGO + '-' + resApl[0].APLORG_NOMBRE;
        } else {
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ORIGEN =
            this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].APLORG_CODIGO + '-';
        }
      });
      this.cxctrnabonoService.getRealizado(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].USU_IDENTIFICACION).subscribe((resReal) => {
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].REALIZADO = resReal[0].NOMBRE;
      });
      this.indice = -1;
      this.booleanBodega = false;
      this.saldoInicial = false;
      this.booleanAnulado = false;
      this.cxctrnabonoService.cxctrnresumenarray[this.indicador] = [];
      this.cxctrnabonoService.cxctrnretencionarray[this.indicador] = [];
      this.cxctrnabonoService.cxctrnformapagoarray[this.indicador] = [];
      this.cxctrnabonoService.cxctrnotrosgarray[this.indicador] = [];
      this.cxctrnabonoService.cxctrnformapagodevarray[this.indicador] = [];
      this.cxctrnabonoService.cxctrnanticiposarray[this.indicador] = [];
      this.lblAplicaRegMicroempresas = '';
      this.lblAplicaRegMicroempresas = '';
      this.bolestcta = false;
      this.bolsaldo = false;
      this.btneditConcil = true;
    } else if (parametro === 'C') { // C para cancelar
      this.indiceTablas = 0;
      this.btnNuevo = false;
      this.btnGuardar = true;
      this.btnBorrar = false;
      this.botonUltimo = false;
      this.botonAnterior = false;
      this.botonPrimero = false;
      this.botonSiguiente = false;
      this.botonBuscar = false;
      this.botonPago = false;
      this.botonAnular = false;
      this.botonAsiento = false;
      this.botonVerAsiento = false;
      this.porcIvaBoolean = true;
      this.booleanDatosPantalla = false;
      // this.tabVarios = false;
      // this.tabDebitoBancario = false;
      // this.tabFormaPagoDev = false;
      this.tabRetenciones = true;
      this.numeroFactura = '';
      this.tabOtrosGastos = true;
      this.cxctrnabonoService.dblTotalRetarray[this.indicador] = 0;
      this.cxctrnabonoService.dblTotalDocarray[this.indicador] = 0;
      this.cxctrnabonoService.dblTotalFormaDevarray[this.indicador] = 0;
      this.cxctrnabonoService.dblTotalNDarray[this.indicador] = 0;
      this.cxctrnabonoService.dblTotalFormaPagoarray[this.indicador] = 0;
      this.cxctrnabonoService.dblTotalOtrosGarray[this.indicador] = 0;
      this.cxctrnabonoService.dblTotalNCarray[this.indicador] = 0;
      this.cxctrnabonoService.dblTotalCobrararray[this.indicador] = 0;
      this.tabEstadoCuentaAnt = false;
      this.tabFormaPago = true;
      this.impresoString = '';
      this.retencionElect = true;
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador] = {
        SALDO: '',
        TRNCOBRO_TIPODOC: '',
        TOTALFORMAPAGO: 0,
        TOTALND: 0,
        TRNCOBRO_IMPORTE: 0,
        TOTALNC: 0,
        TOTALOTROSG: 0,
        TOTALRET: 0,
        TOTALACOBRAR: 0,
        TOTALDOC: 0,
        BAN_BANCO: '',
        BAN_CODIGO: '',
        TRNCOBRO_NROCOMPROBANTE: '',
        TRNCOBRO_SALDOINI: '',
        CON_CODIGO: '',
        TRNCOBRO_NRODOC: '',
        TOTALANTICIPO: '',
        TRNCOBRO_FECHAVENCE: '',
        CLI_NOMBRE: '',
        REALIZADO: '',
        ORIGEN: '',
        VEN_NOMBRE: '',
        APLORG_CODIGO: 'CXC',
        USU_IDENTIFICACION: this.usuario.identificacion,
        TRNCOBRO_CONCEPTO: '',
        BOD_CODIGO: '',
        TRNCOBRO_FECHATRN: new Date(),
        VEN_CODIGO: '',
        CLI_CODIGO: '',
        ASI_NRO: '',
        CABROLADMN_CODIGO: '',
        CABROLVEND_CODIGO: '',
        COM_CODIGO: '01',
        COM_CODIGO_CXP: '01',
        COM_TIPOAMBFACTELEC: '',
        EMP_CODIGO: '',
        EMP_CODIGOVEND: '',
        TRNCOBRO_ANULADO: '',
        TRNCOBRO_CAMBIO: '',
        TRNCOBRO_CUADRE: '',
        TRNCOBRO_EFECTIVO: '',
        TRNCOBRO_FLAG: '1',
        TRNCOBRO_IMPRESO: '',
        TRNCOBRO_LOCALIZACIONXMLRET: '',
        TRNCOBRO_NRODOC_CXP: '',
        TRNCOBRO_NRODOC_OLD: '',
        TRNCOBRO_PATHPDF_FE: '',
        TRNCOBRO_PATHXMLNOAUTO_FE: '',
        TRNCOBRO_PATHXMLRET: '',
        TRNCOBRO_REFERENCIAEXTERNA: '',
        TRNCOBROND_AUTORIZACION_FE: '',
        TRNCOBROND_CLAVEACCESO_FE: '',
        TRNCOBROND_ESTADO_FE: '',
        TRNCOBROND_FECHAAUT_FE: '',
        TRNCOBROND_NUMFACTELEC: ''
      };
      this.booleanBodega = false;
      this.booleanAnulado = false;
      this.saldoInicial = false;
      this.cxctrnabonoService.cxctrnresumenarray[this.indicador] = [];
      this.cxctrnabonoService.cxctrnretencionarray[this.indicador] = [];
      this.cxctrnabonoService.cxctrnformapagoarray[this.indicador] = [];
      this.cxctrnabonoService.cxctrnotrosgarray[this.indicador] = [];
      this.cxctrnabonoService.cxctrnformapagodevarray[this.indicador] = [];
      this.cxctrnabonoService.cxctrnanticiposarray[this.indicador] = [];
      this.lblAplicaRegMicroempresas = '';
      this.btneditConcil = true;
    }
  }
  async borrar() {
    this.editpagofr = true;
    // if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ANC') {
    //   if (Number(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].SALDOANC) !==
    //     Number(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_IMPORTE)) {
    //     this.message.add({
    //       key: 'cxctrnabono',
    //       severity: 'error',
    //       summary: 'Anular Abono',
    //       detail: 'No se puede Eliminar el anticipo ya está siendo utilizado'
    //     });
    //     return;
    //   }
    // }
    // conciliado
    if (this.permisosCartera.PERELIMACION === 1) {
      if (this.activeIndex === 0) {

        if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC.length > 0) {
          // ver que los documentos no tengan pagos para la eliminación
          // if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'FC' ||
          //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ND') {
          //   if (await this.existePagoDoc()) {
          //     return;
          //   }
          // }

          // verificar que el cheque girado por la devolución de anticipos
          // no haya sido conciliado
          if (await this.chequeConciliado('eliminar')) {
            return;
          }

          // verificar que el cheque cobrado no haya sido depositado
          if (await this.chequeDepositado('eliminar')) {
            return;
          }

          // verificar que el efectivo no haya sido depositado
          if (await this.efectivoDepositado('eliminar')) {
            return;
          }

          // verificar que los depósitos no hayan sido conciliados
          if (await this.depositoConciliado('eliminar')) {
            return;
          }

          // verificar que los vouchers no hayan sido conciliados
          if (await this.tarjetaConciliada('eliminar')) {
            return;
          }

          // verificar que el documento no esté en el cierre de caja
          if (await this.documentoCierre('eliminar')) {
            return;
          }
          // verificar si el anticipo ya fue utilizado y no dejar
          // eliminarlo
          // if (this.anticipoUtilizado('eliminar')) {
          //   return;
          // }
          // verifica si existe algun anticipo asociado y si este anticipo ha sido utilizado
          if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CI') {
            if (await this.cxc_fnc_verificar_ant_util(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC) !== 0) {
              this.message.add({
                key: 'cxctrnabono',
                severity: 'error',
                summary: 'Información',
                detail: 'No se puede eliminar la transacción, ya que tiene asociado un anticipo ya utilizado'
              });
              return;
            }
          }
          this.confirmarCartera();
        } else {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'error',
            summary: 'Información',
            detail: 'No hay un documento para la eliminación.'
          });
        }
      } else if (this.activeIndex === 3) {
        this.message.add({
          key: 'cxctrnabono',
          severity: 'error',
          summary: 'Eliminación de Anexos',
          detail: 'No se puede eliminar un anexo, solo modificar'
        });
      }
    } else if (this.permisosCartera.PERELIMACION === 0) {
      this.message.add({
        key: 'cxctrnabono',
        severity: 'error',
        summary: 'Eliminación de Abono',
        detail: 'El usuario no tiene permisos de eliminación, acción denegada'
      });
    }
    document.getElementById("errasiento").style.display = 'none';
  }
  async cxc_fnc_verificar_ant_util(strTrnCobro) {
    let intSw = 0;


    try {
      const data = await this.cxctrnabonoService.cxc_fnc_verificar_ant_util(strTrnCobro);

      for (const rs of data) {
        intSw = rs.DATO;
      }
    } catch (error) {
      console.log(error);
      this.message.add({
        key: 'cxctrnabono',
        severity: 'success',
        summary: 'Error',
        detail: 'No se puede verificar si existe algun anticipo asociado'
      });
    }

    return intSw;
  }
  confirmarCartera() {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea eliminar el documento',
      header: 'Eliminar Abono',
      icon: 'pi pi-exclamation-triangle',
      key: 'confCxctrnabono',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.confirmationService.close();
        this.eliminarCartera();
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async eliminarCartera() {
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador] !== undefined) {
      // if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'FC' ||
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ND') {
      //   this.cxctrnabonoService.existePagoDoc(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe((comp) => {
      //     if (comp.length !== 0) {
      //       this.message.add({
      //         key: 'cxctrnabono',
      //         severity: 'error',
      //         summary: 'Eliminación de Abono',
      //         detail: 'El documento tiene cobros, por lo que no se puede eliminar'
      //       });
      //       return;
      //     }
      //   });
      // }
      if (this.tabFormaPago === true) {
        if (this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length !== 0) {
          this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].map(async (formap) => {
            if (formap.TRNPAGO_TIPO === 'ANCL') {
              const eR = await this.cxctrnabonoService.erTrnpagorefer(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC);
              console.log(eR)
              console.log(eR[0])
              console.log(eR[0].TRNPAGO_REFER)
              let strNumDocAnt = '';
              if (eR !== undefined) {
                if (eR[0].TRNPAGO_REFER !== null) {
                  strNumDocAnt = eR[0].TRNPAGO_REFER;
                }
              }
              console.log('strNumDocAnt',strNumDocAnt)
              if (strNumDocAnt !== '' && isNullOrUndefined(strNumDocAnt) === false) {
                await this.cxctrnabonoService.eliminarTrnCobroProm(strNumDocAnt);
              }
              
              this.eliminarPagosCuotas();
              // this.cxcCarteraService.eliminarNDATrnResumen(formap.TRNCOBRO_NRODOC).subscribe(() => {
              //   console.log('Se actualiza');
              // }, error1 => {
              //   this.message.add({
              //     key: 'cartera',
              //     severity: 'error',
              //     summary: 'Eliminación de Cartera',
              //     detail: 'No se pudo eliminar la cartera, error ' + error1.error
              //   });
              // });
              // this.auditoriagral.registrarAuditoria('CXC_TRNCOBRO', String(this.cxcCarteraService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC), 'E',
              //   '', '01', '', '', '', '').subscribe(() => {
              // this.auditoriagral.registrarAuditoria('CXC_TRNABONO', String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC), 'E',
              //   '', '01', '', '', '', '').subscribe(() => {
                  this.message.add({
                    key: 'cxctrnabono',
                    severity: 'success',
                    summary: 'Eliminación de Abono',
                    detail: 'Se eliminó el abono correctamente'
                  });
                  this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador] = {
                    SALDO: '',
                    TRNCOBRO_TIPODOC: '',
                    TOTALFORMAPAGO: 0,
                    TOTALND: 0,
                    TRNCOBRO_IMPORTE: 0,
                    TOTALNC: 0,
                    TOTALOTROSG: 0,
                    TOTALRET: 0,
                    TOTALACOBRAR: 0,
                    TOTALDOC: 0,
                    BAN_BANCO: '',
                    BAN_CODIGO: '',
                    TRNCOBRO_NROCOMPROBANTE: '',
                    TRNCOBRO_SALDOINI: '',
                    CON_CODIGO: '',
                    TRNCOBRO_NRODOC: '',
                    TOTALANTICIPO: '',
                    TRNCOBRO_FECHAVENCE: '',
                    CLI_NOMBRE: '',
                    REALIZADO: '',
                    ORIGEN: '',
                    VEN_NOMBRE: '',
                    APLORG_CODIGO: 'CXC',
                    USU_IDENTIFICACION: this.usuario.identificacion,
                    TRNCOBRO_CONCEPTO: '',
                    BOD_CODIGO: '',
                    TRNCOBRO_FECHATRN: new Date(),
                    VEN_CODIGO: '',
                    CLI_CODIGO: '',
                    ASI_NRO: '',
                    CABROLADMN_CODIGO: '',
                    CABROLVEND_CODIGO: '',
                    COM_CODIGO: '01',
                    COM_CODIGO_CXP: '01',
                    COM_TIPOAMBFACTELEC: '',
                    EMP_CODIGO: '',
                    EMP_CODIGOVEND: '',
                    TRNCOBRO_ANULADO: '',
                    TRNCOBRO_CAMBIO: '',
                    TRNCOBRO_CUADRE: '',
                    TRNCOBRO_EFECTIVO: '',
                    TRNCOBRO_FLAG: '1',
                    TRNCOBRO_IMPRESO: '',
                    TRNCOBRO_LOCALIZACIONXMLRET: '',
                    TRNCOBRO_NRODOC_CXP: '',
                    TRNCOBRO_NRODOC_OLD: '',
                    TRNCOBRO_PATHPDF_FE: '',
                    TRNCOBRO_PATHXMLNOAUTO_FE: '',
                    TRNCOBRO_PATHXMLRET: '',
                    TRNCOBRO_REFERENCIAEXTERNA: '',
                    TRNCOBROND_AUTORIZACION_FE: '',
                    TRNCOBROND_CLAVEACCESO_FE: '',
                    TRNCOBROND_ESTADO_FE: '',
                    TRNCOBROND_FECHAAUT_FE: '',
                    TRNCOBROND_NUMFACTELEC: ''
                  };
                  this.booleanBodega = false;
                  this.saldoInicial = false;
                  this.cxctrnabonoService.cxctrnresumenarray[this.indicador] = [];
                  this.cxctrnabonoService.cxctrnformapagoarray[this.indicador] = [];
                  this.cxctrnabonoService.cxctrnanticiposarray[this.indicador] = [];
                //});


            }
          });
        }
      }

      if (this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'ELIASIELI').CFG_VALOR1 === 0) {
        if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO !== '' && this.saldoInicial === false) {
          this.cxctrnabonoService.anularAsiento(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO).subscribe(() => {
          });
        } else if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO !== '' && this.saldoInicial === true) {
          this.cxctrnabonoService.actualizarAsiento(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador]).subscribe(() => {
          });
        }
      } else {
        if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO !== '' && this.saldoInicial === false) {
          this.cxctrnabonoService.eliminarAsiento(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO).subscribe(() => {
          });
        } else if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO !== '' && this.saldoInicial === true) {
          this.cxctrnabonoService.actualizarAsiento(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador]).subscribe(() => {
          });
        }
      }
      ////GSRF
      // this.eliminarFormaPagoDev();
      ////GSRF

      this.cxctrnabonoService.eliminarAntAsoc(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe();
      try {
        //CDPJ 
        if (this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'IMOBANCXCV').CFG_VALOR1 === 1) {
          await this.cxctrnabonoService.eliminarMovBan(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC)
        }
        //CDPJ
        await this.cxctrnabonoService.eliminarTrnCobroProm(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC)
        this.eliminarPagosCuotas();
        this.cxctrnabonoService.eliminarNDATrnResumen(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe(() => {
        });
        //GSRF 
        const claveac = this.cxctrnabonoService.cxctrnretencionarray[this.indicador]
        console.log('1', claveac)
        console.log(claveac[0])
        if (claveac !== undefined && claveac !== null) {
          if (claveac[0] !== undefined && claveac[0] !== null && claveac[0] !== '') {
            console.log('<<<<<<enta1r>>>>>>', claveac[0].TRNRETENCION_AUTORIZACION)
            if (claveac[0].TRNRETENCION_AUTORIZACION !== null && claveac[0].TRNRETENCION_AUTORIZACION !== '' && claveac[0].TRNRETENCION_AUTORIZACION !== undefined) {
              console.log('<<<<<<enta99991r>>>>>>')
              this.cxctrnabonoService.deleteimptable(claveac[0].TRNRETENCION_AUTORIZACION)
            }
          }
        }

        //GSRF
        this.auditoriagral.registrarAuditoria('CXC_TRNABONO', String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC), 'E',
          '', '01', '', '', '', '').subscribe(() => {
            this.message.add({
              key: 'cxctrnabono',
              severity: 'success',
              summary: 'Eliminación de Abono',
              detail: 'Se eliminó el abono exitosamente'
            });
            this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador] = {
              SALDO: '',
              TRNCOBRO_TIPODOC: '',
              TOTALFORMAPAGO: 0,
              TOTALND: 0,
              TRNCOBRO_IMPORTE: 0,
              TOTALNC: 0,
              TOTALOTROSG: 0,
              TOTALRET: 0,
              TOTALACOBRAR: 0,
              TOTALDOC: 0,
              BAN_BANCO: '',
              BAN_CODIGO: '',
              TRNCOBRO_NROCOMPROBANTE: '',
              TRNCOBRO_SALDOINI: '',
              CON_CODIGO: '',
              TRNCOBRO_NRODOC: '',
              TOTALANTICIPO: '',
              TRNCOBRO_FECHAVENCE: '',
              CLI_NOMBRE: '',
              REALIZADO: '',
              ORIGEN: '',
              VEN_NOMBRE: '',
              APLORG_CODIGO: 'CXC',
              USU_IDENTIFICACION: this.usuario.identificacion,
              TRNCOBRO_CONCEPTO: '',
              BOD_CODIGO: '',
              TRNCOBRO_FECHATRN: new Date(),
              VEN_CODIGO: '',
              CLI_CODIGO: '',
              ASI_NRO: '',
              CABROLADMN_CODIGO: '',
              CABROLVEND_CODIGO: '',
              COM_CODIGO: '01',
              COM_CODIGO_CXP: '01',
              COM_TIPOAMBFACTELEC: '',
              EMP_CODIGO: '',
              EMP_CODIGOVEND: '',
              TRNCOBRO_ANULADO: '',
              TRNCOBRO_CAMBIO: '',
              TRNCOBRO_CUADRE: '',
              TRNCOBRO_EFECTIVO: '',
              TRNCOBRO_FLAG: '1',
              TRNCOBRO_IMPRESO: '',
              TRNCOBRO_LOCALIZACIONXMLRET: '',
              TRNCOBRO_NRODOC_CXP: '',
              TRNCOBRO_NRODOC_OLD: '',
              TRNCOBRO_PATHPDF_FE: '',
              TRNCOBRO_PATHXMLNOAUTO_FE: '',
              TRNCOBRO_PATHXMLRET: '',
              TRNCOBRO_REFERENCIAEXTERNA: '',
              TRNCOBROND_AUTORIZACION_FE: '',
              TRNCOBROND_CLAVEACCESO_FE: '',
              TRNCOBROND_ESTADO_FE: '',
              TRNCOBROND_FECHAAUT_FE: '',
              TRNCOBROND_NUMFACTELEC: ''
            };
            this.booleanBodega = false;
            this.saldoInicial = false;
            this.cxctrnabonoService.cxctrnresumenarray[this.indicador] = [];
            this.cxctrnabonoService.cxctrnformapagoarray[this.indicador] = [];
            this.cxctrnabonoService.cxctrnformapagodevarray[this.indicador] = [];
            this.cxctrnabonoService.cxctrnotrosgarray[this.indicador] = [];
            this.cxctrnabonoService.cxctrnretencionarray[this.indicador] = [];
            this.cxctrnabonoService.cxcdebitobancarioarray[this.indicador] = [];
            this.cxctrnabonoService.cxctrnvariosarray[this.indicador] = [];
            this.cxctrnabonoService.cxctrnanticiposarray[this.indicador] = [];
          });
        if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length !== 0) {
          this.cxctrnabonoService.cxctrnresumenarray[this.indicador].map((doc) => {
            if (doc.APLORG_CODIGO === 'SISTEMA') {
              this.cxctrnabonoService.actualizarPagadoCuota(doc).subscribe(() => {
              });
            }
            if (doc.SELECCIONADO === true && doc.APLORG_CODIGO !== 'SISTEMA') {
              this.cxctrnabonoService.actualizarestadoFac(doc).subscribe(() => {
              });
            }
          });
        }
      } catch (error1) {
        this.message.add({
          key: 'cxctrnabono',
          severity: 'error',
          summary: 'Eliminación de Abono',
          detail: 'No se pudo eliminar el abono, error ' + error1
        });
        console.log(error1)
      }
    } else {
      this.message.add({
        key: 'cxctrnabono',
        severity: 'error',
        summary: 'Eliminación de Abono',
        detail: 'Seleccione un abono para ser eliminado'
      });
    }
  }
  eliminarPagosCuotas() {
    console.log('ELIMINAR CUOTAS');
    console.log(this.cxctrnabonoService.cxctrnresumenarray[this.indicador]);
    if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length !== 0) {
      this.cxctrnabonoService.cxctrnresumenarray[this.indicador].map((item) => {
        console.log(item.STRCUOTAFAC);
        if (item.STRCUOTAFAC === 'C') {
          const data = {
            TRNCOBRO_NRODOC: item.TRNCOBRO_NRODOC,
            CLI_CODIGO: this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO
          };
          this.actualizarCuotasPagadas(data);
          //GSRF
          this.auditoriagral.registrarAuditoria('CXC_TRNABONO', String(item.TRNCOBRO_NRODOC + '/' + this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC), 'E',
            '', '01', '', '', '', '').subscribe(() => {
            });
          //GSRF
        }
      });
    }
  }
  async actualizarCuotasPagadas(item) {
    const data = {
      ENCFAC_NUMERO: item.TRNCOBRO_NRODOC,
      CLI_CODIGO: item.CLI_CODIGO
    };
    await this.cxctrnabonoService.actPagadoDETCUOTA(data);
  }
  async cancelarEdicionCartera() {
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC !== '' && this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC !== undefined) {
      const res = await this.cxctrnabonoService.getEncCarteraProm(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC);
      if (res.length === 0) {
        this.nuevaCartera('C');
      } else {
        this.btnNuevo = false;
        this.btnGuardar = true;
        this.btnBorrar = false;
        this.botonAnterior = false;
        this.botonPrimero = false;
        this.botonUltimo = false;
        this.botonSiguiente = false;
        this.botonBuscar = false;
        this.botonPago = false;
        this.botonAnular = false;
        this.botonAsiento = false;
        this.botonVerAsiento = false;
        const array: any = [];
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador] = array;//res[0];
        await this.obtenerDatos(res[0].TRNCOBRO_NRODOC);
      }
      /* this.cxctrnabonoService.getEncCartera(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe((res) => {
        if (res.length === 0) {
          this.nuevaCartera('C');
        } else {
          this.btnNuevo = false;
          this.btnGuardar = true;
          this.btnBorrar = false;
          this.botonAnterior = false;
          this.botonPrimero = false;
          this.botonUltimo = false;
          this.botonSiguiente = false;
          this.botonBuscar = false;
          this.botonPago = false;
          this.botonAnular = false;
          this.botonAsiento = false;
          this.botonVerAsiento = false;
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador] = res[0];
          this.obtenerDatos(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC);
        }
      }); */
    } else {
      this.nuevaCartera('C');
    }
  }
  abrirClave(accion) {
    this.displayAcciones = false;
    this.accionClave = accion;
    const elemento = document.getElementsByClassName('layout-config');
    for (let i = 1; i <= elemento.length; i++) {
      elemento[i - 1].className = 'layout-config';
    }
    this.claveDialog = true;
  }
  comprobarClave() {
    this.cxctrnabonoService.obtenerClave(this.accionClave).subscribe((clave) => {

      let claveReal;
      claveReal = clave[0].AUTORIZACION_CLAVE;
      if (claveReal === this.claveAuth) {
        this.claveDialog = false;
        this.confirmarAnularCar();
        this.claveAuth = '';
      } else if (clave !== this.claveAuth) {
        this.message.add({
          key: 'cxctrnabono',
          severity: 'error',
          summary: 'Clave Autorización',
          detail: 'La clave que se ingresó es incorrecta, intente nuevamente'
        });
      }

    });
  }
  confirmarAnularCar() {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea anular el abono',
      header: 'Anular Abono',
      icon: 'pi pi-exclamation-triangle',
      key: 'confCxctrnabono',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.confirmationService.close();
        //this.anularCartera();
        this.finalmenteAnular();
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  finalmenteAnular() {
    // if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'DAN') {
    //   this.cxctrnabonoService.eliminarCaja(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe(() => {
    //     this.auditoriagral.registrarAuditoria('BAN_TRNCAJ', String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC), 'E',
    //       '', '01', '', '', '', '').subscribe(() => {
    //       });
    //   });
    //   this.cxctrnabonoService.eliminarBanco(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe(() => {
    //     this.auditoriagral.registrarAuditoria('BAN_TRNBAN', String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC), 'E',
    //       '', '01', '', '', '', '').subscribe(() => {
    //       });
    //   });
    // }
    if (this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length !== 0) {
      this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].map(async (formap) => {
        if (formap.TRNPAGO_TIPO === 'ANCL') {
          //GSRF
          const eR = await this.cxctrnabonoService.erTrnpagorefer(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC);
          let strNumDocAnt = '';
          if (eR !== undefined) {
            if (eR[0].TRNPAGO_REFER !== null) {
              strNumDocAnt = eR[0].TRNPAGO_REFER;
            }
          }
          console.log(strNumDocAnt)
          if (strNumDocAnt !== '' && isNullOrUndefined(strNumDocAnt) === false) {
            await this.cxctrnabonoService.eliminarTrnCobroProm(strNumDocAnt);
          }
          
          //GSRF
          //await this.cxctrnabonoService.eliminarTrnCobroProm(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC);
          this.eliminarPagosCuotas();
          this.cxctrnabonoService.eliminarNDATrnResumen(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe(() => {
          });
          this.auditoriagral.registrarAuditoria('CXC_TRNABONO', String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC), 'E',
            '', '01', '', '', '', '').subscribe(() => {
            });

        }
      });
    }
    this.cxctrnabonoService.anularDocumento(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe(() => {
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO !== '') {
        this.cxctrnabonoService.anularAsientoDoc(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO).subscribe(() => {
        });
      }
      // if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length !== 0) {
      //   this.cxctrnabonoService.cxctrnresumenarray[this.indicador].map((doc) => {
      //     if (doc.SELECCIONADO === true) {
      //       this.cxctrnabonoService.actualizarestadoFac(doc).subscribe(() => {
      //       });
      //     }
      //   });
      // }
      this.cxctrnabonoService.eliminarDocAnulado(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador]).subscribe(() => {
      });
      this.cxctrnabonoService.eliminarDocAnuladoEnc(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador]).subscribe(() => {
      });
      this.cxctrnabonoService.eliminarPagoAnulado(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador]).subscribe(() => {
      });
      this.cxctrnabonoService.eliminarRetencionAnulado(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador]).subscribe(() => {
      });
      //CDPJ
      if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length !== 0) {
        this.cxctrnabonoService.cxctrnresumenarray[this.indicador].map(async (doc) => {
          if (doc.SELECCIONADO === true) {
            await this.cxctrnabonoService.actualizarestadoFac(doc).toPromise().catch(e => {

            })
          }
        });
      }
      //CDPJ
      this.auditoriagral.registrarAuditoria('CXC_TRNABONO', String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC) + '/' +
        String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE), 'AN',
        '', '01', '', '', '', '').subscribe(() => {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'success',
            summary: 'Anular Abono',
            detail: 'El abono fue anulado'
          });
          this.booleanAnulado = true;
          this.cxctrnabonoService.obtenerSaldoCliente(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO).subscribe((saldo) => {
            this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].SALDO = saldo[0].SALDO;
            this.cancelarEdicionCartera();
          });
        });
    });
  }
  buscarCartera() {
    this.editpagofr = true;
    this.opcion = 'BUSCAR';
    this.busquedaCompuesta = false;
    this.types = [
      { label: 'NÚMERO', value: 'TRNCOBRO_NRODOC' },
      { label: 'TIPO DOC', value: 'TRNCOBRO_TIPODOC' },
      { label: 'FECHA TRANS', value: 'TRNCOBRO_FECHATRN' },
      { label: 'COD_CLIENTE', value: 'CLI_CODIGO' },
      { label: 'CLIENTE', value: 'CLI_NOMBRE' },
      { label: 'CONCEPTO', value: 'TRNCOBRO_CONCEPTO' },
      { label: 'IMPORTE', value: 'TRNCOBRO_IMPORTE' },
      { label: 'FECHA VENC', value: 'TRNCOBRO_FECHAVENCE' },
      { label: 'REF_EXTERNA', value: 'TRNCOBRO_REFERENCIAEXTERNA' },
      { label: 'COMPROBANTE', value: 'TRNCOBRO_NROCOMPROBANTE' },
    ];
    this.busquedacampos = ['', '', '', '', '', '', '', '', '', ''];
    this.tabla = 'CXC_TRNCOBRO';
    this.consulta = 'CXC_TRNCOBRO.*, VEN_FNC_NOMBRE_CLIENTE(CLI_CODIGO, \'01\') AS CLI_NOMBRE';
    this.where = ' trncobro_tipodoc=\'AB\' AND CXC_TRNCOBRO.TRNCOBRO_NRODOC is not null order by CXC_TRNCOBRO.TRNCOBRO_FECHATRN desc';
    this.spin = true;
    this.busquedaSer.busquedaCXCTrnAbono1().subscribe((res: any[]) => {
      this.arregloCons = res;
      this.arregloCons.map((registro) => {
        if (registro.TRNCOBRO_IMPORTE !== null) {
          registro.TRNCOBRO_IMPORTE = Number(registro.TRNCOBRO_IMPORTE).toFixed(2);
        }
        if (registro.TRNCOBRO_FECHATRN !== null) {
          registro.TRNCOBRO_FECHATRN = this.datePipe.transform(registro.TRNCOBRO_FECHATRN, 'dd/MM/yyyy');
        } else {
          registro.TRNCOBRO_FECHATRN = '';
        }
        if (registro.TRNCOBRO_FECHAVENCE !== null) {
          registro.TRNCOBRO_FECHAVENCE = this.datePipe.transform(registro.TRNCOBRO_FECHAVENCE, 'dd/MM/yyyy');
        } else {
          registro.TRNCOBRO_FECHAVENCE = '';
        }
      });
      this.spin = false;
      this.displayDialogBusquedaFast = true;
    });
  }
  generarasiento() {
    if (this.btnGuardar === true) {
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].APLORG_CODIGO !== 'CXC') {
        this.message.add({
          key: 'cxctrnabono',
          severity: 'error',
          summary: 'Asiento Abono',
          detail: 'No se puede generar un asiento debido a que el documento proviene de otro origen'
        });
        return;
      } else {
        if (this.saldoInicial === false) {
          this.confirmarAsiento();
        }
      }
    } else {
      this.message.add({
        key: 'cxctrnabono',
        severity: 'error',
        summary: 'Asiento Abono',
        detail: 'No se puede generar un asiento debido a que el abono no está guardado'
      });
    }
  }
  confirmarAsiento() {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea generar el asiento',
      header: 'Asiento Abono',
      icon: 'pi pi-exclamation-triangle',
      key: 'confCxctrnabono',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.confirmationService.close();

        if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB' ||
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA') {
          this.cxctrnabonoService.generarAsientoCI(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador]).subscribe(() => {
            this.cxctrnabonoService.getAsiento(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe((res) => {
              this.asiento = res[0].ASI_NRO;
              this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO = this.asiento;
              this.actualizarNumeroAsiento(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO);
              this.auditoriagral.registrarAuditoria('CON_ENCASI_L', String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO + '/CXC'), 'I',
                '', '01', '', '', '', '').subscribe(() => {
                  this.message.add({
                    key: 'cxctrnabono',
                    severity: 'success',
                    summary: 'Asiento Contable',
                    detail: 'Se ha generado el asiento contable'
                  });
                });
            });
          }, error1 => {
            this.message.add({
              key: 'cxctrnabono',
              severity: 'error',
              summary: 'Asiento Contable',
              detail: 'No se ha generado el asiento, error ' + error1.error
            });
          });
        }
        ///GSRF
        this.cxctrnabonoService.getAsiento(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe(async (res) => {
          console.log('----***', res)
          this.asiento = res[0].ASI_NRO;
          if (this.asiento !== null) {
            const det = await this.cxctrnabonoService.getDetConencasilProm(this.asiento, 'CXC');
            console.log('----***', det);
            let sum = 0;
            for (const aux of det) {
              sum = aux.DETASI_IMPORTE + sum;
            }
            console.log('----***', Number(sum.toFixed(2)));
            if (Number(sum.toFixed(2)) !== 0) {
              document.getElementById("errasiento").style.display = '';
            } else {
              document.getElementById("errasiento").style.display = 'none';
            }
          } else {
            document.getElementById("errasiento").style.display = 'none';
          }
        });
        //GSRF
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async actualizarNumeroAsiento(strAsiNro) {
    const strTrnCobroNroDoc = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC;
    // FORMAS DE PAGO

    let lstFormaPago = [];

    const data = await this.cxctrnabonoService.asibangettrnpago(strTrnCobroNroDoc);
    //CDPJ
    if (data !== null && data !== undefined) {
      for (const rs of data) {
        lstFormaPago.push({
          strBanCodigo: rs.CAJ_CODIGO,
          strBanNumero: rs.TRNPAGO_NUMERO,
          strBanTipo: rs.TRNPAGO_TIPO
        });
      }

      // Actualiza en numero del asiento

      // Lee cada una de las formas de pago y actualiza el número del asiento en la transaccion de bancos

      for (const item of lstFormaPago) {
        if (item.strBanTipo === "DP") {
          await this.cxctrnabonoService.updateasientobantrnban(strAsiNro, item.strBanCodigo, item.strBanTipo, item.strBanNumero);
        } else {
          await this.cxctrnabonoService.updateasientobantrncaj(strAsiNro, item.strBanCodigo, item.strBanTipo, item.strBanNumero);
        }
      }
    }
    //CDPJ
  }
  asientover() {
    this.cxctrnabonoService.getAsiento(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe((res) => {
      this.asiento = res[0].ASI_NRO;
      if (this.asiento === null) {
        this.message.add({
          key: 'cxctrnabono',
          severity: 'error',
          summary: 'Visualizacion de Asiento Contable',
          detail: 'Este abono no tiene un asiento contable'
        });
      } else {
        this.auxiliar++;
        // this.displayDialogAsiento = true;
        this.displayAsiContable = true;
      }
    });
  }
  recibirSenalesConEncasil(valor) {
    if (valor === true) {
      this.displayAsiContable = false;
    }
  }
  abrirFacturasAbonadas() {
    this.codClienteFac = '';
    this.nombreClienteFac = '';
    this.nroFacCancelada = '';
    this.cxctrnabonoService.cxctrnfaccanceladasarray[this.indicador] = [];
    this.dialogFacCanceladas = true;
  }
  async guardar() {

    if (this.activeIndex === 0) {
      this.spin = true//CDPJ
      // validar la fecha de cobro
      if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length > 0) {
        const strNOVFECCAN = this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'NOVFECCAN').CFG_VALOR1 === null ? '' : this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'NOVFECCAN').CFG_VALOR1;
        if (strNOVFECCAN === 0) {
          if (!this.controlarFechaCobro()) {
            this.mensajeAlerta('info', 'Información', 'La fecha del cobro es menor a la fecha de los documentos.');
            this.spin = false//CDPJ
            return;
          }
          //GSRF
          if (!this.controlarFechaforpago()) {
            this.mensajeAlerta('info', 'Información', 'La fecha de pago es menor a la fecha de los documentos.');
            this.spin = false//CDPJ
            return;
          }
          // if (!this.controlarFechaforpagodev()) {
          //   this.mensajeAlerta('info', 'Información', 'La fecha de pago es menor a la fecha de los documentos.');
          //   this.spin=false//CDPJ
          //   return;
          // }
          //GSRF
        }
      }
      console.log(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC);
      // this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColumnDefCarteraFormaPago.objeto];
      if (this.permisosCartera.PERACTUALIZACION === 1) {
        if (this.booleanNumero === false) {
          if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB' ||
            this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA' ||
            this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ANC') {
            if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE !== '') {
              if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC === '') {
                const exis = await this.cxctrnabonoService.verificarComprobanteUnico('N',
                  this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE, '');

                if (exis[0][':B1'] !== '0' && exis[0][':B1'] !== null && exis[0][':B1'] !== undefined) {
                  this.message.add({
                    key: 'cxctrnabono',
                    severity: 'error',
                    summary: 'Inserción de Abono',
                    detail: 'El numero de comprobante ya existe'
                  });
                  this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE = '';
                  document.getElementById('numeroCartera').focus();
                  this.spin = false//CDPJ
                  return;
                }

              } else if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC !== '') {
                let numeroFac = '';
                if (this.cxctrnresumen.length !== 0) {
                  for (const resumen of this.cxctrnresumen) {
                    if (resumen.SELECCIONADO === true) {
                      numeroFac = resumen.TRNCOBRO_NRODOC;
                      const exis = await this.cxctrnabonoService.verificarComprobanteUnico('M',
                        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE, numeroFac).catch(e => {
                          this.spin = false//CDPJ
                        });
                      console.log(exis);
                      if (exis[0][':B1'] !== '0') {
                        this.message.add({
                          key: 'cxctrnabono',
                          severity: 'error',
                          summary: 'Inserción de Abono',
                          detail: 'El numero de comprobante ya existe'
                        });
                        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE = '';
                        document.getElementById('numeroCartera').focus();
                        this.spin = false//CDPJ
                        return;
                      } else {

                      }

                    }
                  }
                }
              }
              if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === '') {
                this.message.add({
                  key: 'cxctrnabono',
                  severity: 'error',
                  summary: 'Inserción de Abono',
                  detail: 'Escoja un tipo de documento'
                });
                this.spin = false//CDPJ
                return;
              } else if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO === '') {
                this.message.add({
                  key: 'cxctrnabono',
                  severity: 'error',
                  summary: 'Inserción de Abono',
                  detail: 'Escoja un cliente'
                });
                this.spin = false//CDPJ
                return;
              } else if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_CODIGO === '') {
                this.message.add({
                  key: 'cxctrnabono',
                  severity: 'error',
                  summary: 'Inserción de Abono',
                  detail: 'Escoja un vendedor'
                });
                this.spin = false//CDPJ
                return;
              } else {
                let auxiliar = 0;
                let seleccionados = 0;
                if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length !== 0) {
                  this.cxctrnabonoService.cxctrnresumenarray[this.indicador].map((resumen) => {
                    if (resumen.SELECCIONADO === true) {
                      seleccionados++;
                    }
                  });

                  if (seleccionados === 0) {
                    this.message.add({
                      key: 'cxctrnabono',
                      severity: 'error',
                      summary: 'Inserción de Abono',
                      detail: 'Ningún documento ha sido ' +
                        'seleccionado.'
                    });
                    this.spin = false//CDPJ
                    return;
                  }

                  if (Number(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALDOC) === 0) {
                    this.message.add({
                      key: 'cxctrnabono',
                      severity: 'error',
                      summary: 'Inserción de Abono',
                      detail: 'El total debe ser diferente de cero'
                    });
                    this.spin = false//CDPJ
                    return;
                  }
                }
                if (this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length !== 0) {
                  this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].map((formap) => {
                    if (formap.TRNPAGO_TIPO === 'TA' || formap.TRNPAGO_TIPO === 'CH') {
                      if (formap.BANCLI_CODIGO === '' || formap.TRNPAGO_NROCTA === '' || formap.TRNPAGO_NUMERO === '') { // formap.TRNPAGO_NUMERO
                        this.message.add({
                          key: 'cxctrnabono',
                          severity: 'error',
                          summary: 'Inserción de Abono',
                          detail: 'No se puede insertar el registro por que falta código de banco, número de pago, concepto o número de cuenta'
                        });
                        this.spin = false//CDPJ
                        auxiliar++;
                      }
                    }
                    let fecenc = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN;
                    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN.length !== 10) {
                      fecenc = this.datePipe.transform(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN, 'dd/MM/yyyy');
                    }
                    console.log(1, formap.TRNPAGO_TIPO, formap.TRNPAGO_FECHA, fecenc);
                    /* if (formap.TRNPAGO_TIPO === 'EF' || formap.TRNPAGO_TIPO === 'TA') { // formap.TRNPAGO_TIPO === 'DP' || 
                      if (formap.TRNPAGO_FECHA !== fecenc) {
                        this.message.add({
                          key: 'cartera',
                          severity: 'error',
                          summary: 'Inserción de Abono',
                          detail: 'Fecha de pago incorrecta'
                        });
                        auxiliar++;
                      }
                    } */
                  });
                  if (auxiliar === 0) {
                    this.guardarCartera();
                  }
                } else if (this.cxctrnabonoService.cxctrnretencionarray[this.indicador].length !== 0) {
                  let auxiliar1 = 0;
                  let cont = 0;
                  let nroretencion = '';
                  this.cxctrnabonoService.cxctrnretencionarray[this.indicador].map((ret) => {
                    if (ret.RETENCION_CODIGO === '' || ret.TRNRETENCION_NRO === '' || ret.TRNRETENCION_NRO === null) {
                      this.message.add({
                        key: 'cxctrnabono',
                        severity: 'error',
                        summary: 'Inserción de Abono',
                        detail: 'No se puede insertar el registro por que falta el código o número de retención'
                      });
                      this.spin = false//CDPJ
                      auxiliar1++;
                    }

                    // Verificar número de la retención

                    cont++;
                    if (cont > 1) {
                      if (nroretencion !== ret.TRNRETENCION_NRO) {
                        this.message.add({
                          key: 'cxctrnabono',
                          severity: 'error',
                          summary: 'Error',
                          detail: 'El número de la retención debe ser el mismo'
                        });
                        this.spin = false//CDPJ
                        auxiliar1++;
                      }
                    } else {
                      nroretencion = ret.TRNRETENCION_NRO;
                    }
                  });

                  if (auxiliar1 === 0) {
                    this.guardarCartera();
                  }
                } else {
                  this.guardarCartera();
                }
              }
            } else {
              if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === '') {
                this.message.add({
                  key: 'cxctrnabono',
                  severity: 'error',
                  summary: 'Inserción de Abono',
                  detail: 'Escoja un tipo de documento'
                });
                this.spin = false//CDPJ
                return;
              } else if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO === '') {
                this.message.add({
                  key: 'cxctrnabono',
                  severity: 'error',
                  summary: 'Inserción de Abono',
                  detail: 'Escoja un cliente'
                });
                this.spin = false//CDPJ
                return;
              } else if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_CODIGO === '') {
                this.message.add({
                  key: 'cxctrnabono',
                  severity: 'error',
                  summary: 'Inserción de Abono',
                  detail: 'Escoja un vendedor'
                });
                this.spin = false//CDPJ
                return;
              } else {
                let auxiliar = 0;
                let seleccionados = 0;
                if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length !== 0) {
                  this.cxctrnabonoService.cxctrnresumenarray[this.indicador].map((resumen) => {
                    if (resumen.SELECCIONADO === true) {
                      seleccionados++;
                    }
                  });
                  if (Number(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALDOC) === 0) {
                    this.message.add({
                      key: 'cxctrnabono',
                      severity: 'error',
                      summary: 'Inserción de Abono',
                      detail: 'El total debe ser diferente de cero'
                    });
                    this.spin = false//CDPJ
                    return;
                  }
                  if (seleccionados === 0) {
                    this.message.add({
                      key: 'cxctrnabono',
                      severity: 'error',
                      summary: 'Inserción de Abono',
                      detail: 'Ningún documento ha sido ' +
                        'seleccionado.'
                    });
                    this.spin = false//CDPJ
                    return;
                  }
                }

                /* if (seleccionados === 0) {
                  this.message.add({
                    key: 'cartera',
                    severity: 'error',
                    summary: 'Inserción de Abono',
                    detail: 'Ningún documento ha sido ' +
                      'seleccionado.'
                  });
                  return;
                } */
                if (this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length !== 0) {
                  this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].map((formap) => {
                    if (formap.TRNPAGO_TIPO === 'TA' || formap.TRNPAGO_TIPO === 'CH') { // formap.TRNPAGO_TIPO === 'DP' || formap.TRNPAGO_TIPO === 'CH'
                      if (formap.BANCLI_CODIGO === '' || formap.TRNPAGO_NROCTA === '' || formap.TRNPAGO_NUMERO === '') {
                        this.message.add({
                          key: 'cxctrnabono',
                          severity: 'error',
                          summary: 'Inserción de Abono',
                          detail: 'No se puede insertar el registro por que falta código de banco, número de pago, concepto o número de cuenta'
                        });
                        this.spin = false//CDPJ
                        auxiliar++;
                      }
                    }
                    let fecenc = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN;
                    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN.length !== 10) {
                      fecenc = this.datePipe.transform(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN, 'dd/MM/yyyy');
                    }
                    console.log(2, formap.TRNPAGO_TIPO, formap.TRNPAGO_FECHA, fecenc);
                    /* if ( formap.TRNPAGO_TIPO === 'EF' || formap.TRNPAGO_TIPO === 'TA') { // formap.TRNPAGO_TIPO === 'DP' 
                      if (formap.TRNPAGO_FECHA !== fecenc) {
                        this.message.add({
                          key: 'cartera',
                          severity: 'error',
                          summary: 'Inserción de Abono',
                          detail: 'Fecha de pago incorrecta'
                        });
                        auxiliar++;
                      }
                    } */
                  });
                  if (auxiliar === 0) {
                    this.guardarCartera();
                  }
                } else if (this.cxctrnabonoService.cxctrnretencionarray[this.indicador].length !== 0) {
                  let auxiliar1 = 0;
                  let cont = 0;
                  let nroretencion = '';
                  this.cxctrnabonoService.cxctrnretencionarray[this.indicador].map((ret) => {
                    if (ret.RETENCION_CODIGO === '' || ret.TRNRETENCION_NRO === '' || ret.TRNRETENCION_NRO === null) {
                      this.message.add({
                        key: 'cxctrnabono',
                        severity: 'error',
                        summary: 'Inserción de Abono',
                        detail: 'No se puede insertar el registro por que falta el código o número de retención'
                      });
                      this.spin = false//CDPJ
                      auxiliar1++;
                    }

                    // Verificar número de la retención

                    cont++;
                    if (cont > 1) {
                      if (nroretencion !== ret.TRNRETENCION_NRO) {
                        this.message.add({
                          key: 'cxctrnabono',
                          severity: 'error',
                          summary: 'Error',
                          detail: 'El número de la retención debe ser el mismo'
                        });
                        this.spin = false//CDPJ
                        auxiliar1++;
                      }
                    } else {
                      nroretencion = ret.TRNRETENCION_NRO;
                    }
                  });

                  if (auxiliar1 === 0) {
                    this.guardarCartera();
                  }
                } else {
                  this.guardarCartera();
                }
              }
            }
          }
        } else if (this.booleanNumero === true) {
          if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === '') {
            this.message.add({
              key: 'cxctrnabono',
              severity: 'error',
              summary: 'Inserción de Abono',
              detail: 'Escoja un tipo de documento'
            });
            this.spin = false//CDPJ
            return;
          } else if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO === '') {
            this.message.add({
              key: 'cxctrnabono',
              severity: 'error',
              summary: 'Inserción de Abono',
              detail: 'Escoja un cliente'
            });
            this.spin = false//CDPJ
            return;
          } else if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_CODIGO === '') {
            this.message.add({
              key: 'cxctrnabono',
              severity: 'error',
              summary: 'Inserción de Abono',
              detail: 'Escoja un vendedor'
            });
            this.spin = false//CDPJ
            return;
          } else {
            let seleccionados = 0;
            if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length !== 0) {
              this.cxctrnabonoService.cxctrnresumenarray[this.indicador].map((resumen) => {
                if (resumen.SELECCIONADO === true) {
                  seleccionados++;
                }
              });

              if (seleccionados === 0) {
                this.message.add({
                  key: 'cxctrnabono',
                  severity: 'error',
                  summary: 'Inserción de Abono',
                  detail: 'Ningún documento ha sido ' +
                    'seleccionado.'
                });
                this.spin = false//CDPJ
                return;
              }

              // if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC !== 'NC'
              //   && this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC !== 'RT') {
              //   if (Number(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALDOC) === 0) {
              //     this.message.add({
              //       key: 'cartera',
              //       severity: 'error',
              //       summary: 'Inserción de Abono',
              //       detail: 'El total debe ser diferente de cero'
              //     });
              //     this.spin=false//CDPJ
              //     return;
              //   }
              // }
            }
            if (this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length !== 0) {
              let auxiliar = 0;
              this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].map((formap) => {
                if (formap.TRNPAGO_TIPO === 'TA' || formap.TRNPAGO_TIPO === 'CH') { // formap.TRNPAGO_TIPO === 'DP' || formap.TRNPAGO_TIPO === 'CH'
                  if (formap.BANCLI_CODIGO === '' || formap.TRNPAGO_NROCTA === '' || formap.TRNPAGO_NUMERO === '') {
                    this.message.add({
                      key: 'cxctrnabono',
                      severity: 'error',
                      summary: 'Inserción de Abono',
                      detail: 'No se puede insertar el registro por que falta código de banco, número de pago, concepto o número de cuenta'
                    });
                    this.spin = false//CDPJ
                    auxiliar++;
                  }
                }

                let fecenc = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN;
                if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN.length !== 10) {
                  fecenc = this.datePipe.transform(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN, 'dd/MM/yyyy');
                }
                console.log(4, formap.TRNPAGO_TIPO, formap.TRNPAGO_FECHA, fecenc);
                /* if (formap.TRNPAGO_TIPO === 'EF' || formap.TRNPAGO_TIPO === 'TA') { //formap.TRNPAGO_TIPO === 'DP'
                  if (formap.TRNPAGO_FECHA !== fecenc) {
                    this.message.add({
                      key: 'cartera',
                      severity: 'error',
                      summary: 'Inserción de Abono',
                      detail: 'Fecha de pago incorrecta'
                    });
                    auxiliar++;
                  }
                } */
              });
              if (auxiliar === 0) {
                this.guardarCartera();
              }
            } else if (this.cxctrnabonoService.cxctrnretencionarray[this.indicador].length !== 0) {

              let auxiliar1 = 0;
              let cont = 0;
              let nroretencion = '';
              if (this.verificarImporteTotalRet() === false) {
                auxiliar1++;
              }

              this.cxctrnabonoService.cxctrnretencionarray[this.indicador].map((ret) => {
                if (ret.RETENCION_CODIGO === '' || ret.TRNRETENCION_NRO === '' || ret.TRNRETENCION_NRO === null) {
                  this.message.add({
                    key: 'cxctrnabono',
                    severity: 'error',
                    summary: 'Inserción de Abono',
                    detail: 'No se puede insertar el registro por que falta el código o número de retención'
                  });
                  this.spin = false//CDPJ
                  auxiliar1++;
                }

                // Verificar número de la retención

                cont++;
                if (cont > 1) {
                  if (nroretencion !== ret.TRNRETENCION_NRO) {
                    this.message.add({
                      key: 'cxctrnabono',
                      severity: 'error',
                      summary: 'Error',
                      detail: 'El número de la retención debe ser el mismo'
                    });
                    this.spin = false//CDPJ
                    auxiliar1++;
                  }
                } else {
                  nroretencion = ret.TRNRETENCION_NRO;
                }
              });

              if (auxiliar1 === 0) {
                this.guardarCartera();
              }
            } else {
              this.guardarCartera();
            }
          }
        }
      } else if (this.permisosCartera.PERACTUALIZACION === 0) {
        this.message.add({
          key: 'cxctrnabono',
          severity: 'error',
          summary: 'Actualización de Abono',
          detail: 'El usuario no tiene permisos de actualización, acción denegada'
        });
        this.spin = false//CDPJ
      }
    }

    // if (this.activeIndex === 3) {
    //   this.validacionTiposSri();
    // }
  }
  async guardarCartera() {
    this.editpagofr = true;
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN.toString().includes('-')) {
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN =
        this.datePipe.transform(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN,
          'dd/MM/yyyy');
    } else if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN.toString().includes('/')) {
    }
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHAVENCE.toString().includes('-')) {
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHAVENCE =
        this.datePipe.transform(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHAVENCE,
          'dd/MM/yyyy');
    } else if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHAVENCE.toString().includes('/')) {
    }
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA' ||
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB' ||
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ANC') {
      await this.saveCAABANC();
    }
  }
  async saveCAABANC() {
    console.log('saveCAABANC');
    //GSRF
    let dia = new Date().getDate();
    let mes = new Date().getMonth();
    let anio = new Date().getFullYear();
    for (const item of this.cxctrnabonoService.cxctrnformapagoarray[this.indicador]) {
      dia = new Date().getDate();
      mes = new Date().getMonth();
      anio = new Date().getFullYear();

      console.log('-->', item.CAJ_CODIGO)
      let caja = await this.cxctrnabonoService.getcaja(item.CAJ_CODIGO)
      let numdep = await this.cxctrnabonoService.getDP(item.TRNPAGO_NUMERO, item.BANCLI_CODIGO);
      console.log('-->', item.TRNPAGO_TIPO)
      console.log('-->', caja.length)
      console.log('-->', numdep.length)
      if (item.TRNPAGO_TIPO !== 'DP' && (item.TRNPAGO_TIPO === 'EF' || item.TRNPAGO_TIPO === 'ANCL')) {
        if (caja.length === 0) {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'error',
            summary: 'Inserción de Abono',
            detail: 'Caja no existe'
          });
          this.spin = false//CDPJ
          return;
        }
      }

      if (item.TRNPAGO_TIPO === 'DP') {
        if (item.BANCLI_CODIGO === null || item.BANCLI_CODIGO === '' || item.BANCLI_CODIGO === undefined) {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'error',
            summary: 'Inserción de Abono',
            detail: 'Ingrese Banco'
          });
          this.spin = false//CDPJ
          return;
        }
        if (item.TRNPAGO_NUMERO === null || item.TRNPAGO_NUMERO === '' || item.TRNPAGO_NUMERO === undefined) {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'error',
            summary: 'Inserción de Abono',
            detail: 'Ingrese Número'
          });
          this.spin = false//CDPJ
          return;
        }
        if (numdep.length !== 0) {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'error',
            summary: 'Inserción de Abono',
            detail: 'El número ya existe'
          });
          this.spin = false//CDPJ
          return;
        }
        if (item.TRNPAGO_ORIGEN === 'REG' && Number(item.TRNPAGO_IMPORTE)>Number(item.DETREGCOMPRO_SALDO)) {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'error',
            summary: 'Inserción de Abono',
            detail: 'El importe no puede ser mayor al saldo del comprobante con el que desea cruzar'
          });
          this.spin = false//CDPJ
         // this.control = 0
          //this.btnGuardar = false;
          return;
        }
      }
      
      if (item.TRNPAGO_TIPO === 'ANCL') {
        if (item.TRNPAGO_NUMERO === null || item.TRNPAGO_NUMERO === '' || item.TRNPAGO_NUMERO === undefined) {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'error',
            summary: 'Inserción de Abono',
            detail: 'Ingrese Número'
          });
          this.spin = false//CDPJ
          return;
        }
      }
      try {
        // Verifica el periodo contable
        dia = item.TRNPAGO_FECHA === undefined ? dia : item.TRNPAGO_FECHA.getDate();
        mes = item.TRNPAGO_FECHA === undefined ? mes : item.TRNPAGO_FECHA.getMonth();
        anio = item.TRNPAGO_FECHA === undefined ? anio : item.TRNPAGO_FECHA.getFullYear();
      } catch {
        const tmpfecha = item.TRNPAGO_FECHA.substr(0, 10);
        console.log(tmpfecha);
        const splfec = tmpfecha.split('/');
        const fecha = new Date(splfec[2], splfec[1] - 1, splfec[0]);
        dia = fecha.getDate();
        mes = fecha.getMonth();
        anio = fecha.getFullYear();
      }
      if (await this.utilitariosService.verificarPeriodoContable(dia, mes, anio) === false) {
        this.message.add({
          key: 'cxctrnabono',
          severity: 'info',
          summary: 'Información',
          detail: 'Error, la fecha de la forma de pago debe de estar dentro del período contable'
        });
        this.spin = false//CDPJ
          
        return;
      }
    };


    //GSRF
    if ((Number(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALACOBRAR) !==
      Number(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALFORMAPAGO)) && this.saldoInicial === false) {
      this.message.add({
        key: 'cxctrnabono',
        severity: 'error',
        summary: 'Inserción de Abono',
        detail: 'El total de la forma de pago es distinto al total a cobrar'
      });
      this.spin = false//CDPJ
      return;
    }
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB' ||
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA') {
      console.log('3');
      let numeroDoc = '';
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].BOD_CODIGO = '';
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC === '') {
        console.log('4');
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_IMPORTE =
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALDOC;
        let cobro;
        try {
          cobro = await this.cxctrnabonoService.insertarCobroP(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador],
            this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC);
          console.log('1 Insertar Cobro');
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC = cobro[0].TRNCOBRO_NRODOC;
          if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE === '') {
            console.log(cobro[0]);
            this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE = cobro[0].TRNCOBRO_NRODOC;
          }

          const saldo = await this.cxctrnabonoService.obtenerSaldoClienteP(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO);
          console.log('2 Obtiene saldo cliente');
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].SALDO = saldo[0].SALDO;

          if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length !== 0) {
            for (const resumen of this.cxctrnabonoService.cxctrnresumenarray[this.indicador]) {
              if (resumen.SELECCIONADO === true) {
                resumen.CLI_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO;
                numeroDoc = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC;
                resumen.STRCUOTAFAC = 'F';
                if (resumen.APLORG_CODIGO === 'SISTEMA' && resumen.TRNCOBRO_TIPODOC === 'FC') {
                  resumen.STRCUOTAFAC = 'C';
                }
                await this.cxctrnabonoService.insertarDocPorCobrarP(resumen, this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC,
                  this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE);
                console.log('3 insertarDocPorCobrar');
                if (resumen.APLORG_CODIGO === 'SISTEMA' && resumen.TRNCOBRO_TIPODOC === 'FC') {
                  await this.actualizarCuotasPagadas(resumen);
                  console.log('4 actualizarCuotasPagadas');
                }
                this.auditoriagral.registrarAuditoria('CXC_TRNDOCUMENTO', String(cobro[0].TRNCOBRO_NRODOC + '/' + resumen.TRNCOBRO_NRODOC), 'I',
                  '', '01', '', '', '', '').subscribe(() => {
                  });
              }
            }
          }

          this.auditoriagral.registrarAuditoria('CXC_TRNABONO', String(cobro[0].TRNCOBRO_NRODOC + '/' + cobro[0].TRNCOBRO_NROCOMPROBANTE), 'I',
            '', '01', '', '', '', '').subscribe(() => {
              this.message.add({
                key: 'cxctrnabono',
                severity: 'success',
                summary: 'Inserción de Abono',
                detail: 'Se ha insertado el documento exitosamente'
              });
              this.spin = false//CDPJ
            });

          if (this.cxctrnabonoService.cxctrnretencionarray[this.indicador].length !== 0) {
            for (const ret of this.cxctrnabonoService.cxctrnretencionarray[this.indicador]) {
              ret.CLI_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO;
              if (ret.CON_CODIGO === '') {
                ret.CON_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CON_CODIGO;
              }
              ret.CEN_CODIGO = '';
              ret.ENCFAC_NUMERO = this.numeroFactura;
              await this.cxctrnabonoService.insertarRetencionP(ret, this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC,
                this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE);
              console.log('5 insertarRetencion');
              if (this.retencionElect === true) {
                await this.cxctrnabonoService.actualizarTipoRetencionProm(ret, 'E');
                console.log('6 insertarRetencion');
              } else if (this.retencionElect === false) {
                await this.cxctrnabonoService.actualizarTipoRetencionProm(ret, 'F');
                console.log('6 insertarRetencion');
              }
            }
          }

          if (this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].length !== 0) {
            for (const com of this.cxctrnabonoService.cxctrnotrosgarray[this.indicador]) {
              if (com.CON_CODIGO === '' || com.CON_CODIGO === null) {
                com.CON_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CON_CODIGO;
              }

              await this.cxctrnabonoService.insertarComisionProm(com, this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC,
                this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE);
              console.log('7 insertarComision');

              com.TRNCOBRO_NRODOC = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC;
              this.auditoriagral.registrarAuditoria('SACI_TRNCOMISION', String(com.TRNCOMISION_NRO + '/' + cobro[0].TRNCOBRO_NRODOC), 'I',
                '', '01', '', '', '', '').subscribe(() => {
                });
            }
          }


        } catch (err) {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'error',
            summary: 'Error',
            detail: err.error
          });
          this.spin = false//CDPJ
        }
        try {
          if (this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length !== 0) {
            await this.cxctrnabonoService.eliminarFormaPagoProm(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC);
            console.log('8 eliminarFormaPago');
            for (const formap of this.cxctrnabonoService.cxctrnformapagoarray[this.indicador]) {
              //if (formap.TRNPAGO_TIPO === 'DP') {
              //  await this.cxctrnabonoService.eliminarDPBancoProm(formap.TRNPAGO_NUMERO);
              //  console.log('9 eliminarDPBanco');
              //}
              formap.CLI_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO;
              if (formap.TRNPAGO_CONCEPTO === '' || formap.TRNPAGO_CONCEPTO === null) {
                formap.TRNPAGO_CONCEPTO = '*';
              }

              await this.cxctrnabonoService.insertarFormadePagoProm(formap, this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC,
                this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE);
              console.log('10 insertarFormadePago');
              console.log(formap.TRNPAGO_TIPO);
              if (formap.TRNPAGO_TIPO === 'ANCL') {
                const itemND: Cxctrncobro = {};
                itemND.TRNCOBRO_NRODOC = '';
                itemND.TRNCOBRO_NROCOMPROBANTE = '';
                itemND.TRNCOBRO_FECHATRN = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN;
                itemND.TRNCOBRO_CONCEPTO = 'NOTA DE DEBITO POR EL ANTICIPO ' + formap.TRNPAGO_NUMERO;
                itemND.TRNCOBRO_IMPORTE = formap.TRNPAGO_IMPORTE;
                itemND.TRNCOBRO_FECHAVENCE = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHAVENCE === null ? null :
                  this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHAVENCE;
                itemND.APLORG_CODIGO = 'SISTEMA';
                itemND.TRNCOBRO_REFERENCIAEXTERNA = null;
                itemND.CLI_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO;
                itemND.VEN_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_CODIGO;
                itemND.ASI_NRO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO;
                itemND.USU_IDENTIFICACION = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].USU_IDENTIFICACION;
                itemND.TRNCOBRO_FLAG = '1';
                itemND.BAN_CODIGO = null;
                itemND.TRNCOBRO_EFECTIVO = '0.0';
                itemND.TRNCOBRO_CAMBIO = '0.0';
                itemND.CON_CODIGO = null;
                itemND.TRNCOBRO_SALDOINI = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_SALDOINI;
                itemND.BOD_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].BOD_CODIGO;
                itemND.CEN_CODIGO=this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CEN_CODIGO
                console.log(itemND);
                const data = await this.cxctrnabonoService.insertarCobroP(itemND, 'NDA');
                console.log('11 insertarCobro NDA');
                console.log(data);
                let strNumDocAnt = '';
                let strTrnCobroNroDoc = '';
                let strTrnCobroNroComprobante = '';

                const eR = await this.cxctrnabonoService.erTrncobronrodocProm(formap.TRNPAGO_NUMERO);
                console.log(eR);
                console.log('12 encontrar TRNCOBRO_NRODOC');
                if (eR !== undefined) {
                  if (eR[0].TRNCOBRO_NRODOC !== null) {
                    strNumDocAnt = eR[0].TRNCOBRO_NRODOC;
                  }
                }

                for (const rs of data) {
                  strTrnCobroNroDoc = rs.TRNCOBRO_NRODOC;
                  strTrnCobroNroComprobante = rs.TRNCOBRO_NROCOMPROBANTE;
                }
                // actualizar la referencia de la nota de débito con el número del anticipo strTrnCobroNroDoc
                await this.cxctrnabonoService.actualizarNotaDebitoAnticipoProm(strTrnCobroNroDoc, strNumDocAnt);
                console.log('12 actualizarNotaDebitoAnticipo');
                await this.cxctrnabonoService.actualizarFormaPagoNDProm(strTrnCobroNroDoc,
                  formap.TRNPAGO_NUMERO, this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC);
                console.log('12 actualizarFormaPagoND');
              }
              this.auditoriagral.registrarAuditoria('CXC_TRNPAGO', String(cobro[0].TRNCOBRO_NRODOC + '/' + formap.TRNPAGO_NUMERO), 'I',
                '', '01', '', '', '', '').subscribe(() => {
                });
            }
          }
        } catch (err) {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'error',
            summary: 'Forma de Pago',
            detail: 'No se guardo la forma de pago, error ' + err.error
          });
          this.spin = false//CDPJ
        }
        try {
          await this.cxctrnabonoService.generarAsientoCIProm(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador]);
          console.log('12 generarAsientoCI');
          const res = await this.cxctrnabonoService.getAsientoProm(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC);
          console.log('12 getAsiento', res);
          this.asiento = res[0].ASI_NRO;
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO = this.asiento;
          if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length !== 0) {
            for (const resumen of this.cxctrnabonoService.cxctrnresumenarray[this.indicador]) {
              console.log(resumen);
              if (resumen.SELECCIONADO === true) {
                resumen.CLI_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO;
                await this.cxctrnabonoService.actualizarestadoFacProm(resumen);
                console.log('actualizarestadoFac');
              }
            }
          }
          this.actualizarNumeroAsiento(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO);
          this.auditoriagral.registrarAuditoria('CON_ENCASI_L', String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO + '/CXC'), 'I',
            '', '01', '', '', '', '').subscribe(() => {
              this.message.add({
                key: 'cxctrnabono',
                severity: 'success',
                summary: 'Asiento Contable',
                detail: 'Se ha generado el asiento contable'
              });
              this.spin = false//CDPJ
            });

        } catch (err) {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'error',
            summary: 'Asiento Contable',
            detail: 'No se ha generado el asiento contable, error' + err.error
          });
          this.spin = false//CDPJ
        }

        this.cambiarBotones();
        await this.cancelarEdicionCartera();

        if (this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'NROCMPRAUT').CFG_VALOR1 === 1) {
          this.cxctrnabonoService.actualizarNumeracion(this.numSerie).subscribe((res) => {
            console.log(res);
          });
        }

      } else if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC !== '') {
        this.message.add({
          key: 'cxctrnabono',
          severity: 'error',
          summary: 'Abono',
          detail: 'No es posible actualizar el documento. Elimine y vuelva a ingresar.'
        });
        this.spin = false//CDPJ
        return;

        this.cxctrnabonoService.actualizarCobro(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador],
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC).subscribe((cobro) => {
            this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC = cobro[0].TRNCOBRO_NRODOC;
            this.cxctrnabonoService.obtenerSaldoCliente(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO).subscribe((saldo) => {
              this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].SALDO = saldo[0].SALDO;
              this.cxctrnabonoService.eliminarTrnDocumento('TRNCOBRO_NRODOC = \'' +
                this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC + '\' AND COM_CODIGO = \'01\'').subscribe(() => {
                  if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length !== 0) {
                    this.cxctrnabonoService.cxctrnresumenarray[this.indicador].map((resumen) => {
                      if (resumen.SELECCIONADO === true) {
                        numeroDoc = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC;
                        resumen.CLI_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO;
                        resumen.STRCUOTAFAC = 'F';
                        if (resumen.APLORG_CODIGO === 'SISTEMA' && resumen.TRNCOBRO_TIPODOC === 'FC') {
                          resumen.STRCUOTAFAC = 'C';
                        }
                        this.cxctrnabonoService.insertarDocPorCobrar(resumen, this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC,
                          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE).subscribe(() => {
                            if (resumen.APLORG_CODIGO === 'SISTEMA' && resumen.TRNCOBRO_TIPODOC === 'FC') {
                              this.actualizarCuotasPagadas(resumen);
                            }
                            this.auditoriagral.registrarAuditoria('CXC_TRNDOCUMENTO', String(cobro[0].TRNCOBRO_NRODOC + '/' + resumen.TRNCOBRO_NRODOC), 'I',
                              '', '01', '', '', '', '').subscribe(() => {
                              });
                          });
                      }
                    });
                  }
                  if (this.cxctrnabonoService.cxctrnretencionarray[this.indicador].length !== 0) {
                    this.cxctrnabonoService.eliminarTrnRetencion('TRNCOBRO_NRODOC = \'' +
                      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC +
                      '\' AND COM_CODIGO = \'01\' AND TRNRETENCION_ORIGEN = \'CXC\'').subscribe(() => {
                        this.cxctrnabonoService.cxctrnretencionarray[this.indicador].map((ret) => {
                          ret.CLI_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO;
                          if (ret.CON_CODIGO === '') {
                            ret.CON_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CON_CODIGO;
                          }
                          ret.CEN_CODIGO = '';
                          ret.ENCFAC_NUMERO = this.numeroFactura;
                          this.cxctrnabonoService.insertarRetencion(ret, this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC,
                            this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE).subscribe(() => {
                              if (this.retencionElect === true) {
                                this.cxctrnabonoService.actualizarTipoRetencion(ret, 'E').subscribe(() => {
                                });
                              } else if (this.retencionElect === false) {
                                this.cxctrnabonoService.actualizarTipoRetencion(ret, 'F').subscribe(() => {
                                });
                              }
                            });
                        });
                      });
                  }
                  if (this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].length !== 0) {
                    this.cxctrnabonoService.eliminarTrnComision(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe(() => {
                      this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].map((com) => {
                        if (com.CON_CODIGO === '' || com.CON_CODIGO === null) {
                          com.CON_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CON_CODIGO;
                        }
                        this.cxctrnabonoService.insertarComision(com, this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC,
                          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE).subscribe(() => {
                            com.TRNCOBRO_NRODOC = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC;
                            this.auditoriagral.registrarAuditoria('SACI_TRNCOMISION', String(com.TRNCOMISION_NRO + '/' + cobro[0].TRNCOBRO_NRODOC), 'I',
                              '', '01', '', '', '', '').subscribe(() => {
                              });
                          });
                      });
                    });
                  }
                  if (this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length !== 0) {
                    this.cxctrnabonoService.eliminarFormaPago(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe(() => {
                      this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].map((formap) => {
                        if (formap.TRNPAGO_TIPO === 'DP') {
                          this.cxctrnabonoService.eliminarDPBanco(formap.TRNPAGO_NUMERO).subscribe(() => {
                          });
                        }
                        formap.CLI_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO;
                        if (formap.TRNPAGO_CONCEPTO === '' || formap.TRNPAGO_CONCEPTO === null) {
                          formap.TRNPAGO_CONCEPTO = '*';
                        }
                        this.cxctrnabonoService.insertarFormadePago(formap, this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC,
                          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE).subscribe(async () => {
                            if (formap.TRNPAGO_TIPO === 'ANCL') {
                              const itemND: Cxctrncobro = {};
                              itemND.TRNCOBRO_NRODOC = '';
                              itemND.TRNCOBRO_NROCOMPROBANTE = '';
                              itemND.TRNCOBRO_FECHATRN = this.datePipe.transform(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN, 'dd/MM/yyyy');
                              itemND.TRNCOBRO_CONCEPTO = 'NOTA DE DEBITO POR EL ANTICIPO ' + formap.TRNPAGO_NUMERO;
                              itemND.TRNCOBRO_IMPORTE = formap.TRNPAGO_IMPORTE;
                              itemND.TRNCOBRO_FECHAVENCE = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHAVENCE === null ? null :
                                this.datePipe.transform(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHAVENCE, 'dd/MM/yyyy');
                              itemND.APLORG_CODIGO = 'SISTEMA';
                              itemND.TRNCOBRO_REFERENCIAEXTERNA = null;
                              itemND.CLI_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO;
                              itemND.VEN_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_CODIGO;
                              itemND.ASI_NRO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO;
                              itemND.USU_IDENTIFICACION = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].USU_IDENTIFICACION;
                              itemND.TRNCOBRO_FLAG = '1';
                              itemND.BAN_CODIGO = null;
                              itemND.TRNCOBRO_EFECTIVO = '0.0';
                              itemND.TRNCOBRO_CAMBIO = '0.0';
                              itemND.CON_CODIGO = null;
                              itemND.TRNCOBRO_SALDOINI = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_SALDOINI;
                              itemND.BOD_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].BOD_CODIGO;

                              let strNumDocAnt = '';

                              const eRf = await this.cxctrnabonoService.erTrnpagorefer(formap.TRNCOBRO_NRODOC);
                              if (eRf !== null) {
                                for (const rs of eRf) {
                                  strNumDocAnt = rs.TRNPAGO_REFER;
                                }
                              }

                              console.log(strNumDocAnt);
                              let data: any;
                              if (strNumDocAnt === '') {
                                let strTrnCobroNroDoc = '';
                                let strTrnCobroNroComprobante = '';
                                data = await this.cxctrnabonoService.insertarCobroP(itemND, 'NDA');
                                console.log('11 insertarCobro NDA');
                                console.log(data);
                                const eR = await this.cxctrnabonoService.erTrncobronrodocProm(formap.TRNPAGO_NUMERO);
                                console.log(eR);
                                console.log('12 encontrar TRNCOBRO_NRODOC');
                                if (eR !== undefined) {
                                  if (eR[0].TRNCOBRO_NRODOC !== null) {
                                    strNumDocAnt = eR[0].TRNCOBRO_NRODOC;
                                  }
                                }
                                for (const rs of data) {
                                  strTrnCobroNroDoc = rs.TRNCOBRO_NRODOC;
                                  strTrnCobroNroComprobante = rs.TRNCOBRO_NROCOMPROBANTE;
                                }
                                // actualizar la referencia de la nota de débito con el número del anticipo strTrnCobroNroDoc
                                await this.cxctrnabonoService.actualizarNotaDebitoAnticipoProm(strTrnCobroNroDoc, strNumDocAnt);
                                console.log('12 actualizarNotaDebitoAnticipo');
                                await this.cxctrnabonoService.actualizarFormaPagoNDProm(strTrnCobroNroDoc,
                                  formap.TRNPAGO_NUMERO, this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC);
                                console.log('12 actualizarFormaPagoND');
                              } else {
                                data = await this.cxctrnabonoService.actualizarCobroProm(itemND, 'NDA');
                                console.log('11 actualizarCobro NDA');
                              }
                            }
                            this.cxctrnabonoService.generarAsientoCI(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador]).subscribe(() => {
                              this.cxctrnabonoService.getAsiento(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe((res) => {
                                this.asiento = res[0].ASI_NRO;
                                this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO = this.asiento;
                                if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length !== 0) {
                                  this.cxctrnabonoService.cxctrnresumenarray[this.indicador].map((resumen) => {
                                    if (resumen.SELECCIONADO === true) {
                                      resumen.CLI_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO;
                                      this.cxctrnabonoService.actualizarestadoFac(resumen).subscribe(() => {
                                      }, error1 => {
                                        console.log(error1.error);
                                      });
                                    }
                                  });
                                }
                                this.auditoriagral.registrarAuditoria('CON_ENCASI_L', String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO + '/CXC'), 'I',
                                  '', '01', '', '', '', '').subscribe(() => {
                                  });
                              });
                            }, () => {
                            });
                            this.auditoriagral.registrarAuditoria('CXC_TRNPAGO', String(cobro[0].TRNCOBRO_NRODOC + '/' + formap.TRNPAGO_NUMERO), 'I',
                              '', '01', '', '', '', '').subscribe(() => {
                              });
                          }, error1 => {
                            this.message.add({
                              key: 'cxctrnabono',
                              severity: 'error',
                              summary: 'Forma de Pago',
                              detail: 'No se guardo la forma de pago, error ' + error1.error
                            });
                          });
                      });
                    });
                  }
                  this.auditoriagral.registrarAuditoria('CXC_TRNCOBRO', String(cobro[0].TRNCOBRO_NRODOC + '/' + cobro[0].TRNCOBRO_NROCOMPROBANTE), 'A',
                    '', '01', '', '', '', '').subscribe(() => {
                      this.message.add({
                        key: 'cxctrnabono',
                        severity: 'success',
                        summary: 'Inserción de Abono',
                        detail: 'Se ha insertado el documento exitosamente'
                      });
                    });
                  this.cambiarBotones();
                  this.cancelarEdicionCartera();
                  setTimeout(() => {
                    this.cxctrnabonoService.generarAsientoCI(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador]).subscribe(() => {
                      this.cxctrnabonoService.getAsiento(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe((res) => {
                        this.asiento = res[0].ASI_NRO;
                        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO = this.asiento;
                        if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length !== 0) {
                          this.cxctrnabonoService.cxctrnresumenarray[this.indicador].map((resumen) => {
                            if (resumen.SELECCIONADO === true) {
                              resumen.CLI_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO;
                              this.cxctrnabonoService.actualizarestadoFac(resumen).subscribe(() => {
                              }, error1 => {
                                console.log(error1.error);
                              });
                            }
                          });
                        }
                        this.auditoriagral.registrarAuditoria('CON_ENCASI_L', String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ASI_NRO + '/CXC'), 'I',
                          '', '01', '', '', '', '').subscribe(() => {
                            this.message.add({
                              key: 'cxctrnabono',
                              severity: 'success',
                              summary: 'Asiento Contable',
                              detail: 'Se ha generado el asiento contable'
                            });
                          });
                      });
                    }, error1 => {
                      this.message.add({
                        key: 'cxctrnabono',
                        severity: 'error',
                        summary: 'Asiento Contable',
                        detail: 'No se ha generado el asiento, error ' + error1.error
                      });
                    });
                  }, 500);
                });
            });
            // this.cambiarBotones();
            // this.consultarPestañas();
          });
      }
    }
  }
  mensajeAlerta(tipo, titulo, msg) {
    this.message.add({
      key: 'cxctrnabono',
      severity: tipo,
      summary: titulo,
      detail: msg
    });
  }
  cambiarBotones() {
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;
    this.botonBuscar = false;
    this.botonAsiento = false;
    this.botonVerAsiento = false;
    this.botonAnular = false;
  }
  async actualizarNumeroComprobante(strAsiNro) {
    if (this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'NUMASICOM').CFG_VALOR1 === 0) {
      return;
    }

    if (strAsiNro === '') {
      return;
    }

    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE !== '') {//si no esta en blanco el comprobante lo respeta
      return;
    }

    try {
      await this.cxctrnabonoService.actualizarNumeroComprobante(strAsiNro, this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC);
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE = strAsiNro;
    } catch (err) {
      this.spin = false//CDPJ
      this.mensajeAlerta('error', 'Error', '! Proceso actualiza numero de comprobante  no terminó satisfactoriamente.... ! ' + err.error);
    }

  }
  async verificarComprobanteUnico() {
    let bolVerificar = true;
    const strParam: any[] = [];
    if (this.bolNuevo) {
      strParam[0] = 'N';
      strParam[3] = '';
    } else {
      strParam[0] = 'M';
      if (this.cxctrnresumen.length > 0) {
        strParam[3] = this.cxctrnresumen[0].TRNCOBRO_NRODOC;
      } else {
        strParam[3] = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC;
      }
    }

    strParam[1] = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE;
    strParam[2] = '01';
    /*try {
      const rs = await this.cxctrnabonoService.verificarComprobanteUnicoNew(strParam);
      console.log(rs[0]["'0'"]);
      console.log(rs[0][':B1']);
      if (rs[0][':B1'] !== undefined) {
        bolVerificar = false;
      }
			/*if (rs.next()) {
				if (!rs.getString(1).equals("0"))
					bolVerificar = false;
			} 
    }*//* catch (err) {
      let mensaje: string;
      mensaje = this.errorService.generarMensajeErrorCompleto(err.error);
      this.mensajeAlerta('error', 'Error', 'No se puede verificar si el comprobante es único ' + mensaje);
    }*/
    return bolVerificar;
  }
  controlarFechaforpago() {
    let bolCorrecto = true;
    let strFechaDoc = this.obtenerFechaDoc();
    for (const item of this.cxctrnabonoService.cxctrnresumenarray[this.indicador]) {
      if (item.SELECCIONADO !== null) {
        if (item.SELECCIONADO) {
          const strFechaFact = this.dateValidation(item.TRNCOBRO_FECHATRN);
          for (const item1 of this.cxctrnabonoService.cxctrnformapagoarray[this.indicador]) {
            if (item1.TRNPAGO_TIPO !== null) {
              const strFechaFact1 = this.dateValidation(item1.TRNPAGO_FECHA);
              // console.log(strFechaFact1.getTime() > strFechaFact.getTime());
              //console.log(strFechaFact1.getTime(), strFechaFact.getTime());
              if (strFechaFact.getTime() > strFechaFact1.getTime()) {
                bolCorrecto = false;
              }
            }
          }
        }
      }
    };

    return bolCorrecto;
  }
  verificarImporteTotalRet(): boolean {
    let bolVerificar = true;
    for (const itemDoc of this.cxctrnabonoService.cxctrnresumenarray[this.indicador]) {

      if (itemDoc.SELECCIONADO === true) {
        let dblTotalRet = 0;
        for (const itemRet of this.cxctrnabonoService.cxctrnretencionarray[this.indicador]) {

          if (itemDoc.TRNCOBRO_NRODOC === itemRet.ENCFAC_NUMERO) {
            dblTotalRet = dblTotalRet + Number(itemRet.TRNRETENCION_TOTALRETENIDO);
          }
        }

        dblTotalRet = Number(Number(dblTotalRet).toFixed(2));

        if (Number(itemDoc.TRNCOBRO_IMPORTE) != dblTotalRet) {
          this.mensajeAlerta('error', 'Error', 'El importe de la factura ' + itemDoc.TRNCOBRO_NRODOC +
            ' no es igual al total de las retenciones');
          bolVerificar = false;
          return bolVerificar;
        }
      }
    }

    return bolVerificar;
  }
  controlarFechaCobro() {
    let bolCorrecto = true;
    let strFechaDoc = this.obtenerFechaDoc();

    for (const item of this.cxctrnabonoService.cxctrnresumenarray[this.indicador]) {
      if (item.SELECCIONADO !== null) {
        if (item.SELECCIONADO) {
          const strFechaFact = this.dateValidation(item.TRNCOBRO_FECHATRN);
          console.log(strFechaFact.getTime() > strFechaDoc.getTime());
          console.log(strFechaFact.getTime(), strFechaDoc.getTime());
          if (strFechaFact.getTime() > strFechaDoc.getTime()) {
            bolCorrecto = false;
          }
        }
      }
    }

    return bolCorrecto;
  }
  obtenerFechaDoc() {
    let strFecha: any = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN;
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN.toString().includes('-')) {
      strFecha = this.datePipe.transform(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN,
        'dd/MM/yyyy');
    }
    const fechaAct = String(strFecha).split('/');
    const fechaNew = new Date(Number(fechaAct[2]), Number(fechaAct[1]) - 1, Number(fechaAct[0]));

    return fechaNew;
  }
  dateValidation(fecha) {
    let strFecha: any = fecha;
    if (fecha.toString().includes('-')) {
      strFecha = this.datePipe.transform(fecha, 'dd/MM/yyyy');
    }
    const fechaAct = String(strFecha).split('/');
    const fechaNew = new Date(Number(fechaAct[2]), Number(fechaAct[1]) - 1, Number(fechaAct[0]));

    return fechaNew;
  }
  seleccionarCartera() {
    this.obtenerDatos(this.facturaPend.TRNCOBRO_NRODOC);
    this.dialogFacCanceladas = false;
  }
  abrirClientesFacAbonadas() {
    this.opcion = 'BUSQUEDACLIFAC';
    this.types = [
      { label: 'Código', value: 'CLI_CODIGO' },
      { label: 'Nombre', value: 'CLI_NOMBRE' },
      { label: 'RUCIDE', value: 'CLI_RUCIDE' },
      { label: 'Zona', value: 'ZONA_NOMBRE' },
      { label: 'Vendedor', value: 'VEN_NOMBRE' },
      { label: 'Grupo', value: 'GRU_CODIGO' },
      { label: 'Contacto', value: 'CLI_CONTACTO' },
      { label: 'Placa', value: 'CLI_PLACA' },
      { label: 'Nombreec', value: 'CLI_NOMBREC' },
    ];
    this.busquedacampos = [this.codClienteFac, '', '', '', '', '', '', '', ''];
    this.tabla = 'VEN_MAECLIENTE';
    this.consulta = 'ven_maecliente.*,  VEN_FNC_NOMBRE_VENDEDOR(VEN_CODIGO) AS' +
      ' VEN_NOMBRE, VEN_FNC_OBTENER_ZONACLI(CLI_ZONA) AS ZONA_NOMBRE';
    this.where = '';
    this.spin = true;
    this.busquedaSer.busquedaVenMaeCliente1(this.codClienteFac).subscribe((datos: any[]) => {
      this.arregloCons = datos;
      this.spin = false;
      this.displayDialogBusquedaFast = true;
    });
  }
  busquedaCentroCostos(){
    this.opcion='BUSCENCODIGO'
    this.types = [
      { label: 'CÓDIGO', value: 'CEN_CODIGO' },
      { label: 'NOMBRE', value: 'CEN_NOMBRE' }
    ];

    this.busquedacampos = ['', ''];
    this.consulta = `CEN_CODIGO ,CEN_NOMBRE`;
    this.tabla = 'CON_MAECEN';
    this.where = ' ROWNUM<=50 ORDER BY CEN_CODIGO ';


    this.cxctrnabonoService.busquedaCentroCostos(this.consulta, this.where).then((res: any[]) => {


      this.arregloCons = [...res];
      this.displayDialogBusquedaFast = true;
    }).catch(e => {

      let mensaje: string;
      //mensaje = this.errorService.generarMensajeErrorCompleto(e.error);
      this.mensajeAlerta('error', 'Error', `Ha Ocurrido Un Error En La Transacción: ${e.error}`);
    });
  }
  isEdit(data): boolean {
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC !== '' && this.editpagofr === true) {
      return false;
    }
    return true;
  }
  idEditcajcodigoFormapago(data): boolean {
    console.log(data.TRNCAJ_TIPO)
    if ((this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC !== '' && this.editpagofr === true) ||
      ((this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA' || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB') && (data.TRNPAGO_TIPO === 'DP'))) {
      console.log('entro')
      return false;
    } else {
      return true;
    }
  }
  seleccionDocumento(valor) {
    /*if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB' ||
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA' ||
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'RT') {
      
      if (valor.object !== undefined) {
        this.numeroFactura = valor.object.TRNCOBRO_NRODOC;
      }
    }*/
  }
  seleccionRetencion(valor) {
    if (valor === 'nuevo') {
      this.nuevaRetencion();
    } else if (valor === 'eliminar') {
      this.confirmarEliminarRetencion();
    } else if (valor === 'cancelar') {
      this.cancelarRetencion();
    }
    if (valor.object !== undefined) {
      this.detalleRetencionSeleccionado = valor.object;
    }
  }
  seleccionGastos(valor) {
    if (valor === 'nuevo') {
      this.nuevosGastos();
    } else if (valor === 'eliminar') {
      this.confirmarEliminarOtrosG();
    } else if (valor === 'cancelar') {
      this.cancelarOtrosG();
    }
    if (valor.object !== undefined) {
      this.detalleOtrasFSeleccionada = valor.object;
    }
  }

  seleccionFormaPago(valor) {
    if (valor === 'nuevo') {
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].APLORG_CODIGO !== 'CXC') {
        return;
      }
      this.nuevaFormaPago();
    } else if (valor === 'eliminar') {
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].APLORG_CODIGO !== 'CXC') {
        return;
      }
      //GSRF
      console.log('entra-*-*-*-*-*', this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC)
      console.log('entra-*-*-*-*-*', this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC)
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC !== ''
        && this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC !== null
        && this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC !== undefined) {
        if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB'
          || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA') {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'error',
            summary: 'Abono',
            detail: 'No es posible eliminar la forma de pago. Elimine el documento y vuelva a ingresar.'
          });
          return;
        }

      }
      //GSRF
      this.confirmarEliminarFormaPago();
    } else if (valor === 'cancelar') {
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].APLORG_CODIGO !== 'CXC') {
        return;
      }
      this.cancelarFormaPago();
    } else if (valor === 'generaconcepto') {
      let seleccionados = 0;
      if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length !== 0) {
        this.cxctrnabonoService.cxctrnresumenarray[this.indicador].map((resumen) => {
          if (resumen.SELECCIONADO === true) {
            seleccionados++;
          }
        });
      } else {
        this.message.add({
          key: 'cxctrnabono',
          severity: 'error',
          summary: 'Inserción de Abono',
          detail: 'Ningún documento ha sido ' +
            'seleccionado. '
        });
        this.spin = false//CDPJ
        return;
      }
      if (seleccionados === 0) {
        this.message.add({
          key: 'cxctrnabono',
          severity: 'error',
          summary: 'Inserción de Abono',
          detail: 'Ningún documento ha sido ' +
            'seleccionado.'
        });
        this.spin = false//CDPJ
        return;
      }
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].APLORG_CODIGO !== 'CXC') {
        return;
      } else if (this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length === 0) {
        this.message.add({
          key: 'cxctrnabono',
          severity: 'error',
          summary: 'Abono',
          detail: 'Ingrese una forma de pago al detalle'
        });
        return;
      }
      this.generarconcepto()
    }else if (valor === 'regcomp') {
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB' ||
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA') {
        if (this.detalleFormaPago !== null && this.detalleFormaPago !== undefined) {
          if (this.detalleFormaPago.TRNPAGO_TIPO === '') {
            this.listarRegcomp();
          } else {
            this.mensajeAlerta('info', 'Información', 'Es necesario seleccionar una línea vacía');
          }
        } else {
          this.mensajeAlerta('info', 'Información', 'Es necesario seleccionar una línea del detalle');
        }
      }
    }
    if (valor.object !== undefined) {
      this.detalleFormaPago = valor.object;
    }
  }
  listarRegcomp() {
    this.editpagofr = true;
    this.opcion = 'BUSCARREGCOMP';
    this.busquedaCompuesta = false;
    this.types = [
      
      { label: 'Comprobante', value: 'DETREGCOMPRO_COMPROBANTE' },
      { label: 'Cod. Banco', value: 'BAN_CODIGO' },
      { label: 'Nom. Banco', value: 'BAN_NOMBRE' },
      { label: 'Referencia', value: 'DETREGCOMPRO_REFERENCIA' },
      { label: 'Importe',   value: 'DETREGCOMPRO_SALDO' },

    ];
    this.busquedacampos = ['', '', '', '',''];
    this.tabla = 'CXC_DETREGCOMPRO';
    this.consulta = 'CXC_DETREGCOMPRO.*, BAN_FNC_NOMBRE_BANCO(BAN_CODIGO,\'01\') AS BAN_NOMBRE,'
    this.consulta = this.consulta + ' BAN_FNC_OBTIENECONCODBAN (BAN_CODIGO,\'01\') AS CON_CODIGO';

    this.where = 'CLI_CODIGO=\'' + this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO + '\'' + ' and DETREGCOMPRO_SALDO>0';

    this.spin = true;
    this.busquedaSer.busquedaCXCregComp(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO).subscribe((res: any[]) => {
      this.arregloCons = res;
      // this.arregloCons.map((registro) => {
      //   if (registro.TRNCOBRO_IMPORTE !== null) {
      //     registro.TRNCOBRO_IMPORTE = Number(registro.TRNCOBRO_IMPORTE).toFixed(2);
      //   }
      //   if (registro.TRNCOBRO_FECHATRN !== null) {
      //     registro.TRNCOBRO_FECHATRN = this.datePipe.transform(registro.TRNCOBRO_FECHATRN, 'dd/MM/yyyy');
      //   } else {
      //     registro.TRNCOBRO_FECHATRN = '';
      //   }
      //   if (registro.TRNCOBRO_FECHAVENCE !== null) {
      //     registro.TRNCOBRO_FECHAVENCE = this.datePipe.transform(registro.TRNCOBRO_FECHAVENCE, 'dd/MM/yyyy');
      //   } else {
      //     registro.TRNCOBRO_FECHAVENCE = '';
      //   }
      // });
      this.spin = false;
      this.displayDialogBusquedaFast = true;
    });
  }
  nuevaRetencion() {
    if (this.numeroFactura !== '') {
      let intNumRet = 0;
      this.cxctrnabonoService.erCountSacitrnretencion(this.numeroFactura).subscribe(er => {
        if (er !== null) {
          if (er[0] !== undefined) {
            intNumRet = Number(er[0].COUN);
          }
        }

        if (intNumRet > 0) {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'error',
            summary: 'Información',
            detail: 'La factura ya tiene ingresada una retención.'
          });
        } else {
          this.editpagofr = false;
          this.btnNuevoGrid = true;
          this.btnGuardarGrid = false;
          this.btnBorrarGrid = false;
          this.btnCancelarGrid = false;
          const linea = this.cxctrnabonoService.cxctrnretencionarray[this.indicador].length;
          const nuevodetalle = {
            RETENCION_CODIGO: '',
            TRNRETENCION_DESCRIPCION: '',
            TRNRETENCION_NRO: '',
            TRNRETENCION_BASE: 0,
            TRNRETENCION_PORCENTAJE: 0,
            TRNRETENCION_TOTALRETENIDO: 0,
            ENCFAC_NUMERO: this.numeroFactura,
            CLI_CODIGO: this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO,
            CEN_CODIGO: '',
            CON_CODIGO: '',
            TRNRETENCION_ORIGEN: 'CXC',
            LINEA: String(linea + 1),
            NUEVALINEA: 0//CDPJ
          };
          if (this.detalleRetencionSeleccionado !== undefined && this.detalleRetencionSeleccionado !== null) {
            const indi = this.cxctrnabonoService.cxctrnretencionarray[this.indicador].indexOf(this.detalleRetencionSeleccionado);
            if (indi === -1) {
              this.cxctrnabonoService.cxctrnretencionarray[this.indicador].push(nuevodetalle);
              this.detalleRetencionSeleccionado = this.cxctrnabonoService.cxctrnretencionarray[this.indicador][this.cxctrnabonoService.cxctrnretencionarray[this.indicador].length - 1];
              this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnretencionarray[this.indicador], this.defaultColumnDefAbonoRet.objeto);
              this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColumnDefAbonoRet.objeto].setFocusedCell(this.cxctrnabonoService.cxctrnretencionarray[this.indicador].length - 1, 'RETENCION_CODIGO');
            } else {
              //CDPJ
              this.cxctrnabonoService.cxctrnretencionarray[this.indicador].splice(indi + 1, 0, nuevodetalle);
              this.detalleRetencionSeleccionado = nuevodetalle;
              this.aggrid.refreshaggridindex(this.cxctrnabonoService.cxctrnretencionarray[this.indicador], this.defaultColumnDefAbonoRet.objeto, indi);
              //CDPJ
              this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColumnDefAbonoRet.objeto].setFocusedCell(indi + 1, 'RETENCION_CODIGO');
            }
          }
        }
      });
    } else {
      this.editpagofr = false;
      this.btnNuevoGrid = false;
      this.btnGuardarGrid = false;
      this.btnBorrarGrid = false;
      this.btnCancelarGrid = false;
      this.message.add({
        key: 'cxctrnabono',
        severity: 'error',
        summary: 'Información',
        detail: 'Escoja una factura...'
      });
    }
  }

  nuevosGastos() {
    this.editpagofr = false;
    this.btnNuevoGrid = true;
    this.btnGuardarGrid = false;
    this.btnBorrarGrid = false;
    this.btnCancelarGrid = false;
    const linea = this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].length;
    const nuevodetalle = {
      COMISION_CODIGO: '',
      TRNCOMISION_DESCRIPCION: '',
      TRNCOMISION_NRO: '',
      TRNCOMISION_TOTALRETENIDO: 0,
      LINEA: String(linea + 1),
      TRNCOMISION_BASE: 0,
      TRNCOMISION_PORCENTAJE: 0,
      TRNCOBRO_NRODOC: this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC,
      TRNCOMISION_ORIGEN: 'CXC',
      CLI_CODIGO: this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO,
      CON_CODIGO: '',
      TRNCOBRO_NROCOMPROBANTE: this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE,
      TRNCOMISION_FLAG: ''
    };
    if (this.detalleOtrasFSeleccionada !== undefined && this.detalleOtrasFSeleccionada !== null) {
      const indi = this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].indexOf(this.detalleOtrasFSeleccionada);
      if (indi === -1) {
        this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].push(nuevodetalle);
        this.detalleOtrasFSeleccionada = this.cxctrnabonoService.cxctrnotrosgarray[this.indicador][this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].length - 1];
        this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnotrosgarray[this.indicador], this.defaultColumnDefAbonoOtrosG.objeto);
        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColumnDefAbonoOtrosG.objeto].setFocusedCell(this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].length - 1, 'COMISION_CODIGO');
      } else {
        this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].splice(indi + 1, 0, nuevodetalle);
        this.aggrid.refreshaggridindex(this.cxctrnabonoService.cxctrnotrosgarray[this.indicador], this.defaultColumnDefAbonoOtrosG.objeto, indi);
        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColumnDefAbonoOtrosG.objeto].setFocusedCell(indi + 1, 'COMISION_CODIGO');
      }
    }
  }

  nuevaFormaPago() {
    this.editpagofr = false;
    this.btnNuevoGrid = true;
    this.btnGuardarGrid = false;
    this.btnBorrarGrid = false;
    this.btnCancelarGrid = false;
    const linea = this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length;
    const nuevodetalle = {
      TRNCOBRO_NRODOC: '',
      TRNPAGO_TIPO: '',
      CAJ_CODIGO: '',
      TRNPAGO_NUMERO: '',
      TRNPAGO_CONCEPTO: this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_CONCEPTO,
      TRNPAGO_IMPORTE:
        Number(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALACOBRAR) - Number(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALFORMAPAGO),
      BANCLI_CODIGO: '',
      BANCLI_NOMBRE: '',
      TRNPAGO_NROCTA: '',
      TRNPAGO_CODSRI: '',
      TRNPAGO_TIPDIS: '',
      TRNPAGO_FECHA: this.datePipe.transform(new Date(), 'dd/MM/yyyy'),
      CON_CODIGO: '',
      CLI_CODIGO: this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO,
      TRNCHEPOS_NUMDOC: '',
      LINEA: String(linea + 1),
      TRNPAGO_ORIGEN:'CXC'
    };
    this.detalleFormaPago = nuevodetalle;
    if (this.detalleFormaPago !== undefined && this.detalleFormaPago !== null) {
      const indi = this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].indexOf(this.detalleFormaPago);
      if (indi === -1) {
        this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].push(nuevodetalle);
        this.detalleFormaPago = this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length - 1];
        this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnformapagoarray[this.indicador], this.defaultColumnDefAbonoFormaPago.objeto);
        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColumnDefAbonoFormaPago.objeto].setFocusedCell(this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length - 1, 'TRNPAGO_TIPO');
        this.cxctrnabonoService.calcularTotalFormaPago();
      } else {
        this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].splice(indi + 1, 0, nuevodetalle);
        this.aggrid.refreshaggridindex(this.cxctrnabonoService.cxctrnformapagoarray[this.indicador], this.defaultColumnDefAbonoFormaPago.objeto, indi);
        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColumnDefAbonoFormaPago.objeto].setFocusedCell(indi + 1, 'TRNPAGO_TIPO');
        this.cxctrnabonoService.calcularTotalFormaPago();
      }
    }
  }
  confirmarEliminarRetencion() {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea eliminar el registro seleccionado',
      header: 'Confirmación',
      icon: 'pi pi-exclamation-triangle',
      key: 'confCxctrnabono',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.confirmationService.close();
        this.eliminarRetencion();
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  eliminarRetencion() {
    if (this.detalleRetencionSeleccionado !== undefined) {
      this.editpagofr = false;
      this.btnNuevoGrid = false;
      this.btnGuardarGrid = false;
      this.btnBorrarGrid = false;
      this.btnCancelarGrid = false;
      if (this.detalleRetencionSeleccionado.NUEVALINEA === 0) {
        this.cxctrnabonoService.cxctrnretencionarray[this.indicador] = this.cxctrnabonoService.cxctrnretencionarray[this.indicador].filter((val, j) => j !==
          this.cxctrnabonoService.cxctrnretencionarray[this.indicador].indexOf(this.detalleRetencionSeleccionado));
        this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnretencionarray[this.indicador], this.defaultColumnDefAbonoRet.objeto);
        this.cxctrnabonoService.calcularTotalRetenido(0);
      } else {
        // this.cxctrnabonoService.eliminarTrnRetencion('TRNCOBRO_NRODOC = \'' +
        //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC + '\' AND COM_CODIGO = \'01\' AND TRNRETENCION_ORIGEN = \'CXC\'').subscribe(() => {
        //     this.cxctrnabonoService.cxctrnretencionarray[this.indicador] = this.cxctrnabonoService.cxctrnretencionarray[this.indicador].filter((val, j) => j !==
        //       this.cxctrnabonoService.cxctrnretencionarray[this.indicador].indexOf(this.detalleRetencionSeleccionado));
        //     this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnretencionarray[this.indicador], this.defaultColumnDefAbonoRet.objeto);
        //     this.cxctrnabonoService.calcularTotalRetenido(0);
        //   });
        this.message.add({
          key: 'cxctrnabono',
          severity: 'error',
          summary: 'Abono',
          detail: 'No es posible eliminar las retenciones guardadas. Elimine y vuelva a ingresar todo el documento.'
        });
        return;
      }
    }
  }
  cancelarRetencion() {
    if (this.detalleRetencionSeleccionado.LINEA === 0) {
      this.btnNuevoGrid = false;
      this.btnGuardarGrid = true;
      this.cxctrnabonoService.cxctrnretencionarray[this.indicador] = this.cxctrnabonoService.cxctrnretencionarray[this.indicador].filter((val, j) => j !==
        this.cxctrnabonoService.cxctrnretencionarray[this.indicador].indexOf(this.detalleRetencionSeleccionado));
      this.detalleFormaPago = {};
    } else if (this.detalleRetencionSeleccionado.LINEA !== 0) {
      this.btnNuevoGrid = false;
      this.btnGuardarGrid = true;
      this.cxctrnabonoService.obtenerRetenciones(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe((res) => {
        this.cxctrnabonoService.cxctrnretencionarray[this.indicador] = res;
        this.cxctrnabonoService.cxctrnretencionarray[this.indicador].map((detalle) => {
          if (detalle.LINEA === this.detalleRetencionSeleccionado.LINEA) {
            this.detalleRetencionSeleccionadoAux
              = detalle;
          }
        });
        this.detalleRetencionSeleccionado = this.detalleRetencionSeleccionadoAux;
        this.cxctrnabonoService.calcularTotalRetenido(0);
      });
    }
  }
  confirmarEliminarOtrosG() {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea eliminar el registro seleccionado',
      header: 'Confirmación',
      icon: 'pi pi-exclamation-triangle',
      key: 'confCxctrnabono',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.confirmationService.close();
        this.eliminarOtrosG();
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  eliminarOtrosG() {
    if (this.detalleOtrasFSeleccionada !== undefined) {
      this.editpagofr = false;
      this.btnNuevoGrid = false;
      this.btnGuardarGrid = false;
      this.btnBorrarGrid = false;
      this.btnCancelarGrid = false;
      if (this.detalleOtrasFSeleccionada.TRNCOBRO_NRODOC === '') {
        this.cxctrnabonoService.cxctrnotrosgarray[this.indicador] = this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].filter((val, j) => j !==
          this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].indexOf(this.detalleOtrasFSeleccionada));
        this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnotrosgarray[this.indicador], this.defaultColumnDefAbonoOtrosG.objeto);
        this.cxctrnabonoService.calcularTotalOtrosG();
      } else {
        this.cxctrnabonoService.eliminarCaja(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe(() => {
          this.auditoriagral.registrarAuditoria('BAN_TRNCAJ', String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC), 'E',
            '', '01', '', '', '', '').subscribe(() => {
            });
        });
        this.cxctrnabonoService.eliminarBanco(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe(() => {
          this.auditoriagral.registrarAuditoria('BAN_TRNBAN', String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC), 'E',
            '', '01', '', '', '', '').subscribe(() => {
            });
        });
        this.cxctrnabonoService.cxctrnotrosgarray[this.indicador] = this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].filter((val, j) => j !==
          this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].indexOf(this.detalleFormaPago));
        this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnotrosgarray[this.indicador], this.defaultColumnDefAbonoOtrosG.objeto);
        this.cxctrnabonoService.calcularTotalOtrosG();
      }
    }
  }
  cancelarOtrosG() {
    if (this.detalleOtrasFSeleccionada.LINEA === 0) {
      this.btnNuevoGrid = false;
      this.btnGuardarGrid = true;
      this.cxctrnabonoService.cxctrnotrosgarray[this.indicador] = this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].filter((val, j) => j !==
        this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].indexOf(this.detalleFormaPago));
      this.detalleFormaPago = {};
    } else if (this.detalleOtrasFSeleccionada.LINEA !== 0) {
      this.btnNuevoGrid = false;
      this.btnGuardarGrid = true;
      this.cxctrnabonoService.obtenerOtrosGastos(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe((res) => {
        this.cxctrnabonoService.cxctrnotrosgarray[this.indicador] = res;
        this.cxctrnabonoService.cxctrnotrosgarray[this.indicador].map((detalle) => {
          if (detalle.LINEA === this.detalleOtrasFSeleccionada.LINEA) {
            this.detalleOtrasFSeleccionadaAux
              = detalle;
          }
        });
        this.detalleOtrasFSeleccionada = this.detalleOtrasFSeleccionadaAux;
        this.cxctrnabonoService.calcularTotalOtrosG();
      });
    }
  }
  confirmarEliminarFormaPago() {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea eliminar el registro seleccionado',
      header: 'Confirmación',
      icon: 'pi pi-exclamation-triangle',
      key: 'confCxctrnabono',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.confirmationService.close();
        this.eliminarFormaPago();
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  eliminarFormaPago() {
    //this.editpagofr = false;
    if (this.detalleFormaPago !== undefined) {
      this.editpagofr = false;
      this.btnNuevoGrid = false;
      this.btnGuardarGrid = false;
      this.btnBorrarGrid = false;
      this.btnCancelarGrid = false;
      if (this.detalleFormaPago.TRNCOBRO_NRODOC === '') {
        this.cxctrnabonoService.cxctrnformapagoarray[this.indicador] = this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].filter((val, j) => j !==
          this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].indexOf(this.detalleFormaPago));
        this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnformapagoarray[this.indicador], this.defaultColumnDefAbonoFormaPago.objeto);
        this.cxctrnabonoService.calcularTotalFormaPago();
      } else {
        this.cxctrnabonoService.eliminarFormaPago(this.detalleFormaPago.TRNCOBRO_NRODOC).subscribe(() => {
          if (this.detalleFormaPago.TRNPAGO_TIPO === 'DP') {
            this.cxctrnabonoService.eliminarDPBanco(this.detalleFormaPago.TRNPAGO_NUMERO).subscribe(() => {
            });
          }
          this.cxctrnabonoService.cxctrnformapagoarray[this.indicador] = this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].filter((val, j) => j !==
            this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].indexOf(this.detalleFormaPago));
          this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnformapagoarray[this.indicador], this.defaultColumnDefAbonoFormaPago.objeto);
          this.auditoriagral.registrarAuditoria('CXC_TRNPAGO',
            String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC + '/' +
              this.detalleFormaPago.TRNPAGO_NUMERO), 'I',
            '', '01', '', '', '', '').subscribe(() => {
            });
          this.cxctrnabonoService.calcularTotalFormaPago();
        });
      }
    }
  }
  cancelarFormaPago() {
    this.editpagofr = true;
    if (this.detalleFormaPago.LINEA !== undefined && this.detalleFormaPago.TRNPAGO_TIPO.length === 0) {
      this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].splice(
        this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].findIndex(det =>
          det.LINEA === this.detalleFormaPago.LINEA && det.TRNPAGO_TIPO === this.detalleFormaPago.TRNPAGO_TIPO), 1);
      if (this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length > 0) {
        this.detalleFormaPago = this.cxctrnabonoService.cxctrnformapagoarray[this.indicador]
        [this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length - 1];
      }
      this.cxctrnabonoService.calcularTotalFormaPago();
      this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnformapagoarray[this.indicador], this.defaultColumnDefAbonoFormaPago.objeto);
    }
    /*
      if (this.detalleFormaPago.LINEA === 0) {
        this.btnNuevoGrid = false;
        this.btnGuardarGrid = true;
        this.cxctrnabonoService.cxctrnformapago = this.cxctrnabonoService.cxctrnformapago.filter((val, j) => j !==
          this.cxctrnabonoService.cxctrnformapago.indexOf(this.detalleFormaPago));
        this.detalleFormaPago = {};
      } else if (this.detalleFormaPago.LINEA !== 0) {
        this.btnNuevoGrid = false;
        this.btnGuardarGrid = true;
        this.cxctrnabonoService.obtenerFormadePago(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe((res) => {
          this.cxctrnabonoService.cxctrnformapago = res;
          this.cxctrnabonoService.cxctrnformapago.map((detalle) => {
            if (detalle.LINEA === this.detalleFormaPago.LINEA) {
              this.detalleFormaPagoAux
                = detalle;
            }
          });
          this.detalleFormaPago = this.detalleFormaPagoAux;
          this.cxctrnabonoService.calcularTotalFormaPago();
        });
      }*/
  }
  generarconcepto() {
    let concepto = 'Abono a factura/s ';
    let facturas = '';
    let formasdepago = '';
    this.cxctrnabonoService.cxctrnresumenarray[this.indicador].map((resumen) => {
      if (resumen.SELECCIONADO === true) {
        facturas = facturas + resumen.TRNCOBRO_NRODOC + ' / ';
      }
    });
    this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].map((formpag) => {
      formasdepago = formasdepago + formpag.TRNPAGO_TIPO + ' ' + formpag.TRNPAGO_NUMERO + '/ '
    })
    concepto = concepto + facturas + formasdepago;
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_CONCEPTO = concepto;

    this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].map((formpag) => {
      formpag.TRNPAGO_CONCEPTO = concepto

    })
    this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnformapagoarray[this.indicador], this.defaultColumnDefAbonoFormaPago.objeto);
  }
  cambioSaldo() {
    if (this.saldoInicial === true) {
      this.tabVarios = false;
      this.tabDebitoBancario = false;
      this.tabFormaPagoDev = false;
      this.tabRetenciones = false;
      this.tabOtrosGastos = false;
      this.tabEstadoCuentaAnt = false;
      //CDPJ
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ANC') {
        this.tabEstadoCuentaAnt = true;
      }
      //CDPJ
      this.tabFormaPago = false;
    } else if (this.saldoInicial === false) {
      const numeroDoc = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE;
      this.cambiarTipoCartera();
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE = numeroDoc;
    }
  }

  async changeTabs() {
    if (this.activeIndex === 1) {
      if (this.bolestcta === false) {
        this.cxctmptrnresumen = [];
        this.bolestcta = true;
        this.cxctmptrnresumen = await this.cliService.getInfoEstadoCuenta(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO,
          'cxctrnabono');
      }
    }
    if (this.activeIndex === 2) {
      if (this.bolsaldo === false) {
        this.cxctrnresumen = [];
        this.bolsaldo = true;
        this.cxctrnresumen = await this.cliService.getInfoSaldos(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO,
          'cxctrnabono');
      }
    }
    // if (this.activeIndex === 3) {
    //   if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ND'
    //     || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'NC') {
    //     this.cargarAnexos();
    //   }
    // }
  }
  obtenerNumeracionDoc() {
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA' ||
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC
      === 'AB' || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'RT' ||
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ANC') {
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA' ||
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB' ||
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ANC') {
        if (this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'NROCMPRAUT').CFG_VALOR1 === 1) {
          this.booleanNumero = false;
          if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC !== 'ANC') {
            this.cxctrnabonoService.obtenerNumeracion('CI').subscribe((num) => {
              this.numSerie = num[0].NUM_SERIE;
              if (num.length === 0) {
                this.message.add({
                  key: 'cartera',
                  severity: 'error',
                  summary: 'Información',
                  detail: 'No existe una numeración para el documento'
                });
              } else if (Number(num[0].NUM_SECACTUAL) >= Number(num[0].NUM_SECFINAL)) {
                this.message.add({
                  key: 'cartera',
                  severity: 'error',
                  summary: 'Información',
                  detail: 'Se terminó el secuencial de la factura'
                });
              } else {
                const numero = num[0].NUM_SECACTUAL.replace(/\b0+/g, '');
                this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE = Number(numero);
                if (String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE).length !== 0) {
                  if (String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE).length <= 10 &&
                    String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE).length !== 0) {
                    do {
                      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE = '0' +
                        String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE);
                    } while (String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE).length <= 10);
                  }
                }
              }
            });
          }
          if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ANC') {
            this.cxctrnabonoService.obtenerNumeracion('CI').subscribe((num1) => {
              console.log(num1);
              this.numSerie = num1[0].NUM_SERIE;
              if (num1.length === 0) {
                this.message.add({
                  key: 'cartera',
                  severity: 'error',
                  summary: 'Información',
                  detail: 'No existe una numeración para el documento'
                });
              } else if (Number(num1[0].NUM_SECACTUAL) >= Number(num1[0].NUM_SECFINAL)) {
                this.message.add({
                  key: 'cartera',
                  severity: 'error',
                  summary: 'Información',
                  detail: 'Se terminó el secuencial de la factura'
                });
              } else {
                const numero1 = String(num1[0].NUM_SECACTUAL).replace(/\b0+/g, '');
                console.log(numero1);
                this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE = Number(numero1);
                if (String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE).length !== 0) {
                  if (String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE).length <= 10 &&
                    String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE).length !== 0) {
                    do {
                      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE = '0' +
                        String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE);
                    } while (String(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE).length <= 10);
                  }
                }
              }
            });
          }
        } else {
          if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC !== 'ANC') {
            this.booleanNumero = false;
          }
        }
      } else {
        this.booleanNumero = true;
      }
    }
  }
  cambiarTipoCartera() {
    // this.disimporte=false;
    // this.cxctrnabonoService.cxctrnresumenarray[this.indicador] = [];
    // this.cxctrnabonoService.cxctrnretencionarray[this.indicador] = [];
    // this.cxctrnabonoService.cxctrnformapagoarray[this.indicador] = [];
    // this.cxctrnabonoService.cxctrnotrosgarray[this.indicador] = [];
    // this.cxctrnabonoService.cxctrnformapagodevarray[this.indicador] = [];
    // this.cxctrnabonoService.cxctrnanticiposarray[this.indicador] = [];
    // this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALDOC = 0;
    // this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALDOC =
    //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALDOC.toFixed(2);
    // this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALANTICIPO = 0;
    // this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALANTICIPO =
    //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALANTICIPO.toFixed(2);
    // this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALFORMAPAGO = 0;
    // this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALFORMAPAGO =
    //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALFORMAPAGO.toFixed(2);
    // this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALOTROSG = 0;
    // this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALOTROSG =
    //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALOTROSG.toFixed(2);
    // this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALACOBRAR = 0;
    // this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALACOBRAR =
    //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALACOBRAR.toFixed(2);
    // this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALRET = 0;
    // this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALRET =
    //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALRET.toFixed(2);
    // this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALNC = 0;
    // this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].SALDO =
    //   Number(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].SALDO).toFixed(2);
    // this.tabVarios = false;
    // this.tabDebitoBancario = false;
    // this.tabFormaPagoDev = false;
    // this.tabRetenciones = false;
    // this.tabOtrosGastos = false;
    // this.tabEstadoCuentaAnt = false;
    // this.tabFormaPago = false;
     this.obtenerNumeracionDoc();

    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'FC'
      || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA'
      || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB'
      || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'RT'
      || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'DAN'
      || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'NC') {
      this.bolsaldoIni = true;
    } else {
      this.bolsaldoIni = false;
    }

    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO === '') {
      this.message.add({
        key: 'cxctrnabono',
        severity: 'error',
        summary: 'Información',
        detail: 'Seleccione un cliente'
      });
      document.getElementById('cliente').focus();
    } else {
      // if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'FC') {
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC = 'FC';
      //   this.booleanBodega = true;
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHAVENCE = new Date();
      //   this.saldoInicial = true;
      //   this.booleanNumero = false;
      //   this.bolsaldoIni = true;
      //   setTimeout(() => {
      //     document.getElementById('numeroCartera').focus();
      //   }, 1000);
      // }

      // if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'DAN') {
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC = 'DAN';
      //   this.cxctrnabonoService.cxctrnresumenarray[this.indicador] = [];
      //   this.booleanBodega = false;
      //   this.saldoInicial = false;
      //   this.tabFormaPagoDev = true;
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].BOD_CODIGO = '';
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE = '';
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_IMPORTE = 0;
      //   this.cxctrnabonoService.consultarDocumentosACobrar('ANC', 'UPPER(CLI_CODIGO) LIKE UPPER(\'' +
      //     this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO + '\')').subscribe((res) => {
      //       if (res !== null) {
      //         res.map((devanc) => {
      //           if (devanc.SALDO > 0) {
      //             const obj: Cxctrnresumen = {};
      //             obj.SELECCIONADO = false;
      //             obj.TRNCOBRO_NRODOC = devanc.DOCUMENTO;
      //             obj.TRNCOBRO_FECHATRN = this.datePipe.transform(devanc.FECHA, 'dd/MM/yyyy');
      //             if (devanc.FECHAVENCE !== null) {
      //               obj.TRNCOBRO_FECHAVENCE = this.datePipe.transform(devanc.FECHAVENCE, 'dd/MM/yyyy');
      //             } else {
      //               obj.TRNCOBRO_FECHAVENCE = '';
      //             }
      //             obj.TRNCOBRO_CONCEPTO = devanc.CONCEPTO;
      //             obj.TRNCOBRO_SALDOINI = Number(devanc.SALDO).toFixed(2);
      //             obj.TRNCOBRO_IMPORTE = 0;
      //             if (devanc.APLORG_CODIGO !== null || devanc.APLORG_CODIGO !== undefined) {
      //               obj.APLORG_CODIGO = devanc.APLORG_CODIGO;
      //             }
      //             if (devanc.VENDEDOR !== null) {
      //               obj.VEN_CODIGO = devanc.VENDEDOR;
      //             } else {
      //               obj.VEN_CODIGO = '';
      //             }
      //             this.cxctrnabonoService.cxctrnresumenarray[this.indicador].push(obj);
      //           }
      //         });
      //         this.aggrid.refreshGridData(this.cxctrnabonoService.cxctrnresumenarray[this.indicador]);
      //       }
      //     });
      // }

      // if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ANC') {
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC = 'ANC';
      //   this.booleanBodega = false;
      //   this.saldoInicial = false;
      //   this.tabFormaPago = true;
      //   this.tabEstadoCuentaAnt = true;
      //   this.booleanNumero = false;
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].BOD_CODIGO = '';
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE = '';
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_IMPORTE = 0;
      //   this.cxctrnabonoService.cxctrnformapagoarray[this.indicador] = [];
      //   this.cxctrnabonoService.cxctrnanticiposarray[this.indicador] = [];
      //   setTimeout(() => {
      //     document.getElementById('numeroCartera').focus();
      //   }, 1000);
      // }

      // if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'NC') {
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC = 'NC';
      //   this.cxctrnabonoService.cxctrnresumenarray[this.indicador] = [];
      //   this.booleanBodega = false;
      //   this.saldoInicial = false;
      //   this.tabVarios = true;
      //   this.booleanNumero = false;
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].BOD_CODIGO = '';
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE = '';
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_IMPORTE = 0;
      //   this.cxctrnabonoService.cxctrnvariosarray[this.indicador] = [];
      //   //CDPJ
      //   if(this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'CCCAVNC').CFG_VALOR1 !== 1){
      //     this.columDefCarteraVarios.splice(5, 1);
      //     this.aggrid.refreshColumnDefs();
      //   }
      //   //CDPJ
      //   this.cxctrnabonoService.consultarDocumentosACobrar('ON', 'UPPER(CLI_CODIGO) LIKE UPPER(\'' +
      //     this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO + '\')').subscribe((res) => {
      //       if (res !== null) {
      //         res.map((devanc) => {
      //           if (devanc.SALDO > 0) {
      //             const obj: Cxctrnresumen = {};
      //             obj.SELECCIONADO = false;
      //             obj.TRNCOBRO_NRODOC = devanc.DOCUMENTO;
      //             obj.TRNCOBRO_FECHATRN = this.datePipe.transform(devanc.FECHA, 'dd/MM/yyyy');
      //             if (devanc.FECHAVENCE !== null) {
      //               obj.TRNCOBRO_FECHAVENCE = this.datePipe.transform(devanc.FECHAVENCE, 'dd/MM/yyyy');
      //             } else {
      //               obj.TRNCOBRO_FECHAVENCE = '';
      //             }
      //             obj.TRNCOBRO_CONCEPTO = devanc.CONCEPTO;
      //             obj.TRNCOBRO_SALDOINI = Number(devanc.SALDO).toFixed(2);
      //             obj.TRNCOBRO_IMPORTE = 0;
      //             if (devanc.APLORG_CODIGO !== null || devanc.APLORG_CODIGO !== undefined) {
      //               obj.APLORG_CODIGO = devanc.APLORG_CODIGO;
      //             }
      //             if (devanc.VENDEDOR !== null) {
      //               obj.VEN_CODIGO = devanc.VENDEDOR;
      //             } else {
      //               obj.VEN_CODIGO = '';
      //             }
      //             this.cxctrnabonoService.cxctrnresumenarray[this.indicador].push(obj);
      //           }
      //         });
      //         //CDPJ
      //         this.aggrid.refreshGridData(this.cxctrnabonoService.cxctrnresumenarray[this.indicador]);
      //         //CDPJ
      //         //this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnresumenarray[this.indicador], this.defaultColumnDefCarteraDoc.objeto);
      //         setTimeout(() => {
      //           this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnresumenarray[this.indicador], this.defaultColumnDefCarteraDoc.objeto);
      //           document.getElementById('numeroCartera').focus();
      //         }, 1000);
      //       }
      //     });
      // }

      // if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ND') {
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC = 'ND';
      //   this.booleanBodega = false;
      //   this.saldoInicial = false;
      //   this.tabVarios = true;
      //   this.tabDebitoBancario = true;
      //   this.cxctrnabonoService.cxctrnvariosarray[this.indicador] = [];
      //   this.cxctrnabonoService.cxcdebitobancarioarray[this.indicador] = [];
      //   this.booleanNumero = false;
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].BOD_CODIGO = '';
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE = '';
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_IMPORTE = 0;
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHAVENCE = new Date();
      //   //CDPJ
      //   this.columDefCarteraVarios.splice(5, 1);
      //     this.aggrid.refreshColumnDefs();
      //   //CDPJ
      //   setTimeout(() => {
      //     document.getElementById('numeroCartera').focus();
      //   }, 1000);
      // }

      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB' ||
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA') {
        this.cxctrnabonoService.tipoDocumentoarray[this.indicador] = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC;
        this.cxctrnabonoService.cxctrnresumenarray[this.indicador] = [];
        this.booleanBodega = false;
        this.saldoInicial = false;
        this.tabRetenciones = true;
        this.tabOtrosGastos = true;
        this.tabFormaPago = true;
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].BOD_CODIGO = '';
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE = '';
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_IMPORTE = 0;
        this.cxctrnabonoService.cxctrnretencionarray[this.indicador] = [];
        this.cxctrnabonoService.cxctrnotrosgarray[this.indicador] = [];
        this.cxctrnabonoService.cxctrnformapagoarray[this.indicador] = [];
        let condicion = ''
        let cadena=''
        if (this.RESINFCC === 1) {
          if (Object.entries(this.arrayvalbodper).length > 0) {
            let bodper=this.arrayvalbodper.USU_BODPER.split(';')
            //console.log(bodper)
            cadena = bodper.map(x => `'${x}'`).join(",")
            //console.log(cadena)
            condicion = ' and BOD_CODIGO in (' + cadena+ ')'
          }else{
            condicion = ' and BOD_CODIGO = \'\''
          }
          
        }

        this.cxctrnabonoService.consultarDocumentosACobrar('ON', 'UPPER(CLI_CODIGO) LIKE UPPER(\'' +
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO + '\')' +condicion).subscribe((res) => {
            if (res !== null) {
              res.map((devanc) => {
                if (devanc.SALDO > 0) {
                  const obj: Cxctrnresumen = {};
                  obj.SELECCIONADO = false;
                  obj.TRNCOBRO_NRODOC = devanc.DOCUMENTO;
                  obj.TRNCOBRO_FECHATRN = this.datePipe.transform(devanc.FECHA, 'dd/MM/yyyy');
                  if (devanc.FECHAVENCE !== null) {
                    obj.TRNCOBRO_FECHAVENCE = this.datePipe.transform(devanc.FECHAVENCE, 'dd/MM/yyyy');
                  } else {
                    obj.TRNCOBRO_FECHAVENCE = '';
                  }
                  obj.TRNCOBRO_CONCEPTO = devanc.CONCEPTO === undefined || devanc.CONCEPTO === null ? '' : devanc.CONCEPTO;
                  obj.TRNCOBRO_SALDOINI = Number(devanc.SALDO).toFixed(2);
                  obj.TRNCOBRO_IMPORTE = 0;
                  if (devanc.APLORG_CODIGO !== null || devanc.APLORG_CODIGO !== undefined) {
                    obj.APLORG_CODIGO = devanc.APLORG_CODIGO;
                  }
                  if (devanc.VENDEDOR !== null) {
                    obj.VEN_CODIGO = devanc.VENDEDOR;
                  } else {
                    obj.VEN_CODIGO = '';
                  }
                  obj.TRNCOBRO_TIPODOC = devanc.TRNCOBRO_TIPODOC;
                  this.cxctrnabonoService.cxctrnresumenarray[this.indicador].push(obj);
                }
              });
              //CDPJ
              this.aggrid.refreshGridData(this.cxctrnabonoService.cxctrnresumenarray[this.indicador]);
              //CDPJ
              //this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnresumenarray[this.indicador], this.defaultColumnDefCarteraDoc.objeto);
              console.log(this.cxctrnabonoService.cxctrnresumenarray[this.indicador]);
              setTimeout(() => {
                document.getElementById('numeroCartera').focus();
              }, 1000);
            }
          });
      }

      // if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'RT') {
      //   this.cxctrnabonoService.tipoDocumentoarray[this.indicador] = 'RT';
      //   this.cxctrnabonoService.cxctrnresumenarray[this.indicador] = [];
      //   this.booleanBodega = false;
      //   this.saldoInicial = false;
      //   this.tabRetenciones = true;
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].BOD_CODIGO = '';
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE = '';
      //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_IMPORTE = 0;
      //   this.cxctrnabonoService.cxctrnretencionarray[this.indicador] = [];
      //   this.cxctrnabonoService.consultarDocumentosACobrar('ON', 'UPPER(CLI_CODIGO) LIKE UPPER(\'' +
      //     this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO + '\')').subscribe((res) => {
      //       if (res !== null) {
      //         res.map((devanc) => {
      //           if (devanc.SALDO > 0) {
      //             const obj: Cxctrnresumen = {};
      //             obj.SELECCIONADO = false;
      //             obj.TRNCOBRO_NRODOC = devanc.DOCUMENTO;
      //             obj.TRNCOBRO_FECHATRN = this.datePipe.transform(devanc.FECHA, 'dd/MM/yyyy');
      //             if (devanc.FECHAVENCE !== null) {
      //               obj.TRNCOBRO_FECHAVENCE = this.datePipe.transform(devanc.FECHAVENCE, 'dd/MM/yyyy');
      //             } else {
      //               obj.TRNCOBRO_FECHAVENCE = '';
      //             }
      //             obj.TRNCOBRO_CONCEPTO = devanc.CONCEPTO;
      //             obj.TRNCOBRO_SALDOINI = Number(devanc.SALDO).toFixed(2);
      //             obj.TRNCOBRO_IMPORTE = 0;
      //             if (devanc.APLORG_CODIGO !== null || devanc.APLORG_CODIGO !== undefined) {
      //               obj.APLORG_CODIGO = devanc.APLORG_CODIGO;
      //             }
      //             if (devanc.VENDEDOR !== null) {
      //               obj.VEN_CODIGO = devanc.VENDEDOR;
      //             } else {
      //               obj.VEN_CODIGO = '';
      //             }
      //             this.cxctrnabonoService.cxctrnresumenarray[this.indicador].push(obj);
      //           }
      //         });
      //         //CDPJ
      //         this.aggrid.refreshGridData(this.cxctrnabonoService.cxctrnresumenarray[this.indicador]);
      //         //CDPJ
      //         //this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnresumenarray[this.indicador], this.defaultColumnDefCarteraDoc.objeto);
      //         setTimeout(() => {
      //           document.getElementById('numeroCartera').focus();
      //         }, 1000);
      //       }
      //     });
      // }
    }
  }
  isEditFP(data) {
    //CDPJ
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA' ||
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB' ||
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'RT' ||
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'NC' ||
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'DAN') {
      this.editConcil = false
    }
    //CDPJ
    if (this.editConcil) {
      return true;
    }
    return false;
  }
  isEditFRmpago(data): boolean {
    if (data.TRNPAGO_ORIGEN ==='REG') {
      return false;
    }
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC !== '' && this.editpagofr === true
    ) {
      return false;
    }
    return true;
  }
  docSeleccionado(valor) {
    if (valor.data.SELECCIONADO === true && this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC === '') {
      valor.data.TRNCOBRO_IMPORTE = valor.data.TRNCOBRO_SALDOINI;
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB' ||
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA' ||
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'RT') {
        this.numeroFactura = valor.data.TRNCOBRO_NRODOC;
      }
      this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnresumenarray[this.indicador], this.defaultColumnDefCarteraDoc.objeto);
      const indi = this.cxctrnabonoService.cxctrnresumenarray[this.indicador].indexOf(valor.data);
      if (indi === -1) {
        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
          this.defaultColumnDefCarteraDoc.objeto].setFocusedCell(0, 'SELECCIONADO');
      } else {
        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
          this.defaultColumnDefCarteraDoc.objeto].setFocusedCell(indi, 'SELECCIONADO');
      }
      this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
        this.defaultColumnDefCarteraDoc.objeto].forEachNode((node) => {
          const h = indi;
          if (Number(node.id) === h) {
            node.setSelected(true);
          }
          this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
            this.defaultColumnDefCarteraDoc.objeto].ensureIndexVisible(h, 'bottom');
        });
      this.cxctrnabonoService.calcularTotalDoc();
    }

    if (valor.data.SELECCIONADO === false) {
      valor.data.TRNCOBRO_IMPORTE = 0;
      this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnresumenarray[this.indicador], this.defaultColumnDefCarteraDoc.objeto);
      const indi = this.cxctrnabonoService.cxctrnresumenarray[this.indicador].indexOf(valor.data);
      if (indi === -1) {
        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
          this.defaultColumnDefCarteraDoc.objeto].setFocusedCell(0, 'SELECCIONADO');
      } else {
        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
          this.defaultColumnDefCarteraDoc.objeto].setFocusedCell(indi, 'SELECCIONADO');
      }
      this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
        this.defaultColumnDefCarteraDoc.objeto].forEachNode((node) => {
          const h = indi;
          if (Number(node.id) === h) {
            node.setSelected(true);
          }
          this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
            this.defaultColumnDefCarteraDoc.objeto].ensureIndexVisible(h, 'bottom');
        });
      this.cxctrnabonoService.calcularTotalDoc();
    }
  }
  cambio(cambio) {
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador] !== undefined) {
      this.btnGuardar = false;
      this.btnRegresar = false;
      this.btnNuevo = true;
      this.btnNuevoGrid = false;
    }
  }
  actualizarTablas() {
    if (this.indiceTablas === 0) {
      if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length !== 0) {
        this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnresumenarray[this.indicador], this.defaultColumnDefCarteraDoc.objeto);
      }
    }
    // if (this.tabVarios === true) {
    //   if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ND') {
    //     this.cxctrnabonoService.calcularTotalND();
    //   }
    // }
    // //GSRF
    // if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ANC') {
    //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].SALDOANC = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_IMPORTE;
    //   this.cxctrnabonoService.calcularTotalDoc();
    // }  
    // //GSRF
  }
  manejarSeleccion(opcion) {
    if (this.opcion === 'BUSCAR') {
      this.listaClientes.map((cliente) => {
        if (cliente.CLI_CODIGO === opcion.CLI_CODIGO) {
          this.indiceCliente = this.listaClientes.indexOf(cliente);
          this.cxctrnabonoService.getListaReferencias(cliente.CLI_CODIGO).subscribe((ref) => {
            this.listaReferencias = ref;
            this.listaReferencias.map((refL) => {
              if (refL.TRNCOBRO_REFERENCIAEXTERNA === opcion.TRNCOBRO_NRODOC) {
                this.indiceDocRef = this.listaReferencias.indexOf(refL);
              }
            });
          });
        }
      });
      this.obtenerDatos(opcion.TRNCOBRO_NRODOC);
      this.displayDialogBusquedaFast = false;
    } else if (this.opcion === 'BUSQUEDACLI') {
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO = opcion.CLI_CODIGO;
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_NOMBRE = opcion.CLI_NOMBRE;
      this.cxctrnabonoService.obtenerSaldoCliente(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO).subscribe((res) => {
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].SALDO = Number(res[0].SALDO).toFixed(2);
      });
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_CODIGO = opcion.VEN_CODIGO === null ? '' : opcion.VEN_CODIGO;
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_NOMBRE = opcion.VEN_NOMBRE === null ? '' : opcion.VEN_NOMBRE;
      this.displayDialogBusquedaFast = false;
      this.btnNuevoGrid = false;
      this.btnBorrarGrid = false;
      this.btnCancelarGrid = false;
      this.btnNuevo = true;
      this.btnGuardar = false;
      this.btnBorrar = false;
      this.botonPrimero = true;
      this.botonSiguiente = true;
      this.botonAnterior = true;
      this.botonUltimo = true;
      this.busquedaSer.encontrarRegistro44(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO).subscribe((resCli) => {
        if (resCli !== null) {
          if (resCli[0].CLI_CONREGMIC === 'S'
            || resCli[0].CLI_AGENTERET === 'S') {
            if (resCli[0].CLI_CONREGMIC === 'S'
              && resCli[0].CLI_AGENTERET === 'S') {
              this.lblAplicaRegMicroempresas = 'Cliente aplica régimen de Microempresas y agente de retención';
            } else {
              if (resCli[0].CLI_CONREGMIC === 'S') {
                this.lblAplicaRegMicroempresas = 'Cliente aplica régimen de Microempresas';
              }
              if (resCli[0].CLI_AGENTERET === 'S') {
                this.lblAplicaRegMicroempresas = 'Cliente aplica agente de retención';
              }
            }
          } else {
            this.lblAplicaRegMicroempresas = '';
          }
        }
      });
      document.getElementById('vendedor').focus();
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC !== '') {
        this.cambiarTipoCartera();
      }
    } else if (this.opcion === 'BUSQUEDACLIFAC') {
      this.codClienteFac = opcion.CLI_CODIGO;
      this.nombreClienteFac = opcion.CLI_NOMBRE;
      this.cxctrnabonoService.getDocCobrados(this.codClienteFac, this.nroFacCancelada).subscribe((facpendientes) => {
        facpendientes.map((facturas) => {
          facturas.TRNCOBRO_FECHATRN = this.datePipe.transform(facturas.TRNCOBRO_FECHATRN, 'dd/MM/yyyy');
        });
        this.cxctrnabonoService.cxctrnfaccanceladasarray[this.indicador] = facpendientes;
      });
      this.displayDialogBusquedaFast = false;
      document.getElementById('nroFacCanc').focus();
    } else if (this.opcion === 'BUSQUEDABOD') {
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].BOD_CODIGO = opcion.BOD_CODIGO;
      this.displayDialogBusquedaFast = false;
      this.btnNuevo = true;
      this.btnGuardar = false;
      this.btnBorrar = false;
      this.botonPrimero = true;
      this.botonSiguiente = true;
      this.botonAnterior = true;
      this.botonUltimo = true;
      document.getElementById('concepto').focus();
    } else if (this.opcion === 'BUSQUEDAVEN') {
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_CODIGO = opcion.VEN_CODIGO;
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_NOMBRE = opcion.VEN_NOMBRE;
      this.displayDialogBusquedaFast = false;
      this.btnNuevo = true;
      this.btnGuardar = false;
      this.btnBorrar = false;
      this.botonPrimero = true;
      this.botonSiguiente = true;
      this.botonAnterior = true;
      this.botonUltimo = true;
    } else if  (this.opcion === 'BUSCENCODIGO'){
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CEN_CODIGO=opcion.CEN_CODIGO
    }
    //else if (this.opcion === 'BUSQUEDABAN') {
    //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].BAN_CODIGO = opcion.BAN_CODIGO;
    //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].BAN_BANCO = opcion.BAN_BANCO;
    //   this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CON_CODIGO = opcion.CON_CODIGO;
    //   this.displayDialogBusquedaFast = false;
    //   this.cxctrnabonoService.cxcdebitobancarioarray[this.indicador] = [];
    //   if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].BAN_BANCO !== null || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].BAN_BANCO !== '') {
    //     this.tabVarios = false;
    //     if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO !== '') {
    //       this.cxctrnabonoService.obtenerChequesCli(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO).subscribe((cheques) => {
    //         if (cheques !== null) {
    //           cheques.map((cheque) => {
    //             const obj: Cxctrndebitobancario = {};
    //             obj.SELECCIONADO = false;
    //             obj.TRNPAGO_FECHA = this.datePipe.transform(cheque.TRNPAGO_FECHA, 'dd/MM/yyyy');
    //             obj.TRNPAGO_TIPO = cheque.TRNPAGO_TIPO;
    //             obj.TRNPAGO_NUMERO = cheque.TRNPAGO_NUMERO;
    //             obj.TRNPAGO_IMPORTE = Number(cheque.TRNPAGO_IMPORTE).toFixed(2);
    //             obj.TRNPAGO_NROCTA = cheque.TRNPAGO_NROCTA;
    //             obj.BANCLI_CODIGO = cheque.BANCLI_CODIGO;
    //             obj.BANCLI_NOMBRE = cheque.BANCLI_NOMBRE;
    //             obj.TRNCOBRO_NRODOC = cheque.TRNCOBRO_NROCOMPROBANTE;
    //             this.cxctrnabonoService.cxcdebitobancarioarray[this.indicador].push(obj);
    //           });
    //         }
    //         this.aggrid.refreshaggrid(this.cxctrnabonoService.cxcdebitobancarioarray[this.indicador], this.defaultColumnDefCarteraDebito.objeto);
    //       });
    //     }
    //   } else {
    //     this.tabVarios = true;
    //   }
    // }
    if (this.opcion === 'BUSCARREGCOMP') {
      this.detalleFormaPago.TRNPAGO_TIPO = 'DP'
      this.detalleFormaPago.TRNPAGO_TIPO = 'DP'
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ANC') {
        this.detalleFormaPago.TRNPAGO_NUMERO = opcion.DETREGCOMPRO_COMPROBANTE+'-B'
      }else{
        this.detalleFormaPago.TRNPAGO_NUMERO = opcion.DETREGCOMPRO_COMPROBANTE
      } 
      this.detalleFormaPago.BANCLI_CODIGO = opcion.BAN_CODIGO
      this.detalleFormaPago.CON_CODIGO = opcion.CON_CODIGO
      this.detalleFormaPago.BANCLI_NOMBRE = opcion.BAN_NOMBRE
      this.detalleFormaPago.TRNPAGO_IMPORTE=opcion.DETREGCOMPRO_SALDO
      this.detalleFormaPago.DETREGCOMPRO_SALDO=Number(opcion.DETREGCOMPRO_SALDO).toFixed(2);
      this.detalleFormaPago.TRNPAGO_ORIGEN='REG'

      const indi = this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].indexOf(this.detalleFormaPago);
      //console.log(indi)
      this.cxctrnabonoService.calcularTotalFormaPago()
      this.aggrid.refreshaggridindex(this.cxctrnabonoService.cxctrnformapagoarray[this.indicador], this.defaultColumnDefAbonoFormaPago.objeto, indi)
      this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColumnDefAbonoFormaPago.objeto].setFocusedCell(indi - 1, 'TRNPAGO_TIPO');
    }
    if (this.opcion === 'TRNANEX_IDCRETRI') {
      this.anexoSeleccionado.TRNANEX_IDCRETRI = opcion.CODSRI_CODIGO;
      this.anexoSeleccionado.DESCIDCRETRI = opcion.CODSRI_DESCRIPCION;
      document.getElementById('TRNANEX_MONTOIVA').focus();
    }

    if (this.opcion === 'TRNANEX_TIPOSRITARCERO') {
      this.anexoSeleccionado.TRNANEX_TIPOSRITARCERO = opcion.REF_CODIGO;
      document.getElementById('TRNANEX_BASEIMPGRABADAIVA').focus();
    }

    if (this.opcion === 'TRNANEX_TIPOSRIGRAVADA') {
      this.anexoSeleccionado.TRNANEX_TIPOSRIGRAVADA = opcion.REF_CODIGO;
      document.getElementById('TRNANEX_MONTOIVA').focus();
    }

    this.displayDialogBus = false;
    this.displayDialogBusquedaFast = false;
  }
  async obtenerDatos(valor) {
    ///GSRF    
    this.cxctrnabonoService.cxctrnresumenarray[this.indicador] = [];
    this.cxctrnabonoService.cxctrnretencionarray[this.indicador] = [];
    this.cxctrnabonoService.cxctrnvariosarray[this.indicador] = [];
    this.cxctrnabonoService.cxctrnformapagoarray[this.indicador] = [];
    this.cxctrnabonoService.cxctrnotrosgarray[this.indicador] = [];
    this.cxctrnabonoService.cxcdebitobancarioarray[this.indicador] = [];
    this.cxctrnabonoService.cxctrnanticiposarray[this.indicador] = [];
    this.cxctrnabonoService.cxctrnformapagodevarray[this.indicador] = [];
    this.cxctrnabonoService.dblTotalDocarray[this.indicador] = 0;
    this.cxctrnabonoService.dblTotalRetarray[this.indicador] = 0;
    this.cxctrnabonoService.dblTotalOtrosGarray[this.indicador] = 0;
    this.cxctrnabonoService.dblTotalFormaPagoarray[this.indicador] = 0;
    this.cxctrnabonoService.dblTotalFormaDevarray[this.indicador] = 0;
    this.cxctrnabonoService.dblTotalVariosarray[this.indicador] = 0;
    this.cxctrnabonoService.dblTotalNDarray[this.indicador] = 0;
    this.cxctrnabonoService.dblTotalNCarray[this.indicador] = 0;
    this.cxctrnabonoService.dblTotalCobrararray[this.indicador] = 0;
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador] = {};
    ///GSRF
    // this.cxctrnabonoService.dblTotalNCarray[this.indicador] = 0;
    //this.cxctrnabonoService.dblTotalOtrosGarray[this.indicador] = 0;
    //this.cxctrnabonoService.dblTotalFormaPagoarray[this.indicador] = 0;
    //this.cxctrnabonoService.dblTotalFormaDevarray[this.indicador] = 0;
    //this.cxctrnabonoService.dblTotalRetarray[this.indicador] = 0;
    //this.cxctrnabonoService.dblTotalDocarray[this.indicador] = 0;
    // this.cxctrnabonoService.dblTotalNDarray[this.indicador] = 0;
    this.numeroFactura = '';
    this.booleanAnulado = false;
    const res = await this.cxctrnabonoService.getEncCarteraProm(valor);
    console.log(res[0]);
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador] = res[0];
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_ANULADO === 1) {
      document.getElementById('divPrincipal').style.pointerEvents = 'none';
      document.getElementById('divPrincipal').style.opacity = '0.7';
      this.booleanAnulado = true;
      this.btnBorrar = true;
    }

    // if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'NDA') {
    //   this.itemTipoDoc = { label: 'NOTA DE DEBITO', value: 'NDA' };
    //   this.opcionesTipoDoc.push(this.itemTipoDoc);
    // }

    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALDOC = 0;
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALDOC =
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALDOC.toFixed(2);
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALANTICIPO = 0;
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALANTICIPO =
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALANTICIPO.toFixed(2);
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALFORMAPAGO = 0;
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALFORMAPAGO =
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALFORMAPAGO.toFixed(2);
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALOTROSG = 0;
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALOTROSG =
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALOTROSG.toFixed(2);
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALACOBRAR = 0;
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALACOBRAR =
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALACOBRAR.toFixed(2);
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALRET = 0;
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALRET =
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALRET.toFixed(2);
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TOTALNC = 0;
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].SALDO =
      Number(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].SALDO).toFixed(2);

    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC !== 'FC' && this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC !== 'ANC' &&
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC !== 'ND' && this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC !== 'NDA') {
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_IMPORTE = null;
    } else {
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_IMPORTE =
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_IMPORTE.toFixed(2);
    }


    console.log(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador]);

    const data = await this.cxctrnabonoService.erMaeclienteProm(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO);
    for (const resCli of data) {
      if (resCli.CLI_CONREGMIC === 'S'
        || resCli.CLI_AGENTERET === 'S') {
        if (resCli.CLI_CONREGMIC === 'S'
          && resCli.CLI_AGENTERET === 'S') {
          this.lblAplicaRegMicroempresas = 'Cliente aplica régimen de Microempresas y agente de retención';
        } else {
          if (resCli.CLI_CONREGMIC === 'S') {
            this.lblAplicaRegMicroempresas = 'Cliente aplica régimen de Microempresas';
          }
          if (resCli.CLI_AGENTERET === 'S') {
            this.lblAplicaRegMicroempresas = 'Cliente aplica agente de retención';
          }
        }
      } else {
        this.lblAplicaRegMicroempresas = '';
      }
    }

    // this.consultarPestañas();
    //await this.cargarAnexos();
    //GSRF
    // if ( this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ND') {
    // this.disimporte = true;
    //  }else{
    //   this.disimporte = false;
    //  }

    //GSRF
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'FC'
      || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA'
      || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB'
      || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'RT'
      || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'DAN'
      || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'NC') {
      this.bolsaldoIni = true;
    } else {
      this.bolsaldoIni = false;
    }
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC.includes('NC') === true ||
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC.includes('ND') === true) {
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC.includes('ANC') === false &&
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC.includes('NDA') === false &&
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC.includes('NDR') === false) {
        this.bolnc = false;
      } else {
        this.bolnc = true;
      }
    } else {
      this.bolnc = true;
    }

    // const bolCierre = await this.documentoCierre('');

    // if (bolCierre) {
    //   document.getElementById('divPrincipal').style.pointerEvents = 'none';
    //   this.btnBorrar = true;
    //   this.botonAnular = true;
    // }



    // if (bolCierre) {
    //   this.lblDocCierre = true;
    // }

    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].APLORG_CODIGO !== 'CXC') {
      this.impresoString = 'IMPRESO';
      document.getElementById('divPrincipal').style.pointerEvents = 'none';
      document.getElementById('divPrincipal').style.opacity = '0.7';
      this.btnBorrar = true;
      this.botonAnular = true;
      /*this.columDefCarteraDoc.map((columna) => {
        columna.editable = false;
      });
      this.aggrid.refreshColumnDefs2(this.columDefCarteraDoc);
      this.editarCeldas = true;
      this.tipodetalleactivo = 'none';*/
    } else if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].APLORG_CODIGO === 'CXC') {
      this.impresoString = '';
      document.getElementById('divPrincipal').style.pointerEvents = 'all';
      document.getElementById('divPrincipal').style.opacity = '1.0';
      this.botonAnular = false;
      this.btnBorrar = false;
      /*this.columDefCarteraDoc.map((columna) => {
        columna.editable = true;
      });
      this.aggrid.refreshColumnDefs2(this.columDefCarteraDoc);
      this.editarCeldas = false;
      this.tipodetalleactivo = 'all';*/
    }

    console.log(new Date(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN));
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN =
      new Date(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN);
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHAVENCE === null) {
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHAVENCE =
        new Date(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHATRN);
    } else {
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHAVENCE =
        new Date(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHAVENCE);
      console.log(new Date(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_FECHAVENCE));
    }

    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'FC') {
      this.booleanBodega = true;
      this.tabVarios = false;
      this.tabRetenciones = false;
      this.tabOtrosGastos = false;
      this.tabFormaPago = false;
      this.tabFormaPagoDev = false;
      this.tabEstadoCuentaAnt = false;
      this.tabDebitoBancario = false;
    } else {
      this.booleanBodega = false;

      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB' ||
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA') {
        this.tabRetenciones = true;
        this.tabOtrosGastos = true;
        this.tabFormaPago = true;
        this.tabEstadoCuentaAnt = false;
        this.tabVarios = false;
        this.tabDebitoBancario = false;
        this.tabFormaPagoDev = false;
        const resTrnRes = await this.cxctrnabonoService.obtenerDocumentosProm('DT', this.cxctrnabonoService.encabezadoCarteraActivaarray
        [this.indicador].TRNCOBRO_NRODOC);

        this.cxctrnabonoService.cxctrnresumenarray[this.indicador] = [];
        if (resTrnRes !== null) {
          for (const resumen of resTrnRes) {
            let objRes: Cxctrnresumen;
            objRes = {};
            objRes.TRNCOBRO_NRODOC = resumen.TRNDOCUMENTO_NRODOC;
            objRes.TRNCOBRO_FECHATRN = this.datePipe.transform(resumen.TRNCOBRO_FECHATRN, 'dd/MM/yyyy');
            objRes.TRNCOBRO_FECHAVENCE = this.datePipe.transform(resumen.TRNCOBRO_FECHAVENCE, 'dd/MM/yyyy');
            objRes.TRNCOBRO_CONCEPTO = resumen.TRNCOBRO_CONCEPTO;
            objRes.TRNCOBRO_SALDOINI = resumen.SALDOFAC;
            objRes.TRNCOBRO_IMPORTE = String(resumen.TRNDOCUMENTO_IMPORTE.toFixed(2));
            objRes.VEN_CODIGO = resumen.VEN_CODIGO;
            objRes.STRCUOTAFAC = resumen.TRNDOCUMENTO_REF;
            objRes.SELECCIONADO = true;
            objRes.CLI_CODIGO = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO;
            this.cxctrnabonoService.cxctrnresumenarray[this.indicador].push(objRes);
          }

        }
        if (this.cxctrnabonoService.cxctrnresumenarray[this.indicador].length !== 0) {
          this.numeroFactura = this.cxctrnabonoService.cxctrnresumenarray[this.indicador][0].TRNCOBRO_NRODOC;
        }

        this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnresumenarray[this.indicador], this.defaultColumnDefCarteraDoc.objeto);
        this.cxctrnabonoService.calcularTotalDoc();

        const retenciones = await this.cxctrnabonoService.obtenerRetencionesProm(this.cxctrnabonoService.encabezadoCarteraActivaarray
        [this.indicador].TRNCOBRO_NRODOC);
        console.log(retenciones);
        this.cxctrnabonoService.cxctrnretencionarray[this.indicador] = [];
        if (retenciones.length !== 0) {
          this.cxctrnabonoService.cxctrnretencionarray[this.indicador] = retenciones;
          //CDPJ
          for (const itemRet of this.cxctrnabonoService.cxctrnretencionarray[this.indicador]) {
            itemRet.NUEVALINEA = itemRet.LINEA;
          }
          //CDPJ
          this.cxctrnabonoService.calcularTotalRetenido(-1);
        }

        const otrosG = await this.cxctrnabonoService.obtenerOtrosGastosProm(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC);
        if (otrosG !== null) {
          this.cxctrnabonoService.cxctrnotrosgarray[this.indicador] = otrosG;
          this.cxctrnabonoService.calcularTotalOtrosG();
        }

        const formapago = await this.cxctrnabonoService.obtenerFormadePagoProm(this.cxctrnabonoService.encabezadoCarteraActivaarray
        [this.indicador].TRNCOBRO_NRODOC);
        console.log(formapago);
        if (formapago !== null) {
          const arreglo = [];
          for (const form of formapago) {
            form.TRNPAGO_FECHA = this.datePipe.transform(form.TRNPAGO_FECHA, 'dd/MM/yyyy');
            form.TRNPAGO_ORIGEN=isNullOrUndefined(form.TRNPAGO_ORIGEN)?'':form.TRNPAGO_ORIGEN
            if (form.TRNPAGO_TIPO === 'DP') {
              form.CAJ_CODIGO = ''
            }
            if (form.TRNPAGO_TIPO === 'CH') {
              const banN = await this.cxctrnabonoService.erBanclinombreProm(form.BANCLI_CODIGO);
              if (banN !== null) {
                form.BANCLI_NOMBRE = banN[0].BANCLI_NOMBRE;
              }
            } else if (form.TRNPAGO_TIPO === 'TA') {
              const banN = await this.cxctrnabonoService.erTarDescripcion(form.BANCLI_CODIGO);
              if (banN !== null) {
                form.BANCLI_NOMBRE = banN[0].TAR_DESCRIPCION;
              }
            } else {
              const banN = await this.cxctrnabonoService.erBanbancoProm(form.BANCLI_CODIGO);
              if (banN !== null) {
                form.BANCLI_NOMBRE = banN[0].BAN_BANCO;
              }
            }
            arreglo.push(form);
          }

          this.cxctrnabonoService.cxctrnformapagoarray[this.indicador] = arreglo;
          this.cxctrnabonoService.calcularTotalFormaPago();
          await this.efectivoDepositado('COLOR');
          await this.chequeDepositado('COLOR');
          await this.depositoConciliado('COLOR');
          await this.tarjetaConciliada('COLOR');
        }

      }
    }

    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_SALDOINI === 1) {
      this.saldoInicial = true;
      this.bolsaldoIni = true;
      this.tabVarios = false;
      this.tabDebitoBancario = false;
      this.tabFormaPagoDev = false;
      this.tabRetenciones = false;
      this.tabOtrosGastos = false;
      this.tabEstadoCuentaAnt = false;
      //CDPJ
      // if(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'ANC'){
      //   this.tabEstadoCuentaAnt = true;
      // }
      //CDPJ
      this.tabFormaPago = false;
    } else if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_SALDOINI === 0) {
      this.saldoInicial = false;
    }

    const resApl = await this.cxctrnabonoService.getOrigenProm(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].APLORG_CODIGO);
    if (resApl.length !== 0) {
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ORIGEN =
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].APLORG_CODIGO + '-' + resApl[0].APLORG_NOMBRE;
    } else {
      this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].ORIGEN =
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].APLORG_CODIGO + '-';
    }

    const resReal = await this.cxctrnabonoService.getRealizadoProm(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].USU_IDENTIFICACION);
    this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].REALIZADO = resReal[0].NOMBRE;

    this.bolestcta = false;
    this.bolsaldo = false;

    const bolCierre2 = await this.documentoCierre('');

    if (await this.chequeConciliado('') || await this.chequeDepositado('')
      || await this.depositoConciliado('') || await this.efectivoDepositado('')
      || await this.tarjetaConciliada('') || bolCierre2) {
      this.btneditConcil = false;
      this.editConcil = false;
      document.getElementById('divPrincipal').style.pointerEvents = 'none';
      document.getElementById('divPrincipal').style.opacity = '0.7';
    } else {
      this.btneditConcil = true;
      this.editConcil = true;
      document.getElementById('divPrincipal').style.pointerEvents = 'all';
      document.getElementById('divPrincipal').style.opacity = '1.0';
    }
    ///GSRF
    this.cxctrnabonoService.getAsiento(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC).subscribe(async (res) => {
      console.log('----***', res)
      this.asiento = res[0].ASI_NRO;
      if (this.asiento !== null) {

        const det = await this.cxctrnabonoService.getDetConencasilProm(this.asiento, 'CXC');
        console.log('----***', det);
        if (det === null || det.length === 0) {
          document.getElementById("errasiento").style.display = '';
          this.spin = false;//CDPJ
        } else {
          let sum = 0;
          for (const aux of det) {
            sum = aux.DETASI_IMPORTE + sum;
          }
          console.log('----new', Number(sum.toFixed(2)));
          if (Math.abs(Number(det[0].ASI_CREDITOS)) !== Number(det[0].ASI_DEBITOS) ) {
            document.getElementById("errasiento").style.display = '';
          } else {
            document.getElementById("errasiento").style.display = 'none';
          }
        }


      } else {
        document.getElementById("errasiento").style.display = 'none';
      }
      this.spin = false;//CDPJ
    });
    //GSRF
  }
  async efectivoDepositado(strProceso) {
    let bolDep = false;

    if (this.tabFormaPago === true) {
      for (let fila = 1; fila <= this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length; fila++) {
        if (this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].TRNPAGO_TIPO === 'EF') {
          const strNumDep = await this.efectivoDepositadoUtil(
            this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].TRNPAGO_NUMERO,
            this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].CAJ_CODIGO,
            this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE);
          console.log(strNumDep);
          if (strNumDep.length > 0) {
            if (strProceso !== 'COLOR') {
              if (String(strProceso).length > 0) {
                this.message.add({
                  key: 'cxctrnabono',
                  severity: 'error',
                  summary: 'Información',
                  detail: 'No puede '
                    + strProceso
                    + ' el cobro, el efectivo '
                    + this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].TRNPAGO_NUMERO
                    + ' está depositado.'
                    + '\r\rNro. Depósito: '
                    + strNumDep
                });
              }
              bolDep = true;
              break;
            } else {
              this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].COLORDOCDEP = true;
              this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnformapagoarray[this.indicador], this.defaultColumnDefAbonoFormaPago.objeto);
            }
          }
        }
      }
    }
    return bolDep;
  }
  buscarFacturas() {
    this.cxctrnabonoService.getDocCobrados(this.codClienteFac, this.nroFacCancelada).subscribe((facpendientes) => {
      facpendientes.map((facturas) => {
        facturas.TRNCOBRO_FECHATRN = this.datePipe.transform(facturas.TRNCOBRO_FECHATRN, 'dd/MM/yyyy');
      });
      this.cxctrnabonoService.cxctrnfaccanceladasarray[this.indicador] = facpendientes;
    });
  }
  async depositoConciliado(strProceso) {
    let bolConc = false;

    if (this.tabFormaPago === true) {
      for (let fila = 1; fila <= this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length; fila++) {
        if (this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].TRNPAGO_TIPO === 'DP') {
          if (await this.documentoConciliado(this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].TRNPAGO_NUMERO,
            this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].BANCLI_CODIGO,
            this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].TRNPAGO_TIPO)) {
            if (strProceso !== 'COLOR') {
              if (strProceso.length > 0) {
                this.message.add({
                  key: 'cxctrnabono',
                  severity: 'error',
                  summary: 'Información',
                  detail: 'No puede '
                    + strProceso
                    + ' el pago, el depósito '
                    + this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].TRNPAGO_NUMERO
                    + ' está conciliado.'
                });
              }
              bolConc = true;
              break;
            } else {
              this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].COLORDOCCONC = true;
              this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnformapagoarray[this.indicador], this.defaultColumnDefAbonoFormaPago.objeto);

            }
          }
        }
      }
    }
    return bolConc;
  }
  async efectivoDepositadoUtil(strNumero, strCodCaja, strDocNro) {
    let strDepositado = '';

    console.log(strNumero, strCodCaja, strDocNro);
    try {
      const er = await this.cxctrnabonoService.erTrncajdepositonro2Prom(strNumero, strDocNro, 'EF', strCodCaja);

      console.log(er);

      if (er !== null) {
        if (er[0] !== undefined) {
          strDepositado = er[0].TRNCAJ_DEPOSITONRO === null ? '' : er[0].TRNCAJ_DEPOSITONRO;
        }
      }
    } catch (error1) {
      this.message.add({
        key: 'cxctrnabono',
        severity: 'error',
        summary: 'Error',
        detail: 'No se puede verificar si el efectivo está depositado.'
      });
    }

    return strDepositado;
  }
  async documentoConciliado(strNumDoc, strCodBanco, strTipoDoc) {
    let strConcilia = '';
    let bolConcilia = false;
    try {
      const er = await this.cxctrnabonoService.erTrnbanconciliaProm(strNumDoc, strCodBanco, strTipoDoc);
      if (er !== null) {
        if (er[0] !== undefined) {
          strConcilia = er[0].TRNBAN_CONCILIA;
        }
      }

      console.log(strConcilia);

      if (Number(strConcilia) === 1) {
        bolConcilia = true;
      }
    } catch (error) {
      this.message.add({
        key: 'cxctrnabono',
        severity: 'error',
        summary: 'Error',
        detail: 'No se puede verificar si el cheque está conciliado.'
      });
    }

    console.log(bolConcilia);

    return bolConcilia;

  }
  async chequeDepositado(strProceso) {
    let bolDep = false;

    if (this.tabFormaPago === true) {
      for (let fila = 1; fila <= this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length; fila++) {
        if (this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].TRNPAGO_TIPO === 'CH') {
          const strNumDep = await this.chequeDepositadoUtil(
            this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].TRNPAGO_NUMERO,
            this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].BANCLI_CODIGO,
            this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE);
          console.log(strNumDep);
          if (strNumDep.length > 0) {
            if (strProceso !== 'COLOR') {
              if (String(strProceso).length > 0) {
                this.message.add({
                  key: 'cxctrnabono',
                  severity: 'error',
                  summary: 'Información',
                  detail: 'No puede '
                    + strProceso
                    + ' el cobro, el cheque '
                    + this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].TRNPAGO_NUMERO
                    + ' está depositado.'
                    + '\r\rNro. Depósito: '
                    + strNumDep
                });
              }
              bolDep = true;
              break;
            } else {
              this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].COLORDOCDEP = true;
              this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnformapagoarray[this.indicador], this.defaultColumnDefAbonoFormaPago.objeto);

            }
          }

        }
      }
    }
    return bolDep;
  }
  async chequeDepositadoUtil(strNumCheque, strCodBanco, strDocumento) {
    let strDepositado = '';
    console.log(strNumCheque, strCodBanco, strDocumento);
    try {
      const er = await this.cxctrnabonoService.erTrncajdepositonroProm(strNumCheque, strCodBanco, 'CH', strDocumento);
      if (er !== null) {
        if (er[0] !== undefined) {
          strDepositado = er[0].TRNCAJ_DEPOSITONRO === null ? '' : er[0].TRNCAJ_DEPOSITONRO;
        }
      }
    } catch (error1) {
      this.message.add({
        key: 'cxctrnabono',
        severity: 'error',
        summary: 'Error',
        detail: 'No se puede verificar si el cheque está depositado.'
      });
    }

    return strDepositado;
  }
  async tarjetaConciliadaUtil(strNumero, strCodCaja, strDocNro) {
    let bolConc = false;
    let strCodConc = '';
    try {
      const er = await this.cxctrnabonoService.erTrntarjetacodigoProm(strNumero, strDocNro, 'TA', strCodCaja);
      if (er !== null) {
        if (er[0] !== undefined) {
          strCodConc = er[0].TRNTARJETA_CODIGO === null ? '' : er[0].TRNTARJETA_CODIGO;
        }
      }
      if (String(strCodConc).length > 0) {
        bolConc = true;
      }
    } catch (error1) {
      this.message.add({
        key: 'cxctrnabono',
        severity: 'error',
        summary: 'Error',
        detail: 'No se puede verificar si la tarjeta está conciliada.'
      });
    }
    return bolConc;
  }

  async tarjetaConciliada(strProceso) {
    let bolConc = false;

    if (this.tabFormaPago === true) {
      for (let fila = 1; fila <= this.cxctrnabonoService.cxctrnformapagoarray[this.indicador].length; fila++) {
        if (this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].TRNPAGO_TIPO === 'TA') {
          if (await this.tarjetaConciliadaUtil(this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].TRNPAGO_NUMERO,
            this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].CAJ_CODIGO,
            this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NROCOMPROBANTE)) {
            if (strProceso !== 'COLOR') {
              if (strProceso.length > 0) {
                this.message.add({
                  key: 'cxctrnabono',
                  severity: 'error',
                  summary: 'Información',
                  detail: 'No puede '
                    + strProceso
                    + ' el pago, el voucher '
                    + this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].TRNPAGO_NUMERO
                    + ' está conciliado.'
                });
              }
              bolConc = true;
              break;
            } else {
              this.cxctrnabonoService.cxctrnformapagoarray[this.indicador][fila - 1].COLORDOCCONC = true;
              this.aggrid.refreshaggrid(this.cxctrnabonoService.cxctrnformapagoarray[this.indicador], this.defaultColumnDefAbonoFormaPago.objeto);

            }
          }
        }
      }
    }
    return bolConc;
  }
  async documentoCierre(strProceso) {
    let bolCierre = false;
    let strCierre: any = '0';

    let strNumDoc = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC;

    if (Object.keys(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador]).length > 0) {
      strNumDoc = this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_NRODOC;
    }


    try {
      strCierre = await this.cxctrnabonoService.erTrncobrocuadreProm(strNumDoc);

      if (strCierre[0].TRNCOBRO_CUADRE === '1') {
        if (String(strProceso).length > 0) {
          this.message.add({
            key: 'cxctrnabono',
            severity: 'info',
            summary: 'Información',
            detail: 'No puede ' + strProceso + ' el pago, el documento está en el cierre de caja.'
          });
        }
        bolCierre = true;
      }
    } catch (err) {
      this.message.add({
        key: 'cxctrnabono',
        severity: 'error',
        summary: 'Error',
        detail: 'No se puede verificar si el documento ya está en el cierre de caja.'
      });
    }

    return bolCierre;
  }
  async chequeConciliado(strProceso) {
    let bolConc = false;

    if (this.tabFormaPagoDev !== false) {
      for (let fila = 1; fila <= this.cxctrnabonoService.cxctrnformapagodevarray[this.indicador].length; fila++) {
        if (this.cxctrnabonoService.cxctrnformapagodevarray[this.indicador][fila - 1].TRNCAJ_TIPO === 'CH') {
          if (await this.documentoConciliado(this.cxctrnabonoService.cxctrnformapagodevarray[this.indicador][fila - 1].TRNCAJ_NUMERO,
            this.cxctrnabonoService.cxctrnformapagodevarray[this.indicador][fila - 1].BAN_CODIGO,
            this.cxctrnabonoService.cxctrnformapagodevarray[this.indicador][fila - 1].TRNCAJ_TIPO)) {
            if (strProceso !== 'COLOR') {
              if (String(strProceso).length > 0) {
                this.message.add({
                  key: 'cxctrnabono',
                  severity: 'success',
                  summary: 'Información',
                  detail: 'No puede '
                    + strProceso
                    + ' el pago, el cheque '
                    + this.cxctrnabonoService.cxctrnformapagodevarray[this.indicador][fila - 1].TRNCAJ_NUMERO
                    + ' está conciliado.'
                });
              }
              bolConc = true;
              break;
            } else {
              // modeloFPDev.ponerColorDocConc(fila);
            }

          }
        }
      }
    }
    return bolConc;
  }
  cerrarReportes() {
    this.displayDialogReportes = false;
  }
  cerrarfrmcorreos() {
    this.displayDialogfrmcorreos = false;
  }
  cambiarFoco(evento) {
    if (evento.target.id === 'cliente') {
      this.busquedaSer.encontrarRegistro44(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO).subscribe((resCli) => {
        if (resCli !== null) {
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO = resCli[0].CLI_CODIGO;
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_NOMBRE = resCli[0].CLI_NOMBRE;
          this.cxctrnabonoService.obtenerSaldoCliente(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO).subscribe((res) => {
            this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].SALDO = Number(res[0].SALDO).toFixed(2);
          });
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_CODIGO = resCli[0].VEN_CODIGO;
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_NOMBRE = resCli[0].VEN_NOMBRE;
          this.displayDialogBusquedaFast = false;
          this.btnNuevoGrid = false;
          this.btnBorrarGrid = false;
          this.btnCancelarGrid = false;
          this.btnNuevo = true;
          this.btnGuardar = false;
          this.btnBorrar = false;
          this.botonPrimero = true;
          this.botonSiguiente = true;
          this.botonAnterior = true;
          this.botonUltimo = true;
          document.getElementById('vendedor').focus();
          // if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC !== '') {
          //   this.cambiarTipoCartera();
          // }
          if (resCli[0].CLI_CONREGMIC === 'S'
            || resCli[0].CLI_AGENTERET === 'S') {
            if (resCli[0].CLI_CONREGMIC === 'S'
              && resCli[0].CLI_AGENTERET === 'S') {
              this.lblAplicaRegMicroempresas = 'Cliente aplica régimen de Microempresas y agente de retención';
            } else {
              if (resCli[0].CLI_CONREGMIC === 'S') {

                this.lblAplicaRegMicroempresas = 'Cliente aplica régimen de Microempresas';
              }
              if (resCli[0].CLI_AGENTERET === 'S') {

                this.lblAplicaRegMicroempresas = 'Cliente aplica agente de retención';
              }
            }
          } else {
            this.lblAplicaRegMicroempresas = '';
          }
          if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC !== '') {
            this.cambiarTipoCartera();
          }
        } else {
          this.abrirClientes();
        }
      });
    } else if (evento.target.id === 'vendedor') {
      this.busquedaSer.encontrarRegistro45(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_CODIGO).subscribe((resVen) => {
        if (resVen !== null) {
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_CODIGO = resVen[0].VEN_CODIGO;
          this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_NOMBRE = resVen[0].VEN_NOMBRE;
          this.displayDialogBusquedaFast = false;
          this.btnNuevo = true;
          this.btnGuardar = false;
          this.btnBorrar = false;
          this.botonPrimero = true;
          this.botonSiguiente = true;
          this.botonAnterior = true;
          this.botonUltimo = true;
          document.getElementById('numeroCartera').focus();
        } else {
          this.abrirVendedor();
        }
      });
    } else if (evento.target.id === 'numeroCartera') {

      document.getElementById('concepto').focus();

    } else if (evento.target.id === 'concepto') {
      if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'AB' ||
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'NC' ||
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'DAN' ||
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].TRNCOBRO_TIPODOC === 'CA') {
      } else {
        document.getElementById('importe').focus();
      }
    }
  }
  abrirClientes() {
    this.opcion = 'BUSQUEDACLI';
    this.types = [
      { label: 'Código', value: 'CLI_CODIGO' },
      { label: 'Nombre', value: 'CLI_NOMBRE' },
      { label: 'RUCIDE', value: 'CLI_RUCIDE' },
      { label: 'Zona', value: 'ZONA_NOMBRE' },
      { label: 'Vendedor', value: 'VEN_NOMBRE' },
      { label: 'Grupo', value: 'GRU_CODIGO' },
      { label: 'Contacto', value: 'CLI_CONTACTO' },
      { label: 'Placa', value: 'CLI_PLACA' },
      { label: 'Nombreec', value: 'CLI_NOMBREC' },
    ];
    this.busquedacampos = [this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO, '', '', '', '', '', '', '', ''];
    this.tabla = 'VEN_MAECLIENTE';
    this.consulta = 'ven_maecliente.*,  VEN_FNC_NOMBRE_VENDEDOR(VEN_CODIGO) AS' +
      ' VEN_NOMBRE, VEN_FNC_OBTENER_ZONACLI(CLI_ZONA) AS ZONA_NOMBRE';
    this.where = '';
    this.spin = true;
    this.busquedaSer.busquedaVenMaeCliente1(this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].CLI_CODIGO).subscribe((datos: any[]) => {
      this.arregloCons = datos;
      this.spin = false;
      this.displayDialogBusquedaFast = true;
    });
  }
  abrirVendedor() {
    this.opcion = 'BUSQUEDAVEN';
    this.types = [
      { label: 'Código', value: 'VEN_CODIGO' },
      { label: 'Nombre', value: 'VEN_NOMBRE' }
    ];
    this.busquedacampos = [this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_CODIGO, ''];
    this.tabla = 'ven_maevendedor';
    this.consulta = '*';
    if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_CODIGO === '' || this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_CODIGO === null) {
      this.where = '';
    } else if (this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_CODIGO !== '') {
      this.where = this.types[0].value + ' LIKE \'%' +
        this.cxctrnabonoService.encabezadoCarteraActivaarray[this.indicador].VEN_CODIGO + '%\'';
    }
    this.spin = true;
    this.busquedaSer.busquedaVenMaeVendedor2(this.where).subscribe((datos: any[]) => {
      this.arregloCons = datos;
      this.spin = false;
      this.displayDialogBusquedaFast = true;
    });
  }
  seleccionFacPendiente(valor) {
    if (valor.object !== undefined) {
      this.facturaPend = valor.object;
      this.codClienteFac = valor.object.CLI_CODIGO;
      this.cxctrnabonoService.obtenerClienteNom(this.codClienteFac).subscribe((res) => {
        this.nombreClienteFac = res[0].CLI_NOMBRE;
        this.nroFacCancelada = valor.object.TRNDOCUMENTO_NRODOC;
      });
    }
  }
}
